import React, { useState, useContext, useEffect, useRef } from "react";
import "./MatchUpdates.css";
import "../PlaceBet/PlaceBet.css";
// import "../../../src/App.css";
import { Modal } from "antd";
import Header from "../header/Header";
import Footer from "../Footer/Footer";
import { IoInformationCircleOutline } from "react-icons/io5";
import { FaPlayCircle } from "react-icons/fa";
import { MdLiveTv } from "react-icons/md";
import FancyMarket from "../FancyMarket/FancyMarket";
import PlaceBetSuccessfull from "../PlaceBetSuccesfull/PlaceBetSuccessfull";
import Empty from "../EmptyDiv/Empty";
import { TimeContext } from "../TimeContext/TimeContext";
import { getMatchData } from "../../redux/slice/eventData/eventDataSlice";
import { getMatchFancyData } from "../../redux/slice/fancyData/fancyDataSlice";
import { getUserBal } from "../../redux/slice/user/userSlice";
import Helper from "../../helper";
import { useSelector, useDispatch } from "react-redux";
// import { WebSocketContext } from "../../components/Context/websocket";
import axios from "axios";
import Appconfig from "../../config/config";
import { useNavigate, useParams } from "react-router-dom";
import PlaceBet from "../PlaceBet/index";
import { setData } from "../../redux/slice/betting/bettingSlice";
import ExposureHeader from "../ExposureHeader/ExposureHeader";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScrollGames from "../ScrollGames/ScrollGames";
import { useMediaQuery } from "react-responsive";
import SideMenu from "../SideMenu/SideMenu";
import OpenBets from "../OpenBets/OpenBets";
import { getAllBets, setOpenBets, } from "../../redux/slice/openBet/openBetSlice";
import {
  getOpenBets as fetchOpenBetsApi,
} from "../../services/users";
// import WebSocketEventEmitter from "../../components/Context/eventEmitter";
// import { useWebSocket } from "../../components/Context/WebSocketProvider";
import ScoreBoard from "../ScoreBoard";
import useEventOddsSocket from "../../hooks/useEventOddsSocket";
const MatchUpdates = () => {
  // ...existing state and hooks...

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userInfos = useSelector((state) => state.eventData); // Use selector to access state
  const userFancyData = useSelector((state) => state.fancyData); // Use selector to access state
  const userbalance = useSelector((state) => state.userbal); // Use selector to access state
  const balance = userbalance?.userBalance?.balance;
  const userInfo = Helper(); // get login user details
  // const { sendMessage, marketDataMsg, socketStatus } = useWebSocket();
  // const websocket = useContext(WebSocketContext);
  const { event_id } = useParams();

  const eventTeamsRef = useRef([]);
  const runnerNamesRef = useRef({});

  const [scoreBoard, setScoreBoard] = useState("");

  const detailSocketUsername = userInfo?._id || userInfo?.user_name || "guest";

  const liveMatchMarket = useEventOddsSocket(event_id, detailSocketUsername);

  const [showPlaceBetPopup, setShowPlaceBetPopup] = useState(false);
  const [betType, setBetType] = useState(null);
  const [amount, setAmount] = useState(0); // State for amount in PlaceBet popup
  const [showIframe, setShowIframe] = useState(false); // TV hidden by default
  const [showLtv, setShowLtv] = useState(false);
  const [tvVisible, setTvVisible] = useState(false); // TV toggle state
  const [tvUrl, setTvUrl] = useState();
  const [showScoreIfram, setShowScoreIfram] = useState(false);
  const [showMatchStatus, setShowMatchStatus] = useState(true); // State for Match Status visibility
  const [showOpenBets, setShowOpenBets] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false); // State for success message popup
  const [betAmount, setBetAmount] = useState(false);
  const { matchTime } = useContext(TimeContext);
  const [betSource, setBetSource] = useState(""); // State to track if it's from 'Match Odds' or 'Bookmaker'
  const [teamName, setTeamName] = useState(""); // State for team name

  // --- Place these first so they are available to all logic below ---
  const [StakeValue, setStakeValue] = useState(0);
  const [defaultStake, setDefaultStake] = useState(0);
  const [ProfitValue, setProfitValue] = useState(0);
  const [lossValue, setLossValue] = useState(0);
  // const [BetPlaceData, setBetPlaceData] = useState({
  //   event_id: "",
  //   market_id: "",
  //   is_back: "",
  //   price: "",
  //   is_fancy: "",
  //   selection_id: "",
  //   runner_name: "",
  //   PM_FANCY: false,
  // });

  const [BetPlaceData, setBetPlaceData] = useState({
    event_id: "",
    event_type: "",
    event_name: "",
    open_date: "",
    is_inplay: false,

    market_id: "",
    market_name: "",
    market_type: "",

    is_back: "",
    price: "",
    is_fancy: "",
    selection_id: "",
    runner_name: "",
    runner_status: "",

    back_1_price: null,
    lay_1_price: null,

    PM_FANCY: false,
    runners: [],
  });

  // --- The rest of your state declarations ---
  const [marketTypes, setMarketTypes] = useState([]);
  const [blockMatchOdds, setBlockMatchOdds] = useState({});
  const [blockBookmaker, setBlockBookmaker] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [scoreUrl, setScoreUrl] = useState("");
  const [eventData, setEventData] = useState([]);
  const [fancy, setFancy] = useState([]);
  const [eventType, setEventType] = useState("");
  const [eventName, setEventName] = useState("");
  const [openDate, setOpenDate] = useState("");
  const [matchOdds, setMatchOdds] = useState("");
  const [bookmaker, setBookmaker] = useState("");

  useEffect(() => {
    if (!liveMatchMarket) {
      return;
    }

    const receivedEventId = String(
      liveMatchMarket.event_id ?? liveMatchMarket.eventId ?? "",
    );

    if (receivedEventId !== String(event_id)) {
      return;
    }

    const receivedEventName = String(
      liveMatchMarket?.event_name || liveMatchMarket?.eventName || "",
    ).trim();

    const receivedOpenDate = String(
      liveMatchMarket?.open_date || liveMatchMarket?.openDate || "",
    ).trim();

    const receivedEventType = String(
      liveMatchMarket?.event_type || liveMatchMarket?.eventType || "",
    ).trim();

    if (receivedEventName) {
      setEventName(receivedEventName);
    }

    if (receivedOpenDate) {
      setOpenDate(receivedOpenDate);
    }

    if (receivedEventType === "4") {
      setEventType("Cricket");
    } else if (receivedEventType === "2") {
      setEventType("Tennis");
    } else if (receivedEventType === "1") {
      setEventType("Football");
    }

    if (liveMatchMarket?.is_inplay !== undefined) {
      setIsInplay(
        liveMatchMarket.is_inplay === true ||
        liveMatchMarket.is_inplay === "True" ||
        liveMatchMarket.is_inplay === "true",
      );
    }

    const receivedMarkets =
      liveMatchMarket.market_types || liveMatchMarket.marketTypes || [];

    if (!Array.isArray(receivedMarkets) || receivedMarkets.length === 0) {
      console.warn("EMPTY MARKET UPDATE - KEEPING OLD STATE:", receivedEventId);

      return;
    }

    const liveEventName = String(
      liveMatchMarket?.event_name ||
      liveMatchMarket?.eventName ||
      eventData?.[0]?.event_name ||
      eventData?.[0]?.eventName ||
      eventName ||
      "",
    ).trim();

    const receivedTeams = liveEventName
      .split(/\s+v(?:s)?\.?\s+/i)
      .map((team) => team.trim())
      .filter(Boolean);

    // Valid teams milne par hi cache update karo.
    // Empty subsequent update purane names clear nahi karega.
    if (receivedTeams.length >= 2) {
      eventTeamsRef.current = receivedTeams;
    }

    const eventTeams = eventTeamsRef.current;

    const normalizedMarkets = receivedMarkets.map((market) => {
      const marketName = String(
        market?.market_name || market?.marketName || "",
      ).trim();

      const marketNameLower = marketName.toLowerCase();

      const rawRunners = market?.runners || market?.marketRunners || [];

      const normalizedRunners = rawRunners.map((runner, runnerIndex) => {
        const selectionId = String(
          runner?.selection_id ?? runner?.selectionId ?? runnerIndex,
        );

        const runnerCacheKey = [
          String(event_id),
          String(market?.market_id || market?.marketId || marketName),
          selectionId,
        ].join("_");

        const receivedRunnerName = String(
          runner?.runner_name || runner?.runnerName || "",
        ).trim();

        let fallbackRunnerName = "";

        if (
          marketNameLower === "match odds" ||
          marketNameLower === "match_odds" ||
          marketNameLower === "bookmaker" ||
          marketNameLower === "toss"
        ) {
          fallbackRunnerName = eventTeams[runnerIndex] || "";
        }

        if (
          !fallbackRunnerName &&
          runnerIndex === 2 &&
          (marketNameLower === "match odds" || marketNameLower === "match_odds")
        ) {
          fallbackRunnerName = "Draw";
        }

        const cachedRunnerName = runnerNamesRef.current[runnerCacheKey] || "";

        const finalRunnerName =
          receivedRunnerName ||
          cachedRunnerName ||
          fallbackRunnerName ||
          `Runner ${runnerIndex + 1}`;

        // Valid final name ko cache karo.
        runnerNamesRef.current[runnerCacheKey] = finalRunnerName;

        const receivedExposure = Number(runner?.exposure);

        return {
          ...runner,

          selection_id: runner?.selection_id ?? runner?.selectionId,

          runner_name: finalRunnerName,

          runnerName: finalRunnerName,

          exposure: Number.isFinite(receivedExposure) ? receivedExposure : 0,
        };
      });

      return {
        ...market,

        event_id: String(
          market?.event_id || liveMatchMarket.event_id || event_id,
        ),

        market_id: market?.market_id || market?.marketId || "",

        market_name: marketName,

        runners: normalizedRunners,

        marketRunners: normalizedRunners,
      };
    });

    console.log(
      "DETAIL LIVE MARKETS:",
      receivedEventId,
      normalizedMarkets.map((market) => ({
        name: market.market_name,
        runnerCount: market.marketRunners.length,
      })),
    );

    // setMarketTypes(normalizedMarkets);
    setMarketTypes((previousMarkets) => {
      const marketsByKey = new Map();

      (Array.isArray(previousMarkets) ? previousMarkets : []).forEach(
        (market) => {
          const key = String(
            market?.market_id ||
            market?.marketId ||
            market?.market_name ||
            market?.marketName ||
            "",
          );

          if (key) {
            marketsByKey.set(key, market);
          }
        },
      );

      normalizedMarkets.forEach((market) => {
        const key = String(
          market?.market_id ||
          market?.marketId ||
          market?.market_name ||
          market?.marketName ||
          "",
        );

        if (key) {
          marketsByKey.set(key, market);
        }
      });

      return Array.from(marketsByKey.values());
    });

    const nextMatchOdds = normalizedMarkets.find((market) => {
      const marketName = String(market?.market_name || "")
        .trim()
        .toLowerCase();

      return marketName === "match odds" || marketName === "match_odds";
    });

    const nextBookmaker = normalizedMarkets.find((market) => {
      return (
        String(market?.market_name || "")
          .trim()
          .toLowerCase() === "bookmaker"
      );
    });

    // setMatchOdds(nextMatchOdds || "");
    // setBookmaker(nextBookmaker || "");

    setMatchOdds((previousMatchOdds) => {
      if (!nextMatchOdds) {
        // Empty update existing market ko
        // hide nahi karega.
        return previousMatchOdds || "";
      }

      const previousRunners =
        previousMatchOdds?.marketRunners || previousMatchOdds?.runners || [];

      const nextRunners = nextMatchOdds.marketRunners.map((runner, index) => {
        const previousRunner =
          previousRunners.find(
            (previous) =>
              String(previous.selection_id) === String(runner.selection_id),
          ) || previousRunners[index];

        const finalName =
          runner.runner_name ||
          previousRunner?.runner_name ||
          eventTeamsRef.current[index] ||
          `Runner ${index + 1}`;

        return {
          ...runner,
          runner_name: finalName,
          runnerName: finalName,
          exposure: Number(runner?.exposure) || 0,
        };
      });

      return {
        ...nextMatchOdds,
        runners: nextRunners,
        marketRunners: nextRunners,
      };
    });

    setBookmaker((previousBookmaker) => {
      if (!nextBookmaker) {
        return previousBookmaker || "";
      }

      const previousRunners =
        previousBookmaker?.marketRunners || previousBookmaker?.runners || [];

      const nextRunners = nextBookmaker.marketRunners.map((runner, index) => {
        const previousRunner =
          previousRunners.find(
            (previous) =>
              String(previous.selection_id) === String(runner.selection_id),
          ) || previousRunners[index];

        const finalName =
          runner.runner_name ||
          previousRunner?.runner_name ||
          eventTeamsRef.current[index] ||
          `Runner ${index + 1}`;

        return {
          ...runner,
          runner_name: finalName,
          runnerName: finalName,
          exposure: Number(runner?.exposure) || 0,
        };
      });

      return {
        ...nextBookmaker,
        runners: nextRunners,
        marketRunners: nextRunners,
      };
    });

    // setEventData((previous) => {
    //   const previousEvent =
    //     Array.isArray(previous) && previous.length > 0 ? previous[0] : {};

    //   return [
    //     {
    //       ...previousEvent,
    //       ...liveMatchMarket,

    //       event_id: receivedEventId,

    //       marketTypes: normalizedMarkets,

    //       market_types: normalizedMarkets,
    //     },
    //   ];
    // });

    setEventData((previous) => {
      const previousEvent =
        Array.isArray(previous) &&
          previous.length > 0 &&
          String(previous[0]?.event_id) === receivedEventId
          ? previous[0]
          : {};

      const previousMarkets =
        previousEvent?.marketTypes || previousEvent?.market_types || [];

      const marketsByKey = new Map();

      previousMarkets.forEach((market) => {
        const key = String(
          market?.market_id ||
          market?.marketId ||
          market?.market_name ||
          market?.marketName ||
          "",
        );

        if (key) {
          marketsByKey.set(key, market);
        }
      });

      normalizedMarkets.forEach((market) => {
        const key = String(
          market?.market_id ||
          market?.marketId ||
          market?.market_name ||
          market?.marketName ||
          "",
        );

        if (key) {
          marketsByKey.set(key, market);
        }
      });

      const mergedMarkets = Array.from(marketsByKey.values());

      return [
        {
          ...previousEvent,
          ...liveMatchMarket,

          event_id: receivedEventId,

          marketTypes: mergedMarkets,

          market_types: mergedMarkets,
        },
      ];
    });

    setIsEventLoading(false);
  }, [liveMatchMarket, event_id]);

  const [isEventLoading, setIsEventLoading] = useState(true);
  const [selectionIdNew, setSelectionIdNew] = useState("");
  const [is_fancy, setIs_fancy] = useState(false);
  const [fancyOddsData, setFancyOddsData] = useState([]);
  const [isReady, setIsReady] = useState(false);
  const match_odds_bet_limit = 20;
  const [generalSetting, setGeneralSetting] = useState([]);
  const [fancyExposure, setFancyExposure] = useState([]);
  const [chips, setChips] = useState([]);
  const [showBetsSlip, setShowBetsSlip] = useState(false);
  const [selection_id, setSelection_id] = useState("");
  const [marketId, setMarketId] = useState("");
  const [type, setType] = useState("back");
  const [showMenu, setShowMenu] = useState(false); // <-- Add this
  const handleToggleMenu = () => setShowMenu((prev) => !prev);
  const [showRateZeroPopup, setShowRateZeroPopup] = useState(false);
  const [activeTab, setActiveTab] = useState(null);
  const [showScore, setShowScore] = useState(false);
  const [showScoreDesktop, setShowScoreDesktop] = useState(false); // For desktop score toggle
  const [htmlId, setHtmlId] = useState("");
  const [size, setSize] = useState("");
  const [postionFancyList, setPostionFancyList] = useState([]);
  const [bookModalOpen, setBookModalOpen] = useState(false);
  const [isInplay, setIsInplay] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  // const [tvVisible, setTvVisible] = useState(false);
  // Add missing state for placing and isBetPlaced
  const [placing, setPlacing] = useState(false);
  const [isBetPlaced, setIsBetPlaced] = useState(false);

  const [showOpenBetsDropdown, setShowOpenBetsDropdown] = useState(false);
  const openbets = useSelector((state) => state.bets); // or wherever your open bets are in redux
  // Count only bets for the current match using match_id (not event_id)
  const openBetsCount =
    event_id && openbets?.bets
      ? openbets.bets.filter((bet) => bet.match_id === event_id).length
      : 0;

  const handleOpenBetsDropdown = () => setShowOpenBetsDropdown((prev) => !prev);

  // Define tossMarket for use in exposure calculation
  const tossMarket = eventData
    .flatMap((ev) => ev.marketTypes || [])
    .find((mkt) => mkt.market_name === "Toss");

  const allSuspended =
    bookmaker &&
    bookmaker.marketRunners &&
    bookmaker.marketRunners.every(
      (runner) =>
        Number(runner.back_1_price) === 0 &&
        Number(runner.back_2_price) === 0 &&
        Number(runner.back_3_price) === 0 &&
        Number(runner.lay_1_price) === 0 &&
        Number(runner.lay_2_price) === 0 &&
        Number(runner.lay_3_price) === 0,
    );

  // Open bets seperate code

  // A single state to hold all bets for the table
  const [allOpenBets, setAllOpenBets] = useState([]);

  // This function to fetch data remains unchanged
  const getOpenBetsByEvent = () => {
    if (!userInfo?._id) {
      return;
    }

    return dispatch(
      getAllBets({
        user_id: userInfo._id,
      })
    );
  };

  useEffect(() => {
    setMarketTypes([]);
    setMatchOdds("");
    setBookmaker("");
    setEventData([]);

    eventTeamsRef.current = [];
    runnerNamesRef.current = {};
  }, [event_id]);

  // Fetch bets when the component mounts
  /*
 * Admin se bet delete hone par user screen ko
 * automatically update karne ke liye polling.
 */
  useEffect(() => {
    const userId = userInfo?._id;

    if (!userId) {
      setAllOpenBets([]);
      return undefined;
    }

    let componentUnmounted = false;
    let requestInProgress = false;

    const refreshOpenBets = async () => {
      /*
       * Previous request complete hone se pehle
       * second polling request start nahi hogi.
       */
      if (requestInProgress) {
        return;
      }

      requestInProgress = true;

      try {
        const response =
          await fetchOpenBetsApi({
            user_id: userId,

            // Request ko unique rakhne ke liye.
            // Backend extra field ignore karega.
            request_time: Date.now(),
          });

        if (componentUnmounted) {
          return;
        }

        const apiBets =
          response.data?.result &&
            Array.isArray(
              response.data?.resultData
            )
            ? response.data.resultData
            : [];

        const eventBets = apiBets.filter(
          (bet) =>
            String(bet.match_id) ===
            String(event_id)
        );

        console.log(
          "DIRECT OPEN BET REFRESH:",
          {
            time:
              new Date()
                .toLocaleTimeString(),
            apiBetCount:
              apiBets.length,
            eventBetCount:
              eventBets.length,
            eventId:
              String(event_id),
            bettingIds:
              eventBets.map(
                (bet) =>
                  bet._id ||
                  bet.betting_id
              ),
          }
        );

        /*
         * Redux-based count/other components update.
         */
        dispatch(
          setOpenBets(apiBets)
        );

        /*
         * Current MatchUpdates table ko directly
         * update karo.
         */
        setAllOpenBets(eventBets);
      } catch (error) {
        console.error(
          "DIRECT OPEN BET REFRESH ERROR:",
          error.response?.data ||
          error.message ||
          error
        );
      } finally {
        requestInProgress = false;
      }
    };

    // Immediate initial request
    refreshOpenBets();

    // Admin changes maximum 2 seconds me reflect honge
    const intervalId = setInterval(
      refreshOpenBets,
      2000
    );

    const handleFocus = () => {
      refreshOpenBets();
    };

    const handleVisibilityChange = () => {
      if (
        document.visibilityState ===
        "visible"
      ) {
        refreshOpenBets();
      }
    };

    window.addEventListener(
      "focus",
      handleFocus
    );

    document.addEventListener(
      "visibilitychange",
      handleVisibilityChange
    );

    return () => {
      componentUnmounted = true;

      clearInterval(intervalId);

      window.removeEventListener(
        "focus",
        handleFocus
      );

      document.removeEventListener(
        "visibilitychange",
        handleVisibilityChange
      );
    };
  }, [
    dispatch,
    event_id,
    userInfo?._id,
  ]);

  // This effect runs when the 'openbets' data from Redux changes
  useEffect(() => {
    const reduxOpenBets =
      Array.isArray(openbets?.bets)
        ? openbets.bets
        : [];

    const filteredBets = event_id
      ? reduxOpenBets.filter(
        (item) =>
          String(item.match_id) ===
          String(event_id)
      )
      : [];

    /*
     * Empty API response par bhi [] set hoga.
     * Isse deleted bet immediately UI se remove hogi.
     */

    console.log(
      "FILTERED EVENT OPEN BETS:",
      {
        event_id,
        totalReduxBets:
          reduxOpenBets.length,
        filteredBets,
      }
    );

    setAllOpenBets(filteredBets);
  }, [openbets?.bets, event_id]);

  // Open bets seperate code ends

  // Update runners in BetPlaceData with live profit/loss when stake, selection, or price changes
  useEffect(() => {
    if (
      showPlaceBetPopup &&
      BetPlaceData &&
      BetPlaceData.market_id &&
      matchOdds &&
      matchOdds.market_id === BetPlaceData.market_id &&
      matchOdds.marketRunners
    ) {
      setBetPlaceData((prev) => ({
        ...prev,
        runners: matchOdds.marketRunners.map((r) => {
          let exposure = typeof r.exposure === "number" ? r.exposure : 0;
          if (
            BetPlaceData.selection_id &&
            StakeValue > 0 &&
            BetPlaceData.price
          ) {
            const odds = parseFloat(BetPlaceData.price);
            const stake = parseFloat(StakeValue);
            const is_back =
              BetPlaceData.is_back === 1 || BetPlaceData.is_back === true;
            if (is_back) {
              if (r.selection_id === BetPlaceData.selection_id) {
                exposure += (odds - 1) * stake;
              } else {
                exposure -= stake;
              }
            } else {
              if (r.selection_id === BetPlaceData.selection_id) {
                exposure -= (odds - 1) * stake;
              } else {
                exposure += stake;
              }
            }
          }
          return {
            event_id: String(
              r.event_id ||
              BetPlaceData.event_id ||
              event_id
            ),
            market_id: String(
              r.market_id ||
              matchOdds.market_id ||
              BetPlaceData.market_id
            ),
            selection_id: String(r.selection_id),
            runner_name: r.runner_name || "",
            status: r.status || "ACTIVE",
            exposure: Number(exposure),
          };
        }),
      }));
    }
  }, [
    StakeValue,
    BetPlaceData.selection_id,
    BetPlaceData.price,
    showPlaceBetPopup,
    matchOdds,
  ]);

  function SetPosition(stake, priceVal, market_id, is_back, selection_id) {
    priceVal = parseFloat(priceVal);
    var MarketId = market_id;
    var MId = MarketId.replace(".", "");
    var selectionId = selection_id;
    var isback = is_back;
    stake = parseFloat(stake);
    let MatchMarketTypes = "";
    var runners = document.getElementsByClassName("position_" + MId);
    var tempRunners = "";
    for (var item of runners) {
      var selecid = item.getAttribute("data-id");
      var winloss = parseFloat(item.value);
      var curr = 0;
      if (selectionId == selecid) {
        if (isback) {
          if (MatchMarketTypes == "M") {
            curr = winloss + (priceVal * stake) / 100;
          } else {
            curr = winloss + (priceVal * stake - stake);
          }
        } else {
          if (MatchMarketTypes == "M") {
            curr = winloss + -1 * parseFloat((priceVal * stake) / 100);
          } else {
            curr = winloss + -1 * parseFloat(priceVal * stake - stake);
          }
        }
      } else {
        if (isback == 1) {
          curr = winloss + -1 * stake;
        } else {
          curr = winloss + stake;
        }
      }
      var currV = curr;
      if (
        document.getElementById(selecid + "_maxprofit_loss_runner_prev_" + MId)
      ) {
        document
          .getElementById(selecid + "_maxprofit_loss_runner_prev_" + MId)
          .setAttribute("data-value", winloss.toFixed(2));
        document.getElementById(
          selecid + "_maxprofit_loss_runner_prev_" + MId,
        ).innerHTML = Math.abs(winloss.toFixed(2));
      }
      if (
        document.getElementById(
          selecid + "_maxprofit_list_loss_runner_next_" + MId,
        )
      ) {
        document
          .getElementById(selecid + "_maxprofit_list_loss_runner_next_" + MId)
          .setAttribute("data-value", currV.toFixed(2));
        document.getElementById(
          selecid + "_maxprofit_list_loss_runner_next_" + MId,
        ).innerHTML = Math.abs(currV.toFixed(2));
      }
      if (
        document.getElementById(
          selecid + "_maxprofit_Mlist_loss_runner_next_" + MId,
        )
      ) {
        document
          .getElementById(selecid + "_maxprofit_Mlist_loss_runner_next_" + MId)
          .setAttribute("data-value", currV.toFixed(2));
        document.getElementById(
          selecid + "_maxprofit_Mlist_loss_runner_next_" + MId,
        ).innerHTML = Math.abs(currV.toFixed(2));
      }
    }
  }
  const placeStakeValue = (stake) => {
    if (String(stake).startsWith("NaN")) {
      stake = String(stake).replace("NaN", "");
    }
    setStakeValue(parseFloat(stake));
    calc(stake, BetPlaceData.price, BetPlaceData.selection_id);
    SetPosition(
      stake,
      BetPlaceData.price,
      BetPlaceData.market_id,
      BetPlaceData.is_back,
      BetPlaceData.selection_id,
    );
  };

  function calc(t_stake, priceVal, selection_id) {
    var isfancy = BetPlaceData.is_fancy;
    priceVal = parseFloat(priceVal);
    t_stake = parseFloat(t_stake);
    var isback = BetPlaceData.is_back;
    if (!isfancy) {
      var pl = priceVal * t_stake - t_stake;

      pl = parseFloat(pl.toFixed(2));
      if (isback) {
        setProfitValue(pl);
        setLossValue(t_stake);
      } else {
        setLossValue(pl);
        setProfitValue(t_stake);
      }
      // SetPosition(priceVal);
    } else {
      if (document.getElementById("fancy_lay_size_" + selection_id)) {
        var NoValume = parseInt(
          document.getElementById("fancy_lay_size_" + selection_id).innerHTML,
        );
        var YesValume = parseInt(
          document.getElementById("fancy_back_size_" + selection_id).innerHTML,
        );
        var inputno = parseFloat(
          document.getElementById(`fancy_lay_price_${selection_id}`).innerHTML,
        );
        var inputyes = parseFloat(
          document.getElementById(`fancy_back_price_${selection_id}`).innerHTML,
        );
      }

      pl = parseFloat(t_stake);

      if (inputno == inputyes) {
        if (isback) {
          setLossValue(pl.toFixed(2));
          setProfitValue(((YesValume * pl) / 100).toFixed(2));
        } else {
          setLossValue(((NoValume * pl) / 100).toFixed(2));
          setProfitValue(pl.toFixed(2));
        }
      } else {
        setLossValue(pl.toFixed(2));
        setProfitValue(pl.toFixed(2));
      }
    }
  }

  useEffect(() => {
    marketTypes?.map((market) => {
      if (market?.market_name == "Match Odds") {
        getBlockMatchOdds(market.event_id, market.market_id);
      } else if (market?.market_name == "Bookmaker") {
        getBlockBookmaker(market.event_id, market.market_id);
      }
    });
  }, [marketTypes]);

  const getFancyExposure = (selectionId) => {
    let findItem = fancyExposure.find(
      (item) => item.selection_id == selectionId,
    );

    if (findItem) {
      return findItem?.min;
    } else {
      return false;
    }
  };

  const checkFancyExposureExists = (selectionId) => {
    let findItem = fancyExposure.find(
      (item) => item.selection_id == selectionId,
    );

    if (findItem) {
      return true;
    } else {
      return false;
    }
  };

  function getBlockMatchOdds(event_id, market_id) {
    var data = JSON.stringify({
      user_id: Appconfig.superAdmin,
      event_id: event_id,
      market_id: market_id,
    });
    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}blockMarket/getBlockMatchOdds`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        try {
          // alert("Hello");
          // console.log('response.data', response.data)
          if (response.data.result) {
            setBlockMatchOdds(response.data.resultData[0]);
          }
        } catch (e) {
          // postErrorToslack(e.message);
        }
      })
      .catch(function (error) {
        console.log(error);
        // postErrorToslack(error.message);
      });
  }

  function getBlockBookmaker(event_id, market_id) {
    var data = JSON.stringify({
      user_id: Appconfig.superAdmin,
      event_id: event_id,
      market_id: market_id,
    });
    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}blockMarket/getBlockMatchOdds`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        try {
          // alert("Hello");
          // console.log('response.data', response.data)
          if (response.data.result) {
            setBlockBookmaker(response.data.resultData[0]);
          }
        } catch (e) {
          // postErrorToslack(e.message);
        }
      })
      .catch(function (error) {
        console.log(error);
        // postErrorToslack(error.message);
      });
  }

  useEffect(() => {
    if (userInfo) {
      dispatch(
        getUserBal({
          user_id: userInfo?._id,
        }),
      );
    }
  }, [userInfo?._id]);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 300);
  }, []);

  useEffect(() => {
    getScoreUrl(event_id);
  }, [event_id]);

  function getFancyPosition(selectionId) {
    if (userInfo) {
      var data = JSON.stringify({
        user_id: userInfo._id,
        event_id: event_id,
        fancy_id: selectionId,
      });
      var config = {
        method: "post",
        url: `${Appconfig.apiUrl}betting/getFancyPosition`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then(function (response) {
          try {
            setPostionFancyList(response.data.resultData);
            setBookModalOpen(true);
          } catch (e) {
            console.log(e);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      navigate("/login");
    }
  }

  function getScoreUrl_10_September_2025(eventId) {
    var data = JSON.stringify({
      event_id: eventId,
    });
    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}eventsDashboard/getScore`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        try {
          // alert("Hello");
          // setScoreUrl(response.data.resultData.animation);
        } catch (e) {
          // postErrorToslack(e.message);
        }
      })
      .catch(function (error) {
        console.log(error);
        // postErrorToslack(error.message);
      });
    // }
  }

  function getScoreUrl(eventId) {
    var data = JSON.stringify({
      event_id: eventId,
    });
    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}eventsDashboard/getScore`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        try {
          if (response.data.resultData.animation) {
            setScoreUrl(response.data.resultData.animation);
          }
          if (response.data.resultData.scoreboard) {
            setScoreBoard(response.data.resultData.scoreboard);
          }
        } catch (e) {
          // postErrorToslack(e.message);
        }
      })
      .catch(function (error) {
        console.log(error);
        // postErrorToslack(error.message);
      });
    // }
  }

  useEffect(() => {
    var data;
    if (userInfo) {
      data = {
        user_id: userInfo._id,
        event_id: event_id,
      };
    } else {
      data = {
        event_id: event_id,
      };
    }
    dispatch(getMatchData(data));
  }, []);
  console.log("event_id", event_id);

  useEffect(() => {
    if (userInfos.eventData[event_id]) {
      // setEventData(userInfos.eventData[event_id]);
      // setMarketTypes(userInfos.eventData[event_id][0]?.marketTypes);
      // setFancy(userInfos.eventData[event_id][0]?.fancy);

      const apiEventData = userInfos.eventData[event_id];

      const apiEvent = apiEventData?.[0];

      const apiMarketTypes = apiEvent?.marketTypes || [];

      // setEventData(apiEventData);

      setEventData((previousEventData) => {
        const previousEvent =
          Array.isArray(previousEventData) && previousEventData.length > 0
            ? previousEventData[0]
            : null;

        const isSameEvent =
          String(previousEvent?.event_id || "") === String(event_id);

        const previousMarkets = isSameEvent
          ? previousEvent?.marketTypes || previousEvent?.market_types || []
          : [];

        // Existing live markets ko
        // API empty data overwrite nahi karegi.
        if (previousMarkets.length > 0) {
          return [
            {
              ...previousEvent,
              ...apiEvent,

              event_id: String(event_id),

              marketTypes: previousMarkets,

              market_types: previousMarkets,
            },
          ];
        }

        return apiEvent
          ? [
            {
              ...apiEvent,

              event_id: String(event_id),

              marketTypes: [],
              market_types: [],
            },
          ]
          : [];
      });

      // API marketTypes empty ho toh
      // WebSocket state clear nahi karni.
      // if (apiMarketTypes.length > 0) {
      //   setMarketTypes(apiMarketTypes);
      // }

      setFancy(apiEvent?.fancy || []);
      // setScoreUrl(`https://trovetown.co/score/sportRadar/?eventId=${userInfos.eventData[event_id][0]?.betfair_event_id}`)

      // https://trovetown.co/score/sportRadar/?eventId=34559339
      console.log(userInfos.eventData[event_id][0]?.betfair_event_id, "Hello");
      setTvUrl(userInfos.eventData[event_id][0]?.tv_link);
      let eventType = userInfos.eventData[event_id][0];
      if (eventType?.event_type == 4) {
        setEventType("Cricket");
      } else if (eventType?.event_type == 2) {
        setEventType("Tennis");
      } else {
        setEventType("Soccer");
      }
      // setEventName(eventType?.event_name);
      // setOpenDate(eventType?.open_date);

      if (eventType?.event_name) {
        setEventName(eventType.event_name);
      }

      if (eventType?.open_date) {
        setOpenDate(eventType.open_date);
      }
      setIsInplay(eventType?.is_inplay == "True" ? true : false);

      // userInfos.eventData[event_id][0]?.marketTypes?.map((type) => {
      //   if (type.market_name == "Bookmaker") {
      //     setBookmaker(type);
      //   }
      //   if (type.market_name == "Match Odds") {
      //     setMatchOdds(type);
      //   }
      // });

      // const apiMarkets = userInfos.eventData[event_id][0]?.marketTypes || [];

      // const normalizedApiMarkets = Array.isArray(apiMarketTypes)
      //   ? apiMarketTypes
      //       .map((market) => {
      //         const runners = market?.marketRunners || market?.runners || [];

      //         return {
      //           ...market,

      //           market_name: market?.market_name || market?.marketName || "",

      //           runners,
      //           marketRunners: runners,
      //         };
      //       })
      //       // Empty API markets live WebSocket
      //       // data overwrite nahi karenge.
      //       .filter((market) => market.marketRunners.length > 0)
      //   : [];

      // if (normalizedApiMarkets.length > 0) {
      //   setMarketTypes(normalizedApiMarkets);

      //   const apiMatchOdds = normalizedApiMarkets.find((market) => {
      //     const marketName = String(market?.market_name || "")
      //       .trim()
      //       .toLowerCase();

      //     return marketName === "match odds" || marketName === "match_odds";
      //   });

      //   const apiBookmaker = normalizedApiMarkets.find(
      //     (market) =>
      //       String(market?.market_name || "")
      //         .trim()
      //         .toLowerCase() === "bookmaker",
      //   );

      //   // Market mila tabhi state update hogi.
      //   // Missing market existing live state
      //   // ko clear nahi karega.
      //   if (apiMatchOdds) {
      //     setMatchOdds(apiMatchOdds);
      //   }

      //   if (apiBookmaker) {
      //     setBookmaker(apiBookmaker);
      //   }
      // }

      setIsEventLoading(false);
    }
  }, [userInfos.eventData[event_id]]);

  useEffect(() => {
    dispatch(
      getMatchFancyData({
        event_id: event_id,
        user_id: userInfo ? userInfo._id : "",
      }),
    );
  }, []);

  useEffect(() => {
    if (userFancyData.fancyData[event_id]) {
      fancyHtml(userFancyData?.fancyData[event_id]);
    }
  }, [userFancyData.fancyData[event_id]]);

  async function fancyHtml(fancys) {
    var superiors = ["270", "259", "185", "177", "30"];
    var matchId = event_id;
    if (matchId) {
      if (fancys) {
        let check_new_fields_added = false;

        const result = fancys.find((item) => {
          console.log(
            `Checking item with selection_id: ${item.selection_id
            }, game_status: ${item.game_status}, selectionIdNew: ${String(
              selectionIdNew,
            )}`,
          );

          const gameStatusMatch =
            item.game_status === "SUSPENDED" ||
            item.game_status === "Ball Running";
          const selectionIdMatch =
            String(item.selection_id) === String(selectionIdNew);

          console.log(
            `gameStatusMatch: ${gameStatusMatch}, selectionIdMatch: ${selectionIdMatch}`,
          );

          return gameStatusMatch && selectionIdMatch;
        });

        // const result = fancys.find(item => item.game_status === "" && item.selection_id === selection_id);
        if (result) {
          setIs_fancy(false);
        }

        setFancyOddsData(fancys);
      }
    }
  }

  // useEffect(() => {
  //   if (websocket) {
  //     websocket.onopen = () => {
  //       console.log("Websocket is open ", new Date());
  //       setIsReady(true);
  //     };

  //     if (websocket.readyState) {
  //       console.log("WESOCKET JOIN REQUEST SENT", {
  //         action: "JOIN",
  //         data: {
  //           username: "suthard444",
  //           event_id: event_id,
  //         },
  //       });

  //       websocket.send(
  //         JSON.stringify({
  //           action: "JOIN",
  //           data: {
  //             username: "suthard444",
  //             event_id: event_id,
  //           },
  //         })
  //       );
  //     }
  //   }
  // }, [websocket, event_id, isReady]);

  // useEffect(() => {
  //   if (socketStatus) {
  //     sendMessage({
  //       action: "JOIN",
  //       data: {
  //         username: "suthard444",
  //         event_id: event_id,
  //       },
  //     });
  //   }
  // }, [socketStatus]);

  // useEffect(() => {
  //   const saveLiveMarkets = (message) => {
  //     if (message?.action !== "MARKET_UPDATE" || !message?.data) {
  //       return;
  //     }

  //     const liveEvent = message.data;

  //     const receivedEventId = String(
  //       liveEvent.event_id ?? liveEvent.eventId ?? "",
  //     );

  //     // Dusre event ka update accept nahi karna.
  //     if (receivedEventId !== String(event_id)) {
  //       return;
  //     }

  //     const receivedMarketTypes =
  //       liveEvent.market_types || liveEvent.marketTypes || [];

  //     if (
  //       !Array.isArray(receivedMarketTypes) ||
  //       receivedMarketTypes.length === 0
  //     ) {
  //       console.log("NO LIVE MARKETS:", receivedEventId);

  //       return;
  //     }

  //     const normalizedMarketTypes = receivedMarketTypes.map((market) => {
  //       const runners = market?.runners || market?.marketRunners || [];

  //       return {
  //         ...market,

  //         event_id: String(market?.event_id || liveEvent.event_id || event_id),

  //         market_id: market?.market_id || market?.marketId || "",

  //         market_name: market?.market_name || market?.marketName || "",

  //         runners,
  //         marketRunners: runners,
  //       };
  //     });

  //     console.log(
  //       "MATCH PAGE LIVE MARKETS:",
  //       receivedEventId,
  //       normalizedMarketTypes.map((market) => ({
  //         name: market.market_name,
  //         runners: market.marketRunners.length,
  //       })),
  //     );

  //     // All markets: Match Odds,
  //     // Bookmaker, Toss etc.
  //     setMarketTypes(normalizedMarketTypes);

  //     const liveMatchOdds = normalizedMarketTypes.find((market) => {
  //       const name = String(market?.market_name || "")
  //         .trim()
  //         .toLowerCase();

  //       return name === "match odds" || name === "match_odds";
  //     });

  //     const liveBookmaker = normalizedMarketTypes.find((market) => {
  //       const name = String(market?.market_name || "")
  //         .trim()
  //         .toLowerCase();

  //       return name === "bookmaker";
  //     });

  //     setMatchOdds(liveMatchOdds || "");

  //     setBookmaker(liveBookmaker || "");

  //     // Existing code ke liye eventData
  //     // mein bhi live marketTypes save karo.
  //     setEventData((previousEventData) => {
  //       const existingEvent =
  //         Array.isArray(previousEventData) && previousEventData.length > 0
  //           ? previousEventData[0]
  //           : {};

  //       return [
  //         {
  //           ...existingEvent,
  //           ...liveEvent,

  //           event_id: receivedEventId,

  //           marketTypes: normalizedMarketTypes,

  //           market_types: normalizedMarketTypes,
  //         },
  //       ];
  //     });

  //     setIsEventLoading(false);
  //   };

  //   WebSocketEventEmitter.on("message", saveLiveMarkets);

  //   return () => {
  //     WebSocketEventEmitter.off("message", saveLiveMarkets);
  //   };
  // }, [event_id]);

  // useEffect(() => {
  //   // if (websocket) {
  //   //   websocket.onmessage = (evt) => {
  //   //     const data = JSON.parse(evt.data);
  //   //     if (data.action == "MARKET_UPDATE") {
  //   //       // console.log("MARKET SOCKET RESPONDING");
  //   //       let market = data.data;
  //   //       console.log("market", market);
  //   //       if (market) {
  //   //         if (market.market_types.length > 0) {
  //   //           market.market_types.map((market_type, index) => {
  //   //             market_type.hasOwnProperty("runners") &&
  //   //               market_type.runners.map((runner, index) => {
  //   //                 // if (market_type.status == 'OPEN') {
  //   //                 // } else {
  //   //                 // }

  //   //                 // if (runner.market_id == '4.1680554980-BM') {
  //   //                 // }
  //   //                 if (
  //   //                   checkHighestMarketPrice(runner, market_type.market_name)
  //   //                 ) {
  //   //                   if (
  //   //                     runner.status == "SUSPENDED" ||
  //   //                     market_type.status == "CLOSED"
  //   //                   ) {
  //   //                     const selecid = runner.selection_id;
  //   //                     const suspendedDiv = document.querySelector(
  //   //                       `.suspended_${runner.market_id.replace(
  //   //                         ".",
  //   //                         ""
  //   //                       )}_${selecid}`
  //   //                     );
  //   //                     const suspendedMDiv = document.querySelector(
  //   //                       `.Msuspended_${runner.market_id.replace(
  //   //                         ".",
  //   //                         ""
  //   //                       )}_${selecid}`
  //   //                     );
  //   //                     const suspendedMSOCCERDiv = document.querySelector(
  //   //                       `.m-soccer-suspended_${runner.market_id.replace(
  //   //                         ".",
  //   //                         ""
  //   //                       )}_${selecid}`
  //   //                     );
  //   //                     const suspendedSOCCERDiv = document.querySelector(
  //   //                       `.soccer-suspended_${runner.market_id.replace(
  //   //                         ".",
  //   //                         ""
  //   //                       )}_${selecid}`
  //   //                     );
  //   //                     if (suspendedDiv) {
  //   //                       suspendedDiv &&
  //   //                         suspendedDiv.classList.remove("hidden");
  //   //                     }
  //   //                     if (suspendedMDiv) {
  //   //                       suspendedMDiv &&
  //   //                         suspendedMDiv.classList.remove("hidden");
  //   //                     }
  //   //                     if (suspendedMSOCCERDiv) {
  //   //                       suspendedMSOCCERDiv &&
  //   //                         suspendedMSOCCERDiv.classList.remove("hidden");
  //   //                     }
  //   //                     if (suspendedSOCCERDiv) {
  //   //                       suspendedSOCCERDiv &&
  //   //                         suspendedSOCCERDiv.classList.remove("hidden");
  //   //                     }
  //   //                   } else {
  //   //                     const selecid = runner.selection_id;
  //   //                     const suspendedDiv = document.querySelector(
  //   //                       `.suspended_${runner.market_id.replace(
  //   //                         ".",
  //   //                         ""
  //   //                       )}_${selecid}`
  //   //                     );
  //   //                     const suspendedMDiv = document.querySelector(
  //   //                       `.Msuspended_${runner.market_id.replace(
  //   //                         ".",
  //   //                         ""
  //   //                       )}_${selecid}`
  //   //                     );
  //   //                     const suspendedMSOCCERDiv = document.querySelector(
  //   //                       `.m-soccer-suspended_${runner.market_id.replace(
  //   //                         ".",
  //   //                         ""
  //   //                       )}_${selecid}`
  //   //                     );
  //   //                     const suspendedSOCCERDiv = document.querySelector(
  //   //                       `.soccer-suspended_${runner.market_id.replace(
  //   //                         ".",
  //   //                         ""
  //   //                       )}_${selecid}`
  //   //                     );
  //   //                     if (suspendedDiv) {
  //   //                       suspendedDiv && suspendedDiv.classList.add("hidden");
  //   //                     }
  //   //                     if (suspendedMDiv) {
  //   //                       suspendedMDiv &&
  //   //                         suspendedMDiv.classList.add("hidden");
  //   //                     }
  //   //                     if (suspendedMSOCCERDiv) {
  //   //                       suspendedMSOCCERDiv &&
  //   //                         suspendedMSOCCERDiv.classList.add("hidden");
  //   //                     }
  //   //                     if (suspendedSOCCERDiv) {
  //   //                       suspendedSOCCERDiv &&
  //   //                         suspendedSOCCERDiv.classList.add("hidden");
  //   //                     }
  //   //                   }
  //   //                   const boxes = document.querySelectorAll(
  //   //                     ".market_runners_" +
  //   //                     runner.market_id.replace(".", "") +
  //   //                     "_" +
  //   //                     runner.selection_id
  //   //                   );
  //   //                   for (const box of boxes) {
  //   //                     box.classList.add("disabled");
  //   //                   }
  //   //                 } else {
  //   //                   const boxes = document.querySelectorAll(
  //   //                     ".market_runners_" +
  //   //                     runner.market_id.toString().replace(".", "") +
  //   //                     "_" +
  //   //                     runner.selection_id
  //   //                   );
  //   //                   for (const box of boxes) {
  //   //                     box.classList.remove("disabled");
  //   //                   }
  //   //                 }

  //   //                 var match_odd_row = document.getElementsByClassName(
  //   //                   "table_row_" +
  //   //                   runner.market_id.toString().replace(".", "") +
  //   //                   "_" +
  //   //                   runner.selection_id
  //   //                 )[0];

  //   //                 if (
  //   //                   runner.status == "SUSPENDED" ||
  //   //                   runner.status == "CLOSE" ||
  //   //                   runner.status == "CLOSED"
  //   //                 ) {
  //   //                   if (
  //   //                     document.getElementById(
  //   //                       "availableToLay1_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     )
  //   //                   ) {
  //   //                     if (match_odd_row) {
  //   //                       match_odd_row.setAttribute(
  //   //                         "data-title",
  //   //                         runner.status
  //   //                       );
  //   //                       match_odd_row.parentElement.classList.add(
  //   //                         "suspended"
  //   //                       );
  //   //                     }
  //   //                     if (
  //   //                       parseFloat(
  //   //                         document.getElementById(
  //   //                           "availableToBack1_price_" +
  //   //                           runner.market_id.replace(".", "") +
  //   //                           "_" +
  //   //                           runner.selection_id
  //   //                         ).innerHTML
  //   //                       ) != parseFloat(runner.back_1_price)
  //   //                     ) {
  //   //                     } else {
  //   //                     }
  //   //                     if (
  //   //                       parseFloat(
  //   //                         document.getElementById(
  //   //                           "availableToLay1_price_" +
  //   //                           runner.market_id.replace(".", "") +
  //   //                           "_" +
  //   //                           runner.selection_id
  //   //                         ).innerHTML
  //   //                       ) != parseFloat(runner.lay_1_price)
  //   //                     ) {
  //   //                     } else {
  //   //                     }
  //   //                   }
  //   //                   // mobile{
  //   //                   if (
  //   //                     document.getElementById(
  //   //                       "MavailableToLay1_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     )
  //   //                   ) {
  //   //                     if (match_odd_row) {
  //   //                       match_odd_row.setAttribute(
  //   //                         "data-title",
  //   //                         runner.status
  //   //                       );
  //   //                       match_odd_row.parentElement.classList.add(
  //   //                         "suspended"
  //   //                       );
  //   //                     }
  //   //                     if (
  //   //                       parseFloat(
  //   //                         document.getElementById(
  //   //                           "MavailableToBack1_price_" +
  //   //                           runner.market_id.replace(".", "") +
  //   //                           "_" +
  //   //                           runner.selection_id
  //   //                         ).innerHTML
  //   //                       ) != parseFloat(runner.back_1_price)
  //   //                     ) {
  //   //                     } else {
  //   //                     }
  //   //                     if (
  //   //                       parseFloat(
  //   //                         document.getElementById(
  //   //                           "MavailableToLay1_price_" +
  //   //                           runner.market_id.replace(".", "") +
  //   //                           "_" +
  //   //                           runner.selection_id
  //   //                         ).innerHTML
  //   //                       ) != parseFloat(runner.lay_1_price)
  //   //                     ) {
  //   //                     } else {
  //   //                     }
  //   //                   }
  //   //                   // }
  //   //                   if (
  //   //                     document.getElementById(
  //   //                       "availableToLay2_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     )
  //   //                   ) {
  //   //                     if (match_odd_row) {
  //   //                       match_odd_row.setAttribute(
  //   //                         "data-title",
  //   //                         runner.status
  //   //                       );
  //   //                       match_odd_row.parentElement.classList.add(
  //   //                         "suspended"
  //   //                       );
  //   //                     }
  //   //                     if (
  //   //                       parseFloat(
  //   //                         document.getElementById(
  //   //                           "availableToBack2_price_" +
  //   //                           runner.market_id.replace(".", "") +
  //   //                           "_" +
  //   //                           runner.selection_id
  //   //                         ).innerHTML
  //   //                       ) != parseFloat(runner.back_2_price)
  //   //                     ) {
  //   //                     } else {
  //   //                     }
  //   //                     if (
  //   //                       parseFloat(
  //   //                         document.getElementById(
  //   //                           "availableToLay2_price_" +
  //   //                           runner.market_id.replace(".", "") +
  //   //                           "_" +
  //   //                           runner.selection_id
  //   //                         ).innerHTML
  //   //                       ) != parseFloat(runner.lay_2_price)
  //   //                     ) {
  //   //                     } else {
  //   //                     }
  //   //                   }
  //   //                   if (
  //   //                     document.getElementById(
  //   //                       "availableToLay3_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     )
  //   //                   ) {
  //   //                     if (match_odd_row) {
  //   //                       match_odd_row.setAttribute(
  //   //                         "data-title",
  //   //                         runner.status
  //   //                       );
  //   //                       match_odd_row.parentElement.classList.add(
  //   //                         "suspended"
  //   //                       );
  //   //                     }
  //   //                     if (
  //   //                       parseFloat(
  //   //                         document.getElementById(
  //   //                           "availableToBack3_price_" +
  //   //                           runner.market_id.replace(".", "") +
  //   //                           "_" +
  //   //                           runner.selection_id
  //   //                         ).innerHTML
  //   //                       ) != parseFloat(runner.back_3_price)
  //   //                     ) {
  //   //                     } else {
  //   //                     }
  //   //                     if (
  //   //                       parseFloat(
  //   //                         document.getElementById(
  //   //                           "availableToLay3_price_" +
  //   //                           runner.market_id.replace(".", "") +
  //   //                           "_" +
  //   //                           runner.selection_id
  //   //                         ).innerHTML
  //   //                       ) != parseFloat(runner.lay_3_price)
  //   //                     ) {
  //   //                     } else {
  //   //                     }
  //   //                   }
  //   //                 } else {
  //   //                   if (
  //   //                     document.getElementById(
  //   //                       "availableToLay1_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     )
  //   //                   ) {
  //   //                     if (match_odd_row) {
  //   //                       match_odd_row.parentElement.setAttribute(
  //   //                         "data-title",
  //   //                         ""
  //   //                       );
  //   //                       match_odd_row.parentElement.classList.remove(
  //   //                         "suspended"
  //   //                       );
  //   //                     }
  //   //                     if (
  //   //                       parseFloat(
  //   //                         document.getElementById(
  //   //                           "availableToBack1_price_" +
  //   //                           runner.market_id.replace(".", "") +
  //   //                           "_" +
  //   //                           runner.selection_id
  //   //                         ).innerHTML
  //   //                       ) != parseFloat(runner.back_1_price)
  //   //                     ) {
  //   //                       document.getElementById(
  //   //                         "availableToBack1_price_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       ).innerHTML = parseFloat(runner.back_1_price);
  //   //                     } else {
  //   //                       document.getElementById(
  //   //                         "availableToBack1_price_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       ).innerHTML = parseFloat(runner.back_1_price);
  //   //                     }
  //   //                     if (
  //   //                       parseFloat(
  //   //                         document.getElementById(
  //   //                           "availableToLay1_price_" +
  //   //                           runner.market_id.replace(".", "") +
  //   //                           "_" +
  //   //                           runner.selection_id
  //   //                         ).innerHTML
  //   //                       ) != parseFloat(runner.lay_1_price)
  //   //                     ) {
  //   //                       document.getElementById(
  //   //                         "availableToLay1_price_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       ).innerHTML = parseFloat(runner.lay_1_price);
  //   //                     } else {
  //   //                       document.getElementById(
  //   //                         "availableToLay1_price_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       ).innerHTML = parseFloat(runner.lay_1_price);
  //   //                     }
  //   //                   }
  //   //                   // mobile{
  //   //                   if (
  //   //                     document.getElementById(
  //   //                       "MavailableToLay1_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     )
  //   //                   ) {
  //   //                     if (match_odd_row) {
  //   //                       match_odd_row.parentElement.setAttribute(
  //   //                         "data-title",
  //   //                         ""
  //   //                       );
  //   //                       match_odd_row.parentElement.classList.remove(
  //   //                         "suspended"
  //   //                       );
  //   //                     }
  //   //                     if (
  //   //                       parseFloat(
  //   //                         document.getElementById(
  //   //                           "MavailableToBack1_price_" +
  //   //                           runner.market_id.replace(".", "") +
  //   //                           "_" +
  //   //                           runner.selection_id
  //   //                         ).innerHTML
  //   //                       ) != parseFloat(runner.back_1_price)
  //   //                     ) {
  //   //                       document.getElementById(
  //   //                         "MavailableToBack1_price_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       ).innerHTML = parseFloat(runner.back_1_price);
  //   //                     } else {
  //   //                       document.getElementById(
  //   //                         "MavailableToBack1_price_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       ).innerHTML = parseFloat(runner.back_1_price);
  //   //                     }
  //   //                     if (
  //   //                       parseFloat(
  //   //                         document.getElementById(
  //   //                           "MavailableToLay1_price_" +
  //   //                           runner.market_id.replace(".", "") +
  //   //                           "_" +
  //   //                           runner.selection_id
  //   //                         ).innerHTML
  //   //                       ) != parseFloat(runner.lay_1_price)
  //   //                     ) {
  //   //                       document.getElementById(
  //   //                         "MavailableToLay1_price_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       ).innerHTML = parseFloat(runner.lay_1_price);
  //   //                     } else {
  //   //                       document.getElementById(
  //   //                         "MavailableToLay1_price_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       ).innerHTML = parseFloat(runner.lay_1_price);
  //   //                     }
  //   //                   }
  //   //                   // }
  //   //                   if (
  //   //                     document.getElementById(
  //   //                       "availableToLay2_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     )
  //   //                   ) {
  //   //                     if (match_odd_row) {
  //   //                       match_odd_row.parentElement.setAttribute(
  //   //                         "data-title",
  //   //                         ""
  //   //                       );
  //   //                       match_odd_row.parentElement.classList.remove(
  //   //                         "suspended"
  //   //                       );
  //   //                     }
  //   //                     if (
  //   //                       parseFloat(
  //   //                         document.getElementById(
  //   //                           "availableToBack2_price_" +
  //   //                           runner.market_id.replace(".", "") +
  //   //                           "_" +
  //   //                           runner.selection_id
  //   //                         ).innerHTML
  //   //                       ) != parseFloat(runner.back_2_price)
  //   //                     ) {
  //   //                       document.getElementById(
  //   //                         "availableToBack2_price_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       ).innerHTML = parseFloat(runner.back_2_price);
  //   //                     } else {
  //   //                       document.getElementById(
  //   //                         "availableToBack2_price_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       ).innerHTML = parseFloat(runner.back_2_price);
  //   //                     }
  //   //                     if (
  //   //                       parseFloat(
  //   //                         document.getElementById(
  //   //                           "availableToLay2_price_" +
  //   //                           runner.market_id.replace(".", "") +
  //   //                           "_" +
  //   //                           runner.selection_id
  //   //                         ).innerHTML
  //   //                       ) != parseFloat(runner.lay_2_price)
  //   //                     ) {
  //   //                       document.getElementById(
  //   //                         "availableToLay2_price_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       ).innerHTML = parseFloat(runner.lay_2_price);
  //   //                     } else {
  //   //                       document.getElementById(
  //   //                         "availableToLay2_price_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       ).innerHTML = parseFloat(runner.lay_2_price);
  //   //                     }
  //   //                   }
  //   //                   if (
  //   //                     document.getElementById(
  //   //                       "availableToLay3_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     )
  //   //                   ) {
  //   //                     if (match_odd_row) {
  //   //                       match_odd_row.parentElement.setAttribute(
  //   //                         "data-title",
  //   //                         ""
  //   //                       );
  //   //                       match_odd_row.parentElement.classList.remove(
  //   //                         "suspended"
  //   //                       );
  //   //                     }
  //   //                     if (
  //   //                       parseFloat(
  //   //                         document.getElementById(
  //   //                           "availableToBack3_price_" +
  //   //                           runner.market_id.replace(".", "") +
  //   //                           "_" +
  //   //                           runner.selection_id
  //   //                         ).innerHTML
  //   //                       ) != parseFloat(runner.back_3_price)
  //   //                     ) {
  //   //                       document.getElementById(
  //   //                         "availableToBack3_price_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       ).innerHTML = parseFloat(runner.back_3_price);
  //   //                     } else {
  //   //                       document.getElementById(
  //   //                         "availableToBack3_price_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       ).innerHTML = parseFloat(runner.back_3_price);
  //   //                     }
  //   //                     if (
  //   //                       parseFloat(
  //   //                         document.getElementById(
  //   //                           "availableToLay3_price_" +
  //   //                           runner.market_id.replace(".", "") +
  //   //                           "_" +
  //   //                           runner.selection_id
  //   //                         ).innerHTML
  //   //                       ) != parseFloat(runner.lay_3_price)
  //   //                     ) {
  //   //                       document.getElementById(
  //   //                         "availableToLay3_price_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       ).innerHTML = parseFloat(runner.lay_3_price);
  //   //                     } else {
  //   //                       document.getElementById(
  //   //                         "availableToLay3_price_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       ).innerHTML = parseFloat(runner.lay_3_price);
  //   //                     }
  //   //                   }
  //   //                 }
  //   //                 /************************Size */

  //   //                 if (
  //   //                   document.getElementById(
  //   //                     "availableToBack1_size_" +
  //   //                     runner.market_id.replace(".", "") +
  //   //                     "_" +
  //   //                     runner.selection_id
  //   //                   )
  //   //                 ) {
  //   //                   document
  //   //                     .getElementById(
  //   //                       "availableToBack1_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     )
  //   //                     .parentElement.classList.remove("spark");
  //   //                   document
  //   //                     .getElementById(
  //   //                       "availableToLay1_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     )
  //   //                     .parentElement.classList.remove("spark");
  //   //                   if (
  //   //                     parseFloat(
  //   //                       document.getElementById(
  //   //                         "availableToBack1_size_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       ).innerHTML
  //   //                     ) != parseFloat(runner.back_1_size)
  //   //                   ) {
  //   //                     document
  //   //                       .getElementById(
  //   //                         "availableToBack1_size_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       )
  //   //                       .parentElement.classList.add("spark");
  //   //                     setTimeout(function () {
  //   //                       if (
  //   //                         document.getElementById(
  //   //                           "availableToBack1_size_" +
  //   //                           runner.market_id.replace(".", "") +
  //   //                           "_" +
  //   //                           runner.selection_id
  //   //                         )
  //   //                       )
  //   //                         document
  //   //                           .getElementById(
  //   //                             "availableToBack1_size_" +
  //   //                             runner.market_id.replace(".", "") +
  //   //                             "_" +
  //   //                             runner.selection_id
  //   //                           )
  //   //                           .parentElement.classList.remove("spark");
  //   //                     }, 700);
  //   //                     document.getElementById(
  //   //                       "availableToBack1_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     ).innerHTML = parseFloat(runner.back_1_size);
  //   //                   } else {
  //   //                     document.getElementById(
  //   //                       "availableToBack1_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     ).innerHTML = parseFloat(runner.back_1_size);
  //   //                   }
  //   //                   if (
  //   //                     parseFloat(
  //   //                       document.getElementById(
  //   //                         "availableToLay1_size_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       ).innerHTML
  //   //                     ) != parseFloat(runner.lay_1_size)
  //   //                   ) {
  //   //                     document
  //   //                       .getElementById(
  //   //                         "availableToLay1_size_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       )
  //   //                       .parentElement.classList.add("spark");
  //   //                     document.getElementById(
  //   //                       "availableToLay1_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     ).innerHTML = parseFloat(runner.lay_1_size);
  //   //                     setTimeout(function () {
  //   //                       if (
  //   //                         document.getElementById(
  //   //                           "availableToBack1_size_" +
  //   //                           runner.market_id.replace(".", "") +
  //   //                           "_" +
  //   //                           runner.selection_id
  //   //                         )
  //   //                       )
  //   //                         document
  //   //                           .getElementById(
  //   //                             "availableToLay1_size_" +
  //   //                             runner.market_id.replace(".", "") +
  //   //                             "_" +
  //   //                             runner.selection_id
  //   //                           )
  //   //                           .parentElement.classList.remove("spark");
  //   //                     }, 700);
  //   //                   } else {
  //   //                     document.getElementById(
  //   //                       "availableToLay1_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     ).innerHTML = parseFloat(runner.lay_1_size);
  //   //                   }
  //   //                 }
  //   //                 // mobile
  //   //                 if (
  //   //                   document.getElementById(
  //   //                     "MavailableToBack1_size_" +
  //   //                     runner.market_id.replace(".", "") +
  //   //                     "_" +
  //   //                     runner.selection_id
  //   //                   )
  //   //                 ) {
  //   //                   document
  //   //                     .getElementById(
  //   //                       "MavailableToBack1_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     )
  //   //                     .parentElement.classList.remove("spark");
  //   //                   document
  //   //                     .getElementById(
  //   //                       "MavailableToLay1_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     )
  //   //                     .parentElement.classList.remove("spark");
  //   //                   if (
  //   //                     parseFloat(
  //   //                       document.getElementById(
  //   //                         "MavailableToBack1_size_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       ).innerHTML
  //   //                     ) != parseFloat(runner.back_1_size)
  //   //                   ) {
  //   //                     document
  //   //                       .getElementById(
  //   //                         "MavailableToBack1_size_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       )
  //   //                       .parentElement.classList.add("spark");
  //   //                     setTimeout(function () {
  //   //                       if (
  //   //                         document.getElementById(
  //   //                           "MavailableToBack1_size_" +
  //   //                           runner.market_id.replace(".", "") +
  //   //                           "_" +
  //   //                           runner.selection_id
  //   //                         )
  //   //                       )
  //   //                         document
  //   //                           .getElementById(
  //   //                             "MavailableToBack1_size_" +
  //   //                             runner.market_id.replace(".", "") +
  //   //                             "_" +
  //   //                             runner.selection_id
  //   //                           )
  //   //                           .parentElement.classList.remove("spark");
  //   //                     }, 700);
  //   //                     document.getElementById(
  //   //                       "MavailableToBack1_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     ).innerHTML = parseFloat(runner.back_1_size);
  //   //                   } else {
  //   //                     document.getElementById(
  //   //                       "MavailableToBack1_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     ).innerHTML = parseFloat(runner.back_1_size);
  //   //                   }
  //   //                   if (
  //   //                     parseFloat(
  //   //                       document.getElementById(
  //   //                         "MavailableToLay1_size_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       ).innerHTML
  //   //                     ) != parseFloat(runner.lay_1_size)
  //   //                   ) {
  //   //                     document
  //   //                       .getElementById(
  //   //                         "MavailableToLay1_size_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       )
  //   //                       .parentElement.classList.add("spark");
  //   //                     document.getElementById(
  //   //                       "MavailableToLay1_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     ).innerHTML = parseFloat(runner.lay_1_size);
  //   //                     setTimeout(function () {
  //   //                       if (
  //   //                         document.getElementById(
  //   //                           "MavailableToBack1_size_" +
  //   //                           runner.market_id.replace(".", "") +
  //   //                           "_" +
  //   //                           runner.selection_id
  //   //                         )
  //   //                       )
  //   //                         document
  //   //                           .getElementById(
  //   //                             "MavailableToLay1_size_" +
  //   //                             runner.market_id.replace(".", "") +
  //   //                             "_" +
  //   //                             runner.selection_id
  //   //                           )
  //   //                           .parentElement.classList.remove("spark");
  //   //                     }, 700);
  //   //                   } else {
  //   //                     document.getElementById(
  //   //                       "MavailableToLay1_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     ).innerHTML = parseFloat(runner.lay_1_size);
  //   //                   }
  //   //                 }
  //   //                 // }
  //   //                 if (
  //   //                   document.getElementById(
  //   //                     "availableToBack2_size_" +
  //   //                     runner.market_id.replace(".", "") +
  //   //                     "_" +
  //   //                     runner.selection_id
  //   //                   )
  //   //                 ) {
  //   //                   document
  //   //                     .getElementById(
  //   //                       "availableToBack2_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     )
  //   //                     .parentElement.classList.remove("spark");
  //   //                   document
  //   //                     .getElementById(
  //   //                       "availableToLay2_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     )
  //   //                     .parentElement.classList.remove("spark");
  //   //                   if (
  //   //                     parseFloat(
  //   //                       document.getElementById(
  //   //                         "availableToBack2_size_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       ).innerHTML
  //   //                     ) != parseFloat(runner.back_2_size)
  //   //                   ) {
  //   //                     document
  //   //                       .getElementById(
  //   //                         "availableToBack2_size_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       )
  //   //                       .parentElement.classList.add("spark");
  //   //                     setTimeout(function () {
  //   //                       if (
  //   //                         document.getElementById(
  //   //                           "availableToBack2_size_" +
  //   //                           runner.market_id.replace(".", "") +
  //   //                           "_" +
  //   //                           runner.selection_id
  //   //                         )
  //   //                       )
  //   //                         document
  //   //                           .getElementById(
  //   //                             "availableToBack2_size_" +
  //   //                             runner.market_id.replace(".", "") +
  //   //                             "_" +
  //   //                             runner.selection_id
  //   //                           )
  //   //                           .parentElement.classList.remove("spark");
  //   //                     }, 700);
  //   //                     document.getElementById(
  //   //                       "availableToBack2_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     ).innerHTML = parseFloat(runner.back_2_size);
  //   //                   } else {
  //   //                     document.getElementById(
  //   //                       "availableToBack2_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     ).innerHTML = parseFloat(runner.back_2_size);
  //   //                   }
  //   //                   if (
  //   //                     parseFloat(
  //   //                       document.getElementById(
  //   //                         "availableToLay2_size_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       ).innerHTML
  //   //                     ) != parseFloat(runner.lay_2_size)
  //   //                   ) {
  //   //                     document
  //   //                       .getElementById(
  //   //                         "availableToLay2_size_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       )
  //   //                       .parentElement.classList.add("spark");
  //   //                     document.getElementById(
  //   //                       "availableToLay2_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     ).innerHTML = parseFloat(runner.lay_2_size);
  //   //                     setTimeout(function () {
  //   //                       if (
  //   //                         document.getElementById(
  //   //                           "availableToBack2_size_" +
  //   //                           runner.market_id.replace(".", "") +
  //   //                           "_" +
  //   //                           runner.selection_id
  //   //                         )
  //   //                       )
  //   //                         document
  //   //                           .getElementById(
  //   //                             "availableToLay2_size_" +
  //   //                             runner.market_id.replace(".", "") +
  //   //                             "_" +
  //   //                             runner.selection_id
  //   //                           )
  //   //                           .parentElement.classList.remove("spark");
  //   //                     }, 700);
  //   //                   } else {
  //   //                     document.getElementById(
  //   //                       "availableToLay2_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     ).innerHTML = parseFloat(runner.lay_2_size);
  //   //                   }
  //   //                 }
  //   //                 if (
  //   //                   document.getElementById(
  //   //                     "availableToBack3_size_" +
  //   //                     runner.market_id.replace(".", "") +
  //   //                     "_" +
  //   //                     runner.selection_id
  //   //                   )
  //   //                 ) {
  //   //                   document
  //   //                     .getElementById(
  //   //                       "availableToBack3_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     )
  //   //                     .parentElement.classList.remove("spark");
  //   //                   document
  //   //                     .getElementById(
  //   //                       "availableToLay3_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     )
  //   //                     .parentElement.classList.remove("spark");
  //   //                   if (
  //   //                     parseFloat(
  //   //                       document.getElementById(
  //   //                         "availableToBack3_size_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       ).innerHTML
  //   //                     ) != parseFloat(runner.back_3_size)
  //   //                   ) {
  //   //                     document
  //   //                       .getElementById(
  //   //                         "availableToBack3_size_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       )
  //   //                       .parentElement.classList.add("spark");
  //   //                     setTimeout(function () {
  //   //                       if (
  //   //                         document.getElementById(
  //   //                           "availableToBack3_size_" +
  //   //                           runner.market_id.replace(".", "") +
  //   //                           "_" +
  //   //                           runner.selection_id
  //   //                         )
  //   //                       )
  //   //                         document
  //   //                           .getElementById(
  //   //                             "availableToBack3_size_" +
  //   //                             runner.market_id.replace(".", "") +
  //   //                             "_" +
  //   //                             runner.selection_id
  //   //                           )
  //   //                           .parentElement.classList.remove("spark");
  //   //                     }, 700);
  //   //                     document.getElementById(
  //   //                       "availableToBack3_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     ).innerHTML = parseFloat(runner.back_3_size);
  //   //                   } else {
  //   //                     document.getElementById(
  //   //                       "availableToBack3_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     ).innerHTML = parseFloat(runner.back_3_size);
  //   //                   }
  //   //                   if (
  //   //                     parseFloat(
  //   //                       document.getElementById(
  //   //                         "availableToLay3_size_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       ).innerHTML
  //   //                     ) != parseFloat(runner.lay_3_size)
  //   //                   ) {
  //   //                     document
  //   //                       .getElementById(
  //   //                         "availableToLay3_size_" +
  //   //                         runner.market_id.replace(".", "") +
  //   //                         "_" +
  //   //                         runner.selection_id
  //   //                       )
  //   //                       .parentElement.classList.add("spark");
  //   //                     document.getElementById(
  //   //                       "availableToLay3_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     ).innerHTML = parseFloat(runner.lay_3_size);
  //   //                     setTimeout(function () {
  //   //                       if (
  //   //                         document.getElementById(
  //   //                           "availableToBack3_size_" +
  //   //                           runner.market_id.replace(".", "") +
  //   //                           "_" +
  //   //                           runner.selection_id
  //   //                         )
  //   //                       )
  //   //                         document
  //   //                           .getElementById(
  //   //                             "availableToLay3_size_" +
  //   //                             runner.market_id.replace(".", "") +
  //   //                             "_" +
  //   //                             runner.selection_id
  //   //                           )
  //   //                           .parentElement.classList.remove("spark");
  //   //                     }, 700);
  //   //                   } else {
  //   //                     document.getElementById(
  //   //                       "availableToLay3_size_" +
  //   //                       runner.market_id.replace(".", "") +
  //   //                       "_" +
  //   //                       runner.selection_id
  //   //                     ).innerHTML = parseFloat(runner.lay_3_size);
  //   //                   }
  //   //                 }
  //   //               });
  //   //           });
  //   //         }
  //   //       }
  //   //     }
  //   //     // console.log('data111', data);

  //   //     if (data.action == "SCORE_UPDATE") {
  //   //       let market = data.score;
  //   //       if (market) {
  //   //         setScoreBoard(market?.data);
  //   //       }
  //   //     }

  //   //     if (data.action == "FANCY_UPDATE") {
  //   //       console.log('data facny : ', data)
  //   //       let market = data.data;
  //   //       console.log('market', market);
  //   //       console.log("FANCY SOCKET RESPONDING");
  //   //       if (market) {
  //   //         if (market?.fancy_data.length) {
  //   //           fancyHtml(market?.fancy_data);
  //   //         }

  //   //         // fancyHtml(market)
  //   //       }
  //   //     }
  //   //   };
  //   // }
  //   const handleMessage = (data) => {
  //     if (data.action == "MARKET_UPDATE") {
  //       // console.log("MARKET SOCKET RESPONDING");
  //       let market = data.data;
  //       console.log("market", market);
  //       if (market) {
  //         if (market.market_types.length > 0) {
  //           market.market_types.map((market_type, index) => {
  //             market_type.hasOwnProperty("runners") &&
  //               market_type.runners.map((runner, index) => {
  //                 // if (market_type.status == 'OPEN') {
  //                 // } else {
  //                 // }

  //                 // if (runner.market_id == '4.1680554980-BM') {
  //                 // }
  //                 if (
  //                   checkHighestMarketPrice(runner, market_type.market_name)
  //                 ) {
  //                   if (
  //                     runner.status == "SUSPENDED" ||
  //                     market_type.status == "CLOSED"
  //                   ) {
  //                     const selecid = runner.selection_id;
  //                     const suspendedDiv = document.querySelector(
  //                       `.suspended_${runner.market_id.replace(
  //                         ".",
  //                         "",
  //                       )}_${selecid}`,
  //                     );
  //                     const suspendedMDiv = document.querySelector(
  //                       `.Msuspended_${runner.market_id.replace(
  //                         ".",
  //                         "",
  //                       )}_${selecid}`,
  //                     );
  //                     const suspendedMSOCCERDiv = document.querySelector(
  //                       `.m-soccer-suspended_${runner.market_id.replace(
  //                         ".",
  //                         "",
  //                       )}_${selecid}`,
  //                     );
  //                     const suspendedSOCCERDiv = document.querySelector(
  //                       `.soccer-suspended_${runner.market_id.replace(
  //                         ".",
  //                         "",
  //                       )}_${selecid}`,
  //                     );
  //                     if (suspendedDiv) {
  //                       suspendedDiv && suspendedDiv.classList.remove("hidden");
  //                     }
  //                     if (suspendedMDiv) {
  //                       suspendedMDiv &&
  //                         suspendedMDiv.classList.remove("hidden");
  //                     }
  //                     if (suspendedMSOCCERDiv) {
  //                       suspendedMSOCCERDiv &&
  //                         suspendedMSOCCERDiv.classList.remove("hidden");
  //                     }
  //                     if (suspendedSOCCERDiv) {
  //                       suspendedSOCCERDiv &&
  //                         suspendedSOCCERDiv.classList.remove("hidden");
  //                     }
  //                   } else {
  //                     const selecid = runner.selection_id;
  //                     const suspendedDiv = document.querySelector(
  //                       `.suspended_${runner.market_id.replace(
  //                         ".",
  //                         "",
  //                       )}_${selecid}`,
  //                     );
  //                     const suspendedMDiv = document.querySelector(
  //                       `.Msuspended_${runner.market_id.replace(
  //                         ".",
  //                         "",
  //                       )}_${selecid}`,
  //                     );
  //                     const suspendedMSOCCERDiv = document.querySelector(
  //                       `.m-soccer-suspended_${runner.market_id.replace(
  //                         ".",
  //                         "",
  //                       )}_${selecid}`,
  //                     );
  //                     const suspendedSOCCERDiv = document.querySelector(
  //                       `.soccer-suspended_${runner.market_id.replace(
  //                         ".",
  //                         "",
  //                       )}_${selecid}`,
  //                     );
  //                     if (suspendedDiv) {
  //                       suspendedDiv && suspendedDiv.classList.add("hidden");
  //                     }
  //                     if (suspendedMDiv) {
  //                       suspendedMDiv && suspendedMDiv.classList.add("hidden");
  //                     }
  //                     if (suspendedMSOCCERDiv) {
  //                       suspendedMSOCCERDiv &&
  //                         suspendedMSOCCERDiv.classList.add("hidden");
  //                     }
  //                     if (suspendedSOCCERDiv) {
  //                       suspendedSOCCERDiv &&
  //                         suspendedSOCCERDiv.classList.add("hidden");
  //                     }
  //                   }
  //                   const boxes = document.querySelectorAll(
  //                     ".market_runners_" +
  //                       runner.market_id.replace(".", "") +
  //                       "_" +
  //                       runner.selection_id,
  //                   );
  //                   for (const box of boxes) {
  //                     box.classList.add("disabled");
  //                   }
  //                 } else {
  //                   const boxes = document.querySelectorAll(
  //                     ".market_runners_" +
  //                       runner.market_id.toString().replace(".", "") +
  //                       "_" +
  //                       runner.selection_id,
  //                   );
  //                   for (const box of boxes) {
  //                     box.classList.remove("disabled");
  //                   }
  //                 }

  //                 var match_odd_row = document.getElementsByClassName(
  //                   "table_row_" +
  //                     runner.market_id.toString().replace(".", "") +
  //                     "_" +
  //                     runner.selection_id,
  //                 )[0];

  //                 if (
  //                   runner.status == "SUSPENDED" ||
  //                   runner.status == "CLOSE" ||
  //                   runner.status == "CLOSED"
  //                 ) {
  //                   if (
  //                     document.getElementById(
  //                       "availableToLay1_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     )
  //                   ) {
  //                     if (match_odd_row) {
  //                       match_odd_row.setAttribute("data-title", runner.status);
  //                       match_odd_row.parentElement.classList.add("suspended");
  //                     }
  //                     if (
  //                       parseFloat(
  //                         document.getElementById(
  //                           "availableToBack1_price_" +
  //                             runner.market_id.replace(".", "") +
  //                             "_" +
  //                             runner.selection_id,
  //                         ).innerHTML,
  //                       ) != parseFloat(runner.back_1_price)
  //                     ) {
  //                     } else {
  //                     }
  //                     if (
  //                       parseFloat(
  //                         document.getElementById(
  //                           "availableToLay1_price_" +
  //                             runner.market_id.replace(".", "") +
  //                             "_" +
  //                             runner.selection_id,
  //                         ).innerHTML,
  //                       ) != parseFloat(runner.lay_1_price)
  //                     ) {
  //                     } else {
  //                     }
  //                   }
  //                   // mobile{
  //                   if (
  //                     document.getElementById(
  //                       "MavailableToLay1_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     )
  //                   ) {
  //                     if (match_odd_row) {
  //                       match_odd_row.setAttribute("data-title", runner.status);
  //                       match_odd_row.parentElement.classList.add("suspended");
  //                     }
  //                     if (
  //                       parseFloat(
  //                         document.getElementById(
  //                           "MavailableToBack1_price_" +
  //                             runner.market_id.replace(".", "") +
  //                             "_" +
  //                             runner.selection_id,
  //                         ).innerHTML,
  //                       ) != parseFloat(runner.back_1_price)
  //                     ) {
  //                     } else {
  //                     }
  //                     if (
  //                       parseFloat(
  //                         document.getElementById(
  //                           "MavailableToLay1_price_" +
  //                             runner.market_id.replace(".", "") +
  //                             "_" +
  //                             runner.selection_id,
  //                         ).innerHTML,
  //                       ) != parseFloat(runner.lay_1_price)
  //                     ) {
  //                     } else {
  //                     }
  //                   }
  //                   // }
  //                   if (
  //                     document.getElementById(
  //                       "availableToLay2_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     )
  //                   ) {
  //                     if (match_odd_row) {
  //                       match_odd_row.setAttribute("data-title", runner.status);
  //                       match_odd_row.parentElement.classList.add("suspended");
  //                     }
  //                     if (
  //                       parseFloat(
  //                         document.getElementById(
  //                           "availableToBack2_price_" +
  //                             runner.market_id.replace(".", "") +
  //                             "_" +
  //                             runner.selection_id,
  //                         ).innerHTML,
  //                       ) != parseFloat(runner.back_2_price)
  //                     ) {
  //                     } else {
  //                     }
  //                     if (
  //                       parseFloat(
  //                         document.getElementById(
  //                           "availableToLay2_price_" +
  //                             runner.market_id.replace(".", "") +
  //                             "_" +
  //                             runner.selection_id,
  //                         ).innerHTML,
  //                       ) != parseFloat(runner.lay_2_price)
  //                     ) {
  //                     } else {
  //                     }
  //                   }
  //                   if (
  //                     document.getElementById(
  //                       "availableToLay3_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     )
  //                   ) {
  //                     if (match_odd_row) {
  //                       match_odd_row.setAttribute("data-title", runner.status);
  //                       match_odd_row.parentElement.classList.add("suspended");
  //                     }
  //                     if (
  //                       parseFloat(
  //                         document.getElementById(
  //                           "availableToBack3_price_" +
  //                             runner.market_id.replace(".", "") +
  //                             "_" +
  //                             runner.selection_id,
  //                         ).innerHTML,
  //                       ) != parseFloat(runner.back_3_price)
  //                     ) {
  //                     } else {
  //                     }
  //                     if (
  //                       parseFloat(
  //                         document.getElementById(
  //                           "availableToLay3_price_" +
  //                             runner.market_id.replace(".", "") +
  //                             "_" +
  //                             runner.selection_id,
  //                         ).innerHTML,
  //                       ) != parseFloat(runner.lay_3_price)
  //                     ) {
  //                     } else {
  //                     }
  //                   }
  //                 } else {
  //                   if (
  //                     document.getElementById(
  //                       "availableToLay1_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     )
  //                   ) {
  //                     if (match_odd_row) {
  //                       match_odd_row.parentElement.setAttribute(
  //                         "data-title",
  //                         "",
  //                       );
  //                       match_odd_row.parentElement.classList.remove(
  //                         "suspended",
  //                       );
  //                     }
  //                     if (
  //                       parseFloat(
  //                         document.getElementById(
  //                           "availableToBack1_price_" +
  //                             runner.market_id.replace(".", "") +
  //                             "_" +
  //                             runner.selection_id,
  //                         ).innerHTML,
  //                       ) != parseFloat(runner.back_1_price)
  //                     ) {
  //                       document.getElementById(
  //                         "availableToBack1_price_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       ).innerHTML = parseFloat(runner.back_1_price);
  //                     } else {
  //                       document.getElementById(
  //                         "availableToBack1_price_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       ).innerHTML = parseFloat(runner.back_1_price);
  //                     }
  //                     if (
  //                       parseFloat(
  //                         document.getElementById(
  //                           "availableToLay1_price_" +
  //                             runner.market_id.replace(".", "") +
  //                             "_" +
  //                             runner.selection_id,
  //                         ).innerHTML,
  //                       ) != parseFloat(runner.lay_1_price)
  //                     ) {
  //                       document.getElementById(
  //                         "availableToLay1_price_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       ).innerHTML = parseFloat(runner.lay_1_price);
  //                     } else {
  //                       document.getElementById(
  //                         "availableToLay1_price_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       ).innerHTML = parseFloat(runner.lay_1_price);
  //                     }
  //                   }
  //                   // mobile{
  //                   if (
  //                     document.getElementById(
  //                       "MavailableToLay1_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     )
  //                   ) {
  //                     if (match_odd_row) {
  //                       match_odd_row.parentElement.setAttribute(
  //                         "data-title",
  //                         "",
  //                       );
  //                       match_odd_row.parentElement.classList.remove(
  //                         "suspended",
  //                       );
  //                     }
  //                     if (
  //                       parseFloat(
  //                         document.getElementById(
  //                           "MavailableToBack1_price_" +
  //                             runner.market_id.replace(".", "") +
  //                             "_" +
  //                             runner.selection_id,
  //                         ).innerHTML,
  //                       ) != parseFloat(runner.back_1_price)
  //                     ) {
  //                       document.getElementById(
  //                         "MavailableToBack1_price_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       ).innerHTML = parseFloat(runner.back_1_price);
  //                     } else {
  //                       document.getElementById(
  //                         "MavailableToBack1_price_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       ).innerHTML = parseFloat(runner.back_1_price);
  //                     }
  //                     if (
  //                       parseFloat(
  //                         document.getElementById(
  //                           "MavailableToLay1_price_" +
  //                             runner.market_id.replace(".", "") +
  //                             "_" +
  //                             runner.selection_id,
  //                         ).innerHTML,
  //                       ) != parseFloat(runner.lay_1_price)
  //                     ) {
  //                       document.getElementById(
  //                         "MavailableToLay1_price_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       ).innerHTML = parseFloat(runner.lay_1_price);
  //                     } else {
  //                       document.getElementById(
  //                         "MavailableToLay1_price_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       ).innerHTML = parseFloat(runner.lay_1_price);
  //                     }
  //                   }
  //                   // }
  //                   if (
  //                     document.getElementById(
  //                       "availableToLay2_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     )
  //                   ) {
  //                     if (match_odd_row) {
  //                       match_odd_row.parentElement.setAttribute(
  //                         "data-title",
  //                         "",
  //                       );
  //                       match_odd_row.parentElement.classList.remove(
  //                         "suspended",
  //                       );
  //                     }
  //                     if (
  //                       parseFloat(
  //                         document.getElementById(
  //                           "availableToBack2_price_" +
  //                             runner.market_id.replace(".", "") +
  //                             "_" +
  //                             runner.selection_id,
  //                         ).innerHTML,
  //                       ) != parseFloat(runner.back_2_price)
  //                     ) {
  //                       document.getElementById(
  //                         "availableToBack2_price_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       ).innerHTML = parseFloat(runner.back_2_price);
  //                     } else {
  //                       document.getElementById(
  //                         "availableToBack2_price_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       ).innerHTML = parseFloat(runner.back_2_price);
  //                     }
  //                     if (
  //                       parseFloat(
  //                         document.getElementById(
  //                           "availableToLay2_price_" +
  //                             runner.market_id.replace(".", "") +
  //                             "_" +
  //                             runner.selection_id,
  //                         ).innerHTML,
  //                       ) != parseFloat(runner.lay_2_price)
  //                     ) {
  //                       document.getElementById(
  //                         "availableToLay2_price_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       ).innerHTML = parseFloat(runner.lay_2_price);
  //                     } else {
  //                       document.getElementById(
  //                         "availableToLay2_price_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       ).innerHTML = parseFloat(runner.lay_2_price);
  //                     }
  //                   }
  //                   if (
  //                     document.getElementById(
  //                       "availableToLay3_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     )
  //                   ) {
  //                     if (match_odd_row) {
  //                       match_odd_row.parentElement.setAttribute(
  //                         "data-title",
  //                         "",
  //                       );
  //                       match_odd_row.parentElement.classList.remove(
  //                         "suspended",
  //                       );
  //                     }
  //                     if (
  //                       parseFloat(
  //                         document.getElementById(
  //                           "availableToBack3_price_" +
  //                             runner.market_id.replace(".", "") +
  //                             "_" +
  //                             runner.selection_id,
  //                         ).innerHTML,
  //                       ) != parseFloat(runner.back_3_price)
  //                     ) {
  //                       document.getElementById(
  //                         "availableToBack3_price_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       ).innerHTML = parseFloat(runner.back_3_price);
  //                     } else {
  //                       document.getElementById(
  //                         "availableToBack3_price_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       ).innerHTML = parseFloat(runner.back_3_price);
  //                     }
  //                     if (
  //                       parseFloat(
  //                         document.getElementById(
  //                           "availableToLay3_price_" +
  //                             runner.market_id.replace(".", "") +
  //                             "_" +
  //                             runner.selection_id,
  //                         ).innerHTML,
  //                       ) != parseFloat(runner.lay_3_price)
  //                     ) {
  //                       document.getElementById(
  //                         "availableToLay3_price_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       ).innerHTML = parseFloat(runner.lay_3_price);
  //                     } else {
  //                       document.getElementById(
  //                         "availableToLay3_price_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       ).innerHTML = parseFloat(runner.lay_3_price);
  //                     }
  //                   }
  //                 }
  //                 /************************Size */

  //                 if (
  //                   document.getElementById(
  //                     "availableToBack1_size_" +
  //                       runner.market_id.replace(".", "") +
  //                       "_" +
  //                       runner.selection_id,
  //                   )
  //                 ) {
  //                   document
  //                     .getElementById(
  //                       "availableToBack1_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     )
  //                     .parentElement.classList.remove("spark");
  //                   document
  //                     .getElementById(
  //                       "availableToLay1_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     )
  //                     .parentElement.classList.remove("spark");
  //                   if (
  //                     parseFloat(
  //                       document.getElementById(
  //                         "availableToBack1_size_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       ).innerHTML,
  //                     ) != parseFloat(runner.back_1_size)
  //                   ) {
  //                     document
  //                       .getElementById(
  //                         "availableToBack1_size_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       )
  //                       .parentElement.classList.add("spark");
  //                     setTimeout(function () {
  //                       if (
  //                         document.getElementById(
  //                           "availableToBack1_size_" +
  //                             runner.market_id.replace(".", "") +
  //                             "_" +
  //                             runner.selection_id,
  //                         )
  //                       )
  //                         document
  //                           .getElementById(
  //                             "availableToBack1_size_" +
  //                               runner.market_id.replace(".", "") +
  //                               "_" +
  //                               runner.selection_id,
  //                           )
  //                           .parentElement.classList.remove("spark");
  //                     }, 700);
  //                     document.getElementById(
  //                       "availableToBack1_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     ).innerHTML = parseFloat(runner.back_1_size);
  //                   } else {
  //                     document.getElementById(
  //                       "availableToBack1_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     ).innerHTML = parseFloat(runner.back_1_size);
  //                   }
  //                   if (
  //                     parseFloat(
  //                       document.getElementById(
  //                         "availableToLay1_size_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       ).innerHTML,
  //                     ) != parseFloat(runner.lay_1_size)
  //                   ) {
  //                     document
  //                       .getElementById(
  //                         "availableToLay1_size_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       )
  //                       .parentElement.classList.add("spark");
  //                     document.getElementById(
  //                       "availableToLay1_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     ).innerHTML = parseFloat(runner.lay_1_size);
  //                     setTimeout(function () {
  //                       if (
  //                         document.getElementById(
  //                           "availableToBack1_size_" +
  //                             runner.market_id.replace(".", "") +
  //                             "_" +
  //                             runner.selection_id,
  //                         )
  //                       )
  //                         document
  //                           .getElementById(
  //                             "availableToLay1_size_" +
  //                               runner.market_id.replace(".", "") +
  //                               "_" +
  //                               runner.selection_id,
  //                           )
  //                           .parentElement.classList.remove("spark");
  //                     }, 700);
  //                   } else {
  //                     document.getElementById(
  //                       "availableToLay1_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     ).innerHTML = parseFloat(runner.lay_1_size);
  //                   }
  //                 }
  //                 // mobile
  //                 if (
  //                   document.getElementById(
  //                     "MavailableToBack1_size_" +
  //                       runner.market_id.replace(".", "") +
  //                       "_" +
  //                       runner.selection_id,
  //                   )
  //                 ) {
  //                   document
  //                     .getElementById(
  //                       "MavailableToBack1_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     )
  //                     .parentElement.classList.remove("spark");
  //                   document
  //                     .getElementById(
  //                       "MavailableToLay1_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     )
  //                     .parentElement.classList.remove("spark");
  //                   if (
  //                     parseFloat(
  //                       document.getElementById(
  //                         "MavailableToBack1_size_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       ).innerHTML,
  //                     ) != parseFloat(runner.back_1_size)
  //                   ) {
  //                     document
  //                       .getElementById(
  //                         "MavailableToBack1_size_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       )
  //                       .parentElement.classList.add("spark");
  //                     setTimeout(function () {
  //                       if (
  //                         document.getElementById(
  //                           "MavailableToBack1_size_" +
  //                             runner.market_id.replace(".", "") +
  //                             "_" +
  //                             runner.selection_id,
  //                         )
  //                       )
  //                         document
  //                           .getElementById(
  //                             "MavailableToBack1_size_" +
  //                               runner.market_id.replace(".", "") +
  //                               "_" +
  //                               runner.selection_id,
  //                           )
  //                           .parentElement.classList.remove("spark");
  //                     }, 700);
  //                     document.getElementById(
  //                       "MavailableToBack1_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     ).innerHTML = parseFloat(runner.back_1_size);
  //                   } else {
  //                     document.getElementById(
  //                       "MavailableToBack1_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     ).innerHTML = parseFloat(runner.back_1_size);
  //                   }
  //                   if (
  //                     parseFloat(
  //                       document.getElementById(
  //                         "MavailableToLay1_size_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       ).innerHTML,
  //                     ) != parseFloat(runner.lay_1_size)
  //                   ) {
  //                     document
  //                       .getElementById(
  //                         "MavailableToLay1_size_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       )
  //                       .parentElement.classList.add("spark");
  //                     document.getElementById(
  //                       "MavailableToLay1_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     ).innerHTML = parseFloat(runner.lay_1_size);
  //                     setTimeout(function () {
  //                       if (
  //                         document.getElementById(
  //                           "MavailableToBack1_size_" +
  //                             runner.market_id.replace(".", "") +
  //                             "_" +
  //                             runner.selection_id,
  //                         )
  //                       )
  //                         document
  //                           .getElementById(
  //                             "MavailableToLay1_size_" +
  //                               runner.market_id.replace(".", "") +
  //                               "_" +
  //                               runner.selection_id,
  //                           )
  //                           .parentElement.classList.remove("spark");
  //                     }, 700);
  //                   } else {
  //                     document.getElementById(
  //                       "MavailableToLay1_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     ).innerHTML = parseFloat(runner.lay_1_size);
  //                   }
  //                 }
  //                 // }
  //                 if (
  //                   document.getElementById(
  //                     "availableToBack2_size_" +
  //                       runner.market_id.replace(".", "") +
  //                       "_" +
  //                       runner.selection_id,
  //                   )
  //                 ) {
  //                   document
  //                     .getElementById(
  //                       "availableToBack2_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     )
  //                     .parentElement.classList.remove("spark");
  //                   document
  //                     .getElementById(
  //                       "availableToLay2_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     )
  //                     .parentElement.classList.remove("spark");
  //                   if (
  //                     parseFloat(
  //                       document.getElementById(
  //                         "availableToBack2_size_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       ).innerHTML,
  //                     ) != parseFloat(runner.back_2_size)
  //                   ) {
  //                     document
  //                       .getElementById(
  //                         "availableToBack2_size_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       )
  //                       .parentElement.classList.add("spark");
  //                     setTimeout(function () {
  //                       if (
  //                         document.getElementById(
  //                           "availableToBack2_size_" +
  //                             runner.market_id.replace(".", "") +
  //                             "_" +
  //                             runner.selection_id,
  //                         )
  //                       )
  //                         document
  //                           .getElementById(
  //                             "availableToBack2_size_" +
  //                               runner.market_id.replace(".", "") +
  //                               "_" +
  //                               runner.selection_id,
  //                           )
  //                           .parentElement.classList.remove("spark");
  //                     }, 700);
  //                     document.getElementById(
  //                       "availableToBack2_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     ).innerHTML = parseFloat(runner.back_2_size);
  //                   } else {
  //                     document.getElementById(
  //                       "availableToBack2_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     ).innerHTML = parseFloat(runner.back_2_size);
  //                   }
  //                   if (
  //                     parseFloat(
  //                       document.getElementById(
  //                         "availableToLay2_size_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       ).innerHTML,
  //                     ) != parseFloat(runner.lay_2_size)
  //                   ) {
  //                     document
  //                       .getElementById(
  //                         "availableToLay2_size_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       )
  //                       .parentElement.classList.add("spark");
  //                     document.getElementById(
  //                       "availableToLay2_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     ).innerHTML = parseFloat(runner.lay_2_size);
  //                     setTimeout(function () {
  //                       if (
  //                         document.getElementById(
  //                           "availableToBack2_size_" +
  //                             runner.market_id.replace(".", "") +
  //                             "_" +
  //                             runner.selection_id,
  //                         )
  //                       )
  //                         document
  //                           .getElementById(
  //                             "availableToLay2_size_" +
  //                               runner.market_id.replace(".", "") +
  //                               "_" +
  //                               runner.selection_id,
  //                           )
  //                           .parentElement.classList.remove("spark");
  //                     }, 700);
  //                   } else {
  //                     document.getElementById(
  //                       "availableToLay2_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     ).innerHTML = parseFloat(runner.lay_2_size);
  //                   }
  //                 }
  //                 if (
  //                   document.getElementById(
  //                     "availableToBack3_size_" +
  //                       runner.market_id.replace(".", "") +
  //                       "_" +
  //                       runner.selection_id,
  //                   )
  //                 ) {
  //                   document
  //                     .getElementById(
  //                       "availableToBack3_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     )
  //                     .parentElement.classList.remove("spark");
  //                   document
  //                     .getElementById(
  //                       "availableToLay3_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     )
  //                     .parentElement.classList.remove("spark");
  //                   if (
  //                     parseFloat(
  //                       document.getElementById(
  //                         "availableToBack3_size_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       ).innerHTML,
  //                     ) != parseFloat(runner.back_3_size)
  //                   ) {
  //                     document
  //                       .getElementById(
  //                         "availableToBack3_size_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       )
  //                       .parentElement.classList.add("spark");
  //                     setTimeout(function () {
  //                       if (
  //                         document.getElementById(
  //                           "availableToBack3_size_" +
  //                             runner.market_id.replace(".", "") +
  //                             "_" +
  //                             runner.selection_id,
  //                         )
  //                       )
  //                         document
  //                           .getElementById(
  //                             "availableToBack3_size_" +
  //                               runner.market_id.replace(".", "") +
  //                               "_" +
  //                               runner.selection_id,
  //                           )
  //                           .parentElement.classList.remove("spark");
  //                     }, 700);
  //                     document.getElementById(
  //                       "availableToBack3_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     ).innerHTML = parseFloat(runner.back_3_size);
  //                   } else {
  //                     document.getElementById(
  //                       "availableToBack3_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     ).innerHTML = parseFloat(runner.back_3_size);
  //                   }
  //                   if (
  //                     parseFloat(
  //                       document.getElementById(
  //                         "availableToLay3_size_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       ).innerHTML,
  //                     ) != parseFloat(runner.lay_3_size)
  //                   ) {
  //                     document
  //                       .getElementById(
  //                         "availableToLay3_size_" +
  //                           runner.market_id.replace(".", "") +
  //                           "_" +
  //                           runner.selection_id,
  //                       )
  //                       .parentElement.classList.add("spark");
  //                     document.getElementById(
  //                       "availableToLay3_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     ).innerHTML = parseFloat(runner.lay_3_size);
  //                     setTimeout(function () {
  //                       if (
  //                         document.getElementById(
  //                           "availableToBack3_size_" +
  //                             runner.market_id.replace(".", "") +
  //                             "_" +
  //                             runner.selection_id,
  //                         )
  //                       )
  //                         document
  //                           .getElementById(
  //                             "availableToLay3_size_" +
  //                               runner.market_id.replace(".", "") +
  //                               "_" +
  //                               runner.selection_id,
  //                           )
  //                           .parentElement.classList.remove("spark");
  //                     }, 700);
  //                   } else {
  //                     document.getElementById(
  //                       "availableToLay3_size_" +
  //                         runner.market_id.replace(".", "") +
  //                         "_" +
  //                         runner.selection_id,
  //                     ).innerHTML = parseFloat(runner.lay_3_size);
  //                   }
  //                 }
  //               });
  //           });
  //         }
  //       }
  //     }
  //     // console.log('data111', data);

  //     if (data.action == "SCORE_UPDATE") {
  //       let market = data.score;
  //       if (market) {
  //         setScoreBoard(market?.data);
  //       }
  //     }

  //     if (data.action == "FANCY_UPDATE") {
  //       console.log("data facny : ", data);
  //       let market = data.data;
  //       console.log("market", market);
  //       console.log("FANCY SOCKET RESPONDING");
  //       if (market) {
  //         if (market?.fancy_data.length) {
  //           fancyHtml(market?.fancy_data);
  //         }

  //         // fancyHtml(market)
  //       }
  //     }
  //   };

  //   WebSocketEventEmitter.on("message", handleMessage);

  //   return () => {
  //     WebSocketEventEmitter.off("message", handleMessage); // Cleanup on unmount
  //   };
  // }, [websocket, event_id]);

  const checkHighestMarketPrice = (runner, market_name) => {
    let price_exceed_by_limit = false;
    // await Promise.all(
    // 1
    if (runner.market_id.toString().includes("BM")) {
      if (runner.back_1_price > 0) {
        if (parseFloat(runner.back_1_price / 100 + 1) > match_odds_bet_limit) {
          price_exceed_by_limit = true;
        }
      }

      if (runner.lay_1_price > 0) {
        if (parseFloat(runner.lay_1_price / 100 + 1) > match_odds_bet_limit) {
          price_exceed_by_limit = true;
        }
      }

      if (runner.back_1_price <= 0) {
        price_exceed_by_limit = true;
      }

      if (runner.lay_1_price <= 0) {
      }
    } else if (
      market_name == "Bookmaker" ||
      market_name == "Bookmaker 2" ||
      market_name == "TIED_MATCH"
    ) {
      if (runner.back_1_price > 0) {
        if (parseFloat(runner.back_1_price / 100 + 1) > match_odds_bet_limit) {
          price_exceed_by_limit = true;
        }
      }

      if (runner.lay_1_price > 0) {
        if (parseFloat(runner.lay_1_price / 100 + 1) > match_odds_bet_limit) {
          price_exceed_by_limit = true;
        }
      }

      if (runner.back_1_price <= 0) {
        price_exceed_by_limit = true;
      }

      if (runner.lay_1_price <= 0) {
      }
    } else {
      if (
        parseFloat(runner.back_1_price) > match_odds_bet_limit ||
        parseFloat(runner.lay_1_price) > match_odds_bet_limit
      ) {
        price_exceed_by_limit = true;
      }

      if (
        parseFloat(runner.back_1_price) <= 0 &&
        parseFloat(runner.lay_1_price) <= 0
      ) {
        price_exceed_by_limit = true;
      }
    }

    // 2
    if (runner.market_id.toString().includes("BM")) {
      if (runner.back_2_price > 0) {
        if (parseFloat(runner.back_2_price / 100 + 1) > match_odds_bet_limit) {
          price_exceed_by_limit = true;
        }
      }

      if (runner.lay_2_price > 0) {
        if (parseFloat(runner.lay_2_price / 100 + 1) > match_odds_bet_limit) {
          price_exceed_by_limit = true;
        }
      }

      if (runner.back_2_price <= 0) {
        price_exceed_by_limit = true;
      }

      if (runner.lay_2_price <= 0) {
      }
    } else if (
      market_name == "Bookmaker" ||
      market_name == "Bookmaker 2" ||
      market_name == "TIED_MATCH"
    ) {
      if (runner.back_2_price > 0) {
        if (parseFloat(runner.back_2_price / 100 + 1) > match_odds_bet_limit) {
          price_exceed_by_limit = true;
        }
      }

      if (runner.lay_2_price > 0) {
        if (parseFloat(runner.lay_2_price / 100 + 1) > match_odds_bet_limit) {
          price_exceed_by_limit = true;
        }
      }

      if (runner.back_2_price <= 0) {
        price_exceed_by_limit = true;
      }

      if (runner.lay_2_price <= 0) {
      }
    } else {
      if (
        parseFloat(runner.back_2_price) > match_odds_bet_limit ||
        parseFloat(runner.lay_2_price) > match_odds_bet_limit
      ) {
        price_exceed_by_limit = true;
      }

      if (
        parseFloat(runner.back_2_price) <= 0 &&
        parseFloat(runner.lay_2_price) <= 0
      ) {
        price_exceed_by_limit = true;
      }
    }

    // 3
    if (runner.market_id.toString().includes("BM")) {
      if (runner.back_3_price > 0) {
        if (parseFloat(runner.back_3_price / 100 + 1) > match_odds_bet_limit) {
          price_exceed_by_limit = true;
        }
      }

      if (runner.lay_3_price > 0) {
        if (parseFloat(runner.lay_3_price / 100 + 1) > match_odds_bet_limit) {
          price_exceed_by_limit = true;
        }
      }

      if (runner.back_3_price <= 0) {
        price_exceed_by_limit = true;
      }

      if (runner.lay_3_price <= 0) {
      }
    } else if (
      market_name == "Bookmaker" ||
      market_name == "Bookmaker 2" ||
      market_name == "TIED_MATCH"
    ) {
      if (runner.back_3_price > 0) {
        if (parseFloat(runner.back_3_price / 100 + 1) > match_odds_bet_limit) {
          price_exceed_by_limit = true;
        }
      }

      if (runner.lay_3_price > 0) {
        if (parseFloat(runner.lay_3_price / 100 + 1) > match_odds_bet_limit) {
          price_exceed_by_limit = true;
        }
      }

      if (runner.back_3_price <= 0) {
        price_exceed_by_limit = true;
      }

      if (runner.lay_3_price <= 0) {
      }
    } else {
      if (
        parseFloat(runner.back_3_price) > match_odds_bet_limit ||
        parseFloat(runner.lay_3_price) > match_odds_bet_limit
      ) {
        price_exceed_by_limit = true;
      }

      if (
        parseFloat(runner.back_3_price) <= 0 &&
        parseFloat(runner.lay_3_price) <= 0
      ) {
        price_exceed_by_limit = true;
      }
    }

    // )

    return price_exceed_by_limit;
  };

  useEffect(() => {
    if (userInfo) {
      getGeneralSetting();
      getFancysExposure();
      getChips();
    }
  }, [event_id]);

  function getGeneralSetting() {
    var data = JSON.stringify({
      user_id: userInfo?._id,
      event_id: event_id,
    });
    var config = {
      method: "post",
      url: `${Appconfig.apiUrl}matchGeneralSetting/getAllGeneralSetting`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function (response) {
        try {
          // alert("Hello");
          // console.log('response.data', response.data)
          if (response.data.result) {
            setGeneralSetting(response.data.resultData);
          }
        } catch (e) {
          // postErrorToslack(e.message);
        }
      })
      .catch(function (error) {
        console.log(error);
        // postErrorToslack(error.message);
      });
  }

  function getFancysExposure() {
    if (userInfo) {
      var data = JSON.stringify({
        event_id: event_id,
        user_id: userInfo._id,
      });
      var config = {
        method: "post",
        url: `${Appconfig.apiUrl}betting/getFancysExposure`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then(function (response) {
          try {
            if (response.data.resultData.length > 0) {
              setFancyExposure(response.data.resultData);
            }
          } catch (e) {
            console.log(e);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      navigate("/login");
    }
  }

  function getChips() {
    if (userInfo) {
      var data = JSON.stringify({
        user_id: userInfo._id,
      });
      var config = {
        method: "post",
        url: `${Appconfig.apiUrl}chips/getChips`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then(function (response) {
          try {
            if (response.status) {
              setChips(response.data);
            }
          } catch (e) {
            console.log(e);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      navigate("/login");
    }
  }

  const handleOpenBetSlip = (
    event_id,
    market_id,
    is_back,
    size,
    is_fancy,
    selection_id,
    runner_name,
    htmlId,
    PM_FANCY = null,
    market_name,
  ) => {
    setShowBetsSlip(true);
    setSelection_id(selection_id);
    setMarketId(market_id);
    setType(is_back ? "back" : "lay");
    setHtmlId(htmlId);
    setSize(size);
    setIs_fancy(is_fancy);

    if (selection_id) {
      setSelectionIdNew(selection_id);
    }
    // console.log({
    //     'event_id': event_id,
    //     'market_id': market_id,
    //     'is_back': is_back,
    //     'size': document.getElementById(size)?.innerHTML,
    //     'is_fancy': is_fancy,
    //     'selection_id': selection_id,
    //     'runner_name': runner_name,
    //     'new_price': document.getElementById(htmlId)?.innerHTML,
    //     'PM_FANCY': PM_FANCY,
    //     'market_name': market_name,
    // })

    // console.log('yes ')

    let selectElements = document.getElementsByClassName(
      "market_runners_" + market_id.replace(".", "") + "_" + selection_id,
    );
    // if (selectElements.length > 0) {
    //     let check_class_exists = document.getElementsByClassName('market_runners_' + market_id.replace('.', '') + '_' + selection_id)[0].classList.contains('disabled');
    //     if (check_class_exists) {
    //         return false;
    //     }

    // }

    setProfitValue(0);
    setStakeValue(0);
    var priceNew = document.getElementById(htmlId).innerHTML;
    var lastFive = market_id.substr(market_id.length - 3);
    if (lastFive == "-BM") {
      priceNew = (priceNew / 100 + 1).toFixed(2);
    } else {
      if (
        market_name == "Bookmaker" ||
        market_name == "Bookmaker 2" ||
        market_name == "TIED_MATCH"
      ) {
        priceNew = (priceNew / 100 + 1).toFixed(2);
      }
    }
    // console.log('priceNew:', priceNew)
    let market_type = "match_odds";
    let runnersArr = [];
    if (market_name === "Toss") {
      market_type = "toss";
      // Only use toss market runners for toss bets
      // const tossMarket = eventData
      //   .flatMap(ev => ev.marketTypes || [])
      //   .find(mkt => mkt.market_id === market_id && mkt.market_name === "Toss");
      const tossMarket = marketTypes.find((market) => {
        const marketName = String(
          market?.market_name || market?.marketName || "",
        )
          .trim()
          .toLowerCase();

        return marketName === "toss";
      });
      runnersArr = tossMarket.marketRunners.map((r) => ({
        event_id: String(event_id),
        market_id: String(tossMarket.market_id || market_id),
        selection_id: String(r.selection_id),
        runner_name: r.runner_name || "",
        status: r.status || "OPEN",
        exposure: Number.isFinite(Number(r.exposure))
          ? Number(r.exposure)
          : 0,
      }));
    } else if (
      String(market_id) === String(matchOdds?.market_id) &&
      Array.isArray(matchOdds?.marketRunners)
    ) {
      market_type = "match_odds";

      runnersArr = matchOdds.marketRunners.map((r) => ({
        event_id: String(event_id),
        market_id: String(matchOdds.market_id || market_id),
        selection_id: String(r.selection_id),
        runner_name: r.runner_name || "",
        status: r.status || "ACTIVE",
        exposure: Number.isFinite(Number(r.exposure))
          ? Number(r.exposure)
          : 0,
      }));
    } else if (
      market_name === "Bookmaker" ||
      market_name === "Bookmaker 2" ||
      market_name === "TIED_MATCH"
    ) {
      market_type = "bookmaker";
      if (bookmaker && bookmaker.marketRunners) {
        runnersArr = bookmaker.marketRunners.map((r) => ({
          event_id: String(event_id),
          market_id: String(bookmaker.market_id || market_id),
          selection_id: String(r.selection_id),
          runner_name: r.runner_name || "",
          status: r.status || "ACTIVE",

          back_1_price: r.back_1_price,
          back_2_price: r.back_2_price,
          back_3_price: r.back_3_price,
          lay_1_price: r.lay_1_price,
          lay_2_price: r.lay_2_price,
          lay_3_price: r.lay_3_price,
          back_1_size: r.back_1_size,
          back_2_size: r.back_2_size,
          back_3_size: r.back_3_size,
          lay_1_size: r.lay_1_size,
          lay_2_size: r.lay_2_size,
          lay_3_size: r.lay_3_size,

          exposure: Number.isFinite(Number(r.exposure))
            ? Number(r.exposure)
            : 0,
        }));
      }
    }

    const normalizedEventType = Number(
      liveMatchMarket?.event_type ??
      liveMatchMarket?.eventType ??
      matchOdds?.event_type ??
      matchOdds?.eventType ??
      eventData?.[0]?.event_type ??
      eventData?.[0]?.eventType ??
      (String(eventType).toLowerCase() === "cricket"
        ? 4
        : String(eventType).toLowerCase() === "tennis"
          ? 2
          : String(eventType).toLowerCase() === "soccer" ||
            String(eventType).toLowerCase() === "football"
            ? 1
            : 0),
    );

    const normalizedEventName =
      liveMatchMarket?.event_name ||
      liveMatchMarket?.eventName ||
      eventData?.[0]?.event_name ||
      eventData?.[0]?.eventName ||
      eventName ||
      "";

    const normalizedOpenDate =
      liveMatchMarket?.open_date ||
      liveMatchMarket?.openDate ||
      eventData?.[0]?.open_date ||
      eventData?.[0]?.openDate ||
      openDate ||
      "";

    const normalizedIsInplay =
      liveMatchMarket?.is_inplay ??
      liveMatchMarket?.inplay ??
      eventData?.[0]?.is_inplay ??
      false;

    const allCurrentMarkets =
      liveMatchMarket?.market_types ||
      liveMatchMarket?.marketTypes ||
      marketTypes ||
      [];

    const clickedMarket =
      allCurrentMarkets.find((market) => {
        return (
          String(market?.market_id || market?.marketId || "") ===
          String(market_id)
        );
      }) || null;

    const clickedRunner =
      (clickedMarket?.marketRunners || clickedMarket?.runners || []).find(
        (runner) => {
          return (
            String(runner?.selection_id || runner?.selectionId || "") ===
            String(selection_id)
          );
        },
      ) || null;

    setBetPlaceData({
      event_id: String(event_id),
      event_type: normalizedEventType,
      event_name: normalizedEventName,
      open_date: normalizedOpenDate,
      is_inplay: normalizedIsInplay,

      market_id: String(market_id),
      market_name:
        market_name ||
        clickedMarket?.market_name ||
        clickedMarket?.marketName ||
        "Match Odds",

      market_type: market_type || "match_odds",

      is_back: is_back ? 1 : 0,
      price: Number(priceNew),
      is_fancy: is_fancy,

      selection_id: String(selection_id),

      runner_name:
        runner_name ||
        clickedRunner?.runner_name ||
        clickedRunner?.runnerName ||
        "",

      runner_status: clickedRunner?.status || "",

      back_1_price: clickedRunner?.back_1_price ?? null,

      lay_1_price: clickedRunner?.lay_1_price ?? null,

      PM_FANCY: PM_FANCY,
      runners: runnersArr,
    });
    setShowPlaceBetPopup(true);

    setTimeout(function () {
      SetPosition(0, priceNew, market_id, is_back, selection_id);
      calc(0, priceNew, selection_id);
      placeStakeValue(defaultStake);
    }, 800);
  };

  function formatPrice(price) {
    if (price < 1000) {
      return price;
    }
    const suffixes = ["", "k", "M", "B"];
    const tier = Math.floor(Math.log10(price) / 3);
    const suffix = suffixes[tier];
    const scaledPrice = price / Math.pow(10, tier * 3);
    return `${scaledPrice}${suffix}`;
  }

  function betPlace(ishow) {
    if (userInfo) {
      if (userInfo.user_type == "User") {
        // if (balance > (BetPlaceData.is_fancy ? StakeValue : lossValue)) {
        // console.log({
        //     'balance': balance,
        //     'StakeValue': StakeValue,
        //     'lossValue': lossValue,
        //     'is_fancy' : BetPlaceData.is_fancy
        // });

        setPlacing(true);
        setIsLoading(true);

        // var data = JSON.stringify({
        //   user_id: userInfo._id,
        //   match_id: BetPlaceData.event_id,
        //   selection_id: BetPlaceData.selection_id,
        //   is_back: BetPlaceData.is_back,
        //   stake: StakeValue,
        //   price_val: BetPlaceData.price,
        //   market_id: BetPlaceData.market_id,
        //   is_fancy: BetPlaceData.is_fancy == 1 ? "Yes" : "No",
        //   market_name: "Match odds",
        //   profit: ProfitValue,
        //   loss: lossValue,
        //   pm_fancy: BetPlaceData.PM_FANCY,
        // });

        const betPayload = {
          user_id: String(userInfo._id),

          match_id: String(BetPlaceData.event_id),
          event_id: String(BetPlaceData.event_id),

          event_type: Number(
            BetPlaceData.event_type ||
            liveMatchMarket?.event_type ||
            liveMatchMarket?.eventType ||
            matchOdds?.event_type ||
            matchOdds?.eventType ||
            eventData?.[0]?.event_type ||
            eventData?.[0]?.eventType ||
            0,
          ),

          event_name:
            BetPlaceData.event_name ||
            liveMatchMarket?.event_name ||
            liveMatchMarket?.eventName ||
            eventData?.[0]?.event_name ||
            eventData?.[0]?.eventName ||
            eventName ||
            "",

          open_date:
            BetPlaceData.open_date ||
            liveMatchMarket?.open_date ||
            liveMatchMarket?.openDate ||
            eventData?.[0]?.open_date ||
            eventData?.[0]?.openDate ||
            openDate ||
            "",

          is_inplay:
            BetPlaceData.is_inplay ??
            liveMatchMarket?.is_inplay ??
            liveMatchMarket?.inplay ??
            false,

          market_id: String(BetPlaceData.market_id),

          market_name: BetPlaceData.market_name || "Match Odds",

          market_type: BetPlaceData.market_type || "match_odds",

          selection_id: String(BetPlaceData.selection_id),

          runner_name: BetPlaceData.runner_name || "",

          runners: Array.isArray(BetPlaceData.runners)
            ? BetPlaceData.runners
            : [],

          runner_status: BetPlaceData.runner_status || "",

          back_1_price: BetPlaceData.back_1_price,

          lay_1_price: BetPlaceData.lay_1_price,

          is_back: Number(BetPlaceData.is_back),

          is_fancy:
            Number(BetPlaceData.is_fancy) === 1 ||
              BetPlaceData.is_fancy === true
              ? "Yes"
              : "No",

          stake: Number(StakeValue),
          price_val: Number(BetPlaceData.price),
          profit: Number(ProfitValue),
          loss: Number(lossValue),

          pm_fancy: Boolean(BetPlaceData.PM_FANCY),
        };

        const missingBetFields = [];

        if (!betPayload.user_id) {
          missingBetFields.push("user_id");
        }

        if (!betPayload.match_id) {
          missingBetFields.push("match_id");
        }

        const isFancyBet =
          betPayload.is_fancy === true ||
          betPayload.is_fancy === "Yes";

        if (!isFancyBet && !betPayload.market_id) {
          missingBetFields.push("market_id");
        }

        if (!betPayload.selection_id) {
          missingBetFields.push("selection_id");
        }

        if (
          !Number.isFinite(betPayload.event_type) ||
          betPayload.event_type <= 0
        ) {
          missingBetFields.push("event_type");
        }

        if (!betPayload.event_name) {
          missingBetFields.push("event_name");
        }

        if (!betPayload.runner_name) {
          missingBetFields.push("runner_name");
        }

        if (missingBetFields.length > 0) {
          console.error("BET PAYLOAD MISSING FIELDS:", {
            missingBetFields,
            betPayload,
            BetPlaceData,
            liveMatchMarket,
            matchOdds,
            eventData,
          });

          toast.error("Bet data missing: " + missingBetFields.join(", "));

          setIsLoading(false);
          setPlacing(false);
          return;
        }

        console.log("FINAL ADD BETTING PAYLOAD:", betPayload);

        const config = {
          method: "post",
          url: `${Appconfig.apiUrl}betting/addBetting`,
          headers: {
            "Content-Type": "application/json",
          },
          data: betPayload,
        };
        // alert("success");
        axios(config)
          .then(function (response) {
            dispatch(setData(new Date().toISOString()));

            try {
              setPlacing(false);
              setSelection_id("");
              setHtmlId("");
              setProfitValue(0);
              setStakeValue(0);
              setShowBetsSlip(false);

              var data;
              if (userInfo) {
                data = {
                  user_id: userInfo._id,
                  event_id: event_id,
                };
              }
              dispatch(getMatchData(data));
              // getEvents()
              // getFancyData()
              if (userInfo) {
                getFancysExposure();
              }

              if (response.data.result == 0) {
                // console.log('response:', response.data.resultMessage)
                toast.error(response.data.resultMessage);
              } else {
                setShowSuccessPopup(true);
                // Close the place bet popup
                setShowPlaceBetPopup(false);

                getOpenBetsByEvent();

                if (response.data.resultData[0].is_back == 1) {
                  // console.log('place_name:', response.data.resultData[0].place_name)
                  // console.log('stake:', response.data.resultData[0].stake)
                  // console.log('price_val:', response.data.resultData[0].price_val)
                }
                if (response.data.resultData[0].is_back == 0) {
                  // console.log('place_name:', response.data.resultData[0].place_name)
                  // console.log('stake:', response.data.resultData[0].stake)
                  // console.log('price_val:', response.data.resultData[0].price_val)
                }
                setIsBetPlaced(!isBetPlaced);
              }
              var MId = BetPlaceData.market_id.replace(".", "");
              var selectionId = BetPlaceData.selection_id;
              var runners = document.getElementsByClassName("position_" + MId);
              for (var item of runners) {
                var selecid = item.getAttribute("data-id");
                document.getElementById(
                  selecid + "_maxprofit_list_loss_runner_next_" + MId,
                ).innerHTML = "";
                document.getElementById(
                  selecid + "_maxprofit_Mlist_loss_runner_next_" + MId,
                ).innerHTML = "";
              }
              // setBetPlaceData({
              //   event_id: "",
              //   market_id: "",
              //   is_back: "",
              //   price: "",
              //   is_fancy: "",
              //   selection_id: "",
              //   runner_name: "",
              // });

              setBetPlaceData({
                event_id: "",
                event_type: "",
                event_name: "",
                open_date: "",
                is_inplay: false,

                market_id: "",
                market_name: "",
                market_type: "",

                is_back: "",
                price: "",
                is_fancy: "",
                selection_id: "",
                runner_name: "",
                runner_status: "",

                back_1_price: null,
                lay_1_price: null,

                PM_FANCY: false,
                runners: [],
              });
            } catch (e) {
              console.log(e.message);
            }
            setIsLoading(false);
          })
          .catch(function (error) {
            console.log(error);
            console.log(error.message);
            setIsLoading(false);
            setPlacing(false);
          });
        // } else {
        //   toast.error("Insufficient Balance");
        // }
      }
    } else {
      navigate("/login");
    }
  }

  const handleClosePlaceBet = () => {
    setShowPlaceBetPopup(false);
  };

  const handleLiveClick = (e) => {
    e.preventDefault();
    setShowIframe((prevShowIframe) => !prevShowIframe);
  };

  const handleMarketClick = () => {
    setShowMatchStatus(true); // Show match status
    setShowOpenBets(false); // Hide open bets
    setShowIframe(false); // Hide iframe
  };

  const handleOpenBets = () => {
    setShowOpenBets(true); // Toggle Open Bets visibility
    setShowMatchStatus(false); // Hide match status when open bets are shown
  };

  const handleOpenRules = () => {
    navigate("/rules");
  };

  // ...inside your component, before return...
  let team1 = "";
  let team2 = "";
  if (eventName) {
    const teams = eventName.split(/ vs | VS | Vs | v | V |-/i);
    if (teams.length >= 2) {
      team1 = teams[0];
      team2 = teams[1];
    }
  }

  const handleRateZeroClick = () => {
    setShowRateZeroPopup(true);
  };

  const headingEventName =
    eventName ||
    liveMatchMarket?.event_name ||
    liveMatchMarket?.eventName ||
    eventData?.[0]?.event_name ||
    eventData?.[0]?.eventName ||
    "";

  const headingOpenDate =
    openDate ||
    liveMatchMarket?.open_date ||
    liveMatchMarket?.openDate ||
    eventData?.[0]?.open_date ||
    eventData?.[0]?.openDate ||
    "";

  return (
    <div>
      <Header
        showMenu={showMenu}
        handleToggleMenu={handleToggleMenu}
        isMobile={isMobile}
      />
      <div style={{ position: "fixed", zIndex: "2", width: "100%" }}>
        <ScrollGames
          setEventType={setEventType}
          eventType={eventType}
          isMobile={isMobile} // <-- Pass isMobile here
        />
      </div>
      <div className="main-content-wrapper">
        {isMobile ? (
          <>
            {/* Overlay */}
            <div
              className="sidemenu-overlay"
              style={{ display: showMenu ? "block" : "none" }}
              onClick={() => setShowMenu(false)}
            />
            {/* SideMenu Drawer */}
            <div
              className={`sidemenu-mobile${showMenu ? " open" : ""}`}
              onClick={(e) => e.stopPropagation()}
            >
              <SideMenu
                handleToggleMenu={handleToggleMenu}
                isMobile={isMobile}
                props={{ setEventType }}
              />
            </div>
            <Modal
              title={"Book"}
              className="book-model"
              onCancel={() => setBookModalOpen(false)}
              footer={null}
              open={bookModalOpen}
            >
              <div style={{ padding: "5px", color: "#23282c" }}>
                <div
                  style={{
                    display: "grid",
                    border: "2px solid #333",
                    borderTop: "1px solid #333",
                    width: "100%",
                  }}
                >
                  <div style={{ backgroundColor: "#e0e6e6", width: "100%" }}>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "5px",
                          borderRight: "1px solid #000",
                        }}
                      >
                        <span style={{ color: "black", fontWeight: "bold" }}>
                          {" "}
                          Run
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "5px",
                          borderRight: "1px solid #000",
                        }}
                      >
                        <span style={{ color: "black", fontWeight: "bold" }}>
                          {" "}
                          Amount
                        </span>
                      </div>
                    </div>
                  </div>

                  {postionFancyList.length > 0 ? (
                    postionFancyList.map((item, index) => {
                      if (item < 0)
                        return (
                          <>
                            <div
                              style={{
                                backgroundColor: "#e0e6e6",
                                width: "100%",
                              }}
                            >
                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: "1fr 1fr",
                                  width: "100%",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "5px",
                                    borderRight: "1px solid #000",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "black",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {" "}
                                    {index}
                                  </span>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "5px",
                                    borderRight: "1px solid #000",
                                  }}
                                >
                                  <span
                                    style={{ color: "red", fontWeight: "bold" }}
                                    data-value={item}
                                  >
                                    {" "}
                                    {item}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      if (item >= 0 && item != null)
                        return (
                          <>
                            <div
                              style={{
                                backgroundColor: "#e0e6e6",
                                width: "100%",
                              }}
                            >
                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: "1fr 1fr",
                                  width: "100%",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "5px",
                                    borderRight: "1px solid #000",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "black",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {" "}
                                    {index}
                                  </span>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "5px",
                                    borderRight: "1px solid #000",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "green",
                                      fontWeight: "bold",
                                    }}
                                    data-value={item}
                                  >
                                    {" "}
                                    {item}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                    })
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        fontWeight: "bold",
                        textAlign: "center",
                        borderTop: "1px solid",
                        borderColor: "black",
                      }}
                    >
                      No data!
                    </div>
                  )}
                </div>
              </div>
            </Modal>

            <div className="matchupdates-container">
              {/* <div className="match-update-header">
              <div className="inside-content">
                <FaPlayCircle size={15} color="white" style={{ marginRight: 5, marginLeft: 5, marginTop: 3 }} />
                <span>{eventName ? eventName : ''}</span>
                <p>{openDate ? openDate : ''}</p>
              </div>
              <IoInformationCircleOutline size={15} color="white" style={{ marginRight: 5, marginLeft: 0, marginTop: 10 }} />
            </div>

            <div className="header-part-2">
              <a href="#" onClick={handleMarketClick}>MARKET</a>
              <a href="#" onClick={handleLiveClick}>
                LIVE <MdLiveTv size={15} color="white" style={{ marginBottom: 2, marginLeft: 2 }} />
              </a>
              <a href="#" onClick={handleOpenBets}>OPEN BETS</a>
            </div> */}

              <div className="match-header-container">
                {/* Top Ribbon */}
                {/* <div className="ribbon-wrapper">
                  <div className="ribbon">
                    <span className="event-name">{eventName ? eventName : ""}</span>
                    <span className="event-time">{openDate ? openDate : ""}</span>

                    <svg
                      className="ribbon-wave"
                      xmlns="http://www.w3.org/2000/svg"
                      width="100"
                      height="26"
                      viewBox="0 0 190 26"
                    >
                      <path
                        d="M0.208334 0.899998C3.00833 1.4 9.20833 2.6 14.2083 3.4C28.1083 5.9 33.9083 7.6 51.1083 13.9C73.9083 22.5 79.5833 24.7999 93 25.5C107.692 25.4999 116.508 23.5 132.708 17.2C156.308 8 166.008 4.8 177.408 2.4L189.208 0H92.2083C30.8083 0 -2.99167 0.4 0.208334 0.899998Z"
                        fill="#c1092f"
                      />
                    </svg>

                    <div className="ribbon-deco left" />
                    <div className="ribbon-deco right" />
                  </div>
                </div> */}

                {/* Top Icons */}
                {/* <div className="header-icons">
                  <div
                    className="live-icon"
                    onClick={() => {
                      setShowLtv((prev) => !prev);
                    }}
                  >
                    {isInplay && (
                      <>
                        <span className="ping" />
                        <span className="dot" />
                      </>
                    )}
                    <img
                      src="https://bx-s3-dev-001.s3.ap-southeast-1.amazonaws.com/icons/tv.svg"
                      alt="TV Icon"
                    />
                  </div>
                  <div className="info-icon" onClick={() => handleOpenRules()}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="#6D081D"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="16" x2="12" y2="12" />
                      <line x1="12" y1="8" x2="12.01" y2="8" />
                    </svg>
                  </div>
                </div> */}

                {/* Teams Row */}
                {/* <div className="teams-row">
                  {team1 && team2 ? (
                    <>
                      <div className="team-name left">{team1.trim()}</div>
                      <div className="vs">vs</div>
                      <div className="team-name right">{team2.trim()}</div>
                    </>
                  ) : (
                    <div className="team-name single">{eventName}</div>
                  )}
                </div> */}
                <div className="flex flex-col w-full">
                  <div className="flex flex-row w-full justify-between items-center px-2 mt-2 bg-bg_appBg rounded-sm py-2">
                    <div
                      id="playIcon"
                      className="flex items-center justify-start gap-x-3 w-[92%]"
                    >
                      <span className="min-w-[4%]">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 21 20"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_1717_31137)">
                            <path
                              d="M10.5 19.8571C8.55041 19.8571 6.64463 19.279 5.02363 18.1959C3.40264 17.1128 2.13922 15.5733 1.39316 13.7721C0.647093 11.971 0.451889 9.98903 0.832229 8.07694C1.21257 6.16484 2.15137 4.40846 3.52992 3.02992C4.90846 1.65137 6.66484 0.712569 8.57694 0.332229C10.489 -0.0481111 12.471 0.147093 14.2721 0.893157C16.0733 1.63922 17.6128 2.90264 18.6959 4.52363C19.779 6.14463 20.3571 8.05041 20.3571 9.99997C20.3541 12.6133 19.3146 15.1188 17.4667 16.9667C15.6188 18.8146 13.1133 19.8541 10.5 19.8571ZM10.5 1.5714C8.83296 1.5714 7.20338 2.06572 5.81731 2.99187C4.43123 3.91801 3.35092 5.23437 2.71298 6.77449C2.07505 8.31461 1.90813 10.0093 2.23335 11.6443C2.55857 13.2793 3.36131 14.7811 4.54007 15.9599C5.71883 17.1386 7.22065 17.9414 8.85564 18.2666C10.4906 18.5918 12.1853 18.4249 13.7254 17.787C15.2656 17.149 16.5819 16.0687 17.5081 14.6826C18.4342 13.2966 18.9285 11.667 18.9285 9.99997C18.926 7.76536 18.0371 5.62302 16.457 4.04291C14.8769 2.4628 12.7346 1.57397 10.5 1.5714Z"
                              fill="url(#paint0_linear_1717_31137)"
                            ></path>
                            <path
                              d="M15.6915 11.5172H10.5629C10.3735 11.5172 10.1918 11.4419 10.0578 11.308C9.92389 11.174 9.84863 10.9923 9.84863 10.8029V5.67376C9.84863 5.48432 9.92389 5.30264 10.0578 5.16868C10.1918 5.03473 10.3735 4.95947 10.5629 4.95947C10.7524 4.95947 10.934 5.03473 11.068 5.16868C11.2019 5.30264 11.2772 5.48432 11.2772 5.67376V10.0886H15.6915C15.8809 10.0886 16.0626 10.1639 16.1966 10.2978C16.3305 10.4318 16.4058 10.6135 16.4058 10.8029C16.4058 10.9923 16.3305 11.174 16.1966 11.308C16.0626 11.4419 15.8809 11.5172 15.6915 11.5172Z"
                              fill="url(#paint1_linear_1717_31137)"
                            ></path>
                          </g>
                          <defs>
                            <linearGradient
                              id="paint0_linear_1717_31137"
                              x1="0.642822"
                              y1="21.0893"
                              x2="22.3721"
                              y2="18.475"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="var(--icon-color-brand-secondary)"></stop>
                              <stop
                                offset="1"
                                stopColor="var(--icon-color-brand-secondary)"
                              ></stop>
                            </linearGradient>
                            <linearGradient
                              id="paint1_linear_1717_31137"
                              x1="9.84863"
                              y1="11.927"
                              x2="17.076"
                              y2="11.0576"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="var(--icon-color-brand-secondary)"></stop>
                              <stop
                                offset="1"
                                stopColor="var(--icon-color-brand-secondary)"
                              ></stop>
                            </linearGradient>
                            <clipPath id="clip0_1717_31137">
                              <rect
                                width="20"
                                height="20"
                                fill="white"
                                transform="translate(0.5)"
                              ></rect>
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                      <span className="bg-bg_text_brand_primary text-transparent bg-clip-text font-lato text-base font-bold">
                        <span className="capitalize w-max break-words">
                          {headingEventName || "Match details"}
                        </span>
                        {/* {team2 && (
                          <>
                            <span className="ml-[2px]">vs</span>
                            <span className="capitalize w-max ml-[2px] break-words">{team2}</span>
                          </>
                        )} */}
                      </span>
                    </div>
                    <div className="flex items-center justify-center gap-x-2">
                      <span className="w-max break-words bg-bg_text_brand_primary text-transparent bg-clip-text font-lato text-xs font-bold">
                        {headingOpenDate}
                      </span>
                      <span onClick={() => handleOpenRules()}>
                        <svg
                          width="17"
                          height="17"
                          viewBox="0 0 17 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_1717_31141)">
                            <path
                              d="M8.5 0.5C4.07841 0.5 0.5 4.078 0.5 8.5C0.5 12.9215 4.078 16.5 8.5 16.5C12.9216 16.5 16.5 12.922 16.5 8.5C16.5 4.07847 12.922 0.5 8.5 0.5ZM8.5 15.3837C4.70431 15.3837 1.61628 12.2957 1.61628 8.5C1.61628 4.70428 4.70431 1.61628 8.5 1.61628C12.2957 1.61628 15.3837 4.70428 15.3837 8.5C15.3837 12.2957 12.2957 15.3837 8.5 15.3837Z"
                              fill="var(--icon-color-brand-secondary)"
                            ></path>
                            <path
                              d="M8.5003 7.1687C8.02642 7.1687 7.68945 7.36883 7.68945 7.66367V11.6757C7.68945 11.9285 8.02642 12.1812 8.5003 12.1812C8.95311 12.1812 9.32164 11.9285 9.32164 11.6757V7.66361C9.32164 7.36879 8.95311 7.1687 8.5003 7.1687Z"
                              fill="var(--icon-color-brand-secondary)"
                            ></path>
                            <path
                              d="M8.50019 4.69409C8.01578 4.69409 7.63672 5.04159 7.63672 5.44175C7.63672 5.84194 8.01581 6.19997 8.50019 6.19997C8.97406 6.19997 9.35319 5.84194 9.35319 5.44175C9.35319 5.04159 8.97403 4.69409 8.50019 4.69409Z"
                              fill="var(--icon-color-brand-secondary)"
                            ></path>
                          </g>
                          <defs>
                            <clipPath id="clip0_1717_31141">
                              <rect
                                width="16"
                                height="16"
                                fill="white"
                                transform="translate(0.5 0.5)"
                              ></rect>
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div
                title="Live And Open Bets"
                className="lg:hidden w-full bg-bg_color_primary shadow-sm"
              >
                {/* Tab Buttons Container */}
                <div
                  id="step-selectMode"
                  className="relative flex w-full overflow-clip rounded-none bg-bg_color_primary border-none shadow-none gap-x-2.5"
                >
                  <button
                    onClick={() =>
                      setActiveTab(activeTab === "LIVE" ? null : "LIVE")
                    }
                    className={`flex items-center justify-center w-full gap-1.5 tracking-wider font-lato py-2.5 uppercase active:opacity-90 p-3 text-sm font-semibold font-bold text-xs ${activeTab === "LIVE"
                      ? "text-text_brand_primary text-text_color_primary1"
                      : "text-text_color_tertiary1 text-text_color_primary3"
                      }`}
                  >
                    <span>
                      <div className="w-2 h-2 bg-bg_color_brand_primary1 rounded-full"></div>
                    </span>
                    SCORE
                  </button>

                  <button
                    onClick={() =>
                      setActiveTab(activeTab === "OPEN" ? null : "OPEN")
                    }
                    className={`flex items-center justify-center w-full gap-1.5 tracking-wider font-lato py-2.5 uppercase active:opacity-90 p-3 text-sm font-semibold font-bold text-xs ${activeTab === "OPEN"
                      ? "text-text_brand_primary text-text_color_primary1"
                      : "text-text_color_tertiary1 text-text_color_primary3"
                      }`}
                  >
                    OPEN BETS
                    <span>
                      <div>({openBetsCount})</div>
                    </span>
                  </button>

                  {/* Animated underline */}
                  {activeTab && (
                    <div
                      className="absolute z-10 transition-all ease-in-out bg-bg_color_brand_primary1 rounded-lg h-[2px]"
                      style={{
                        zIndex: 9,
                        width: "50%",
                        left: activeTab === "LIVE" ? "0%" : "50%",
                        bottom: 0,
                      }}
                    />
                  )}
                </div>

                {/* Dropdown content - now BELOW the tab buttons */}
                {activeTab === "OPEN" && (
                  <div
                    className={`transition-[max-height,padding] duration-300 ease-in-out overflow-hidden ${activeTab === "OPEN" ? "max-h-[600px]" : "max-h-0 p-0"
                      }`}
                    style={{
                      background: "white",
                      borderRadius: "8px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                      marginTop: "8px",
                    }}
                  >
                    <div
                      style={{
                        maxHeight: 400,
                        overflowY: "auto",
                        scrollBehavior: "smooth",
                      }}
                    >
                      <div className="overflow-x-auto p-1 bg-gray-50 rounded-lg shadow-md">
                        <table className="min-w-full text-sm text-left text-gray-800 bg-white border-separate border-spacing-0">
                          <thead className="bg-[#0c9971] text-white uppercase text-xs">
                            <tr>
                              <th className="px-3 py-2 border-b border-r border-gray-300 first:rounded-tl-lg last:rounded-tr-lg">
                                Event Name
                              </th>
                              <th className="px-3 py-2 border-b border-r border-gray-300">
                                Market Type
                              </th>
                              <th className="px-3 py-2 border-b border-r border-gray-300">
                                Stake
                              </th>
                              <th className="px-3 py-2 border-b border-r border-gray-300">
                                Odd
                              </th>
                              <th className="px-3 py-2 border-b border-gray-300 last:rounded-tr-lg">
                                Bet Type
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {allOpenBets.length > 0 ? (
                              allOpenBets.map((bet, index) => {
                                const isBack =
                                  bet.is_back === true ||
                                  bet.is_back === 1 ||
                                  bet.type === "back";
                                const rowBg = isBack
                                  ? "bg-[#a7d8fd]"
                                  : "bg-[#f9c9d4]";
                                const isLast = index === allOpenBets.length - 1;
                                return (
                                  <tr
                                    key={bet._id}
                                    className={`${rowBg} hover:bg-[#f1fdf9] transition duration-200`}
                                  >
                                    <td
                                      className={`px-3 py-2 border-b border-r border-gray-300 ${isLast ? "rounded-bl-lg" : ""
                                        }`}
                                    >
                                      {bet.event_name}
                                    </td>
                                    <td className="px-3 py-2 border-b border-r border-gray-300">
                                      {bet.market_name}
                                    </td>
                                    <td className="px-3 py-2 border-b border-r border-gray-300">
                                      {bet.stake}
                                    </td>
                                    <td className="px-3 py-2 border-b border-r border-gray-300">
                                      {bet.price_val}
                                    </td>
                                    <td
                                      className={`px-3 py-2 border-b border-gray-300 text-center font-bold ${isLast ? "rounded-br-lg" : ""
                                        }`}
                                    >
                                      {isBack ? "Back" : "Lay"}
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td
                                  colSpan="5"
                                  className="text-center py-6 text-gray-500 border-t border-b border-gray-300"
                                >
                                  No Open Bets Found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div className="col-span-1">
                <div className="w-full px-2">
                  <button
                    className="inline-block leading-normal relative overflow-hidden transition duration-150 ease-in-out w-full py-2 text-sm my-2 font-semibold text-center text-text_color_primary2 bg-bg_color_watch_enjoy_live_action_btn rounded-md cursor-pointer"
                    type="button"
                    onClick={() => {
                      setTvVisible((prev) => !prev);
                      setShowIframe((prev) => !prev);
                      setShowLtv((prev) => !prev);
                    }}
                  >
                    {tvVisible ? "Hide TV" : "Watch TV Enjoy Live Action..."}
                  </button>
                  <div></div>
                </div>
              </div>

              {tvVisible && (
                <div
                  className="tv-div"
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    margin: "0 auto",
                    padding: "8px",
                  }}
                >
                  <div
                    id="streamingBox"
                    className="tv-fix"
                    style={{
                      width: "100%",
                      maxWidth: "700px",
                      border: "3px solid #0c9971",
                      borderRadius: "8px",
                      overflow: "hidden",
                      background: "#000",
                    }}
                  >
                    <iframe
                      allowFullScreen={true}
                      webkitallowfullscreen="true"
                      mozallowfullscreen="true"
                      contentEditable="false"
                      frameBorder="0"
                      scrolling="yes"
                      id="tvframe"
                      src={tvUrl}
                      style={{
                        width: "100%",
                        height: "200px",
                        minHeight: "180px",
                        maxWidth: "100%",
                        border: "none",
                        background: "#000",
                        display: "",
                      }}
                    ></iframe>
                  </div>
                </div>
              )}

              {/* Desktop: Show score icon and toggle score iframe */}
              {!isMobile && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    margin: "10px 0",
                  }}
                >
                  <img
                    // src={process.env.PUBLIC_URL + '/images/icons8-score-96.png'}
                    src="/images/icons8-score-96.png"
                    alt="Show Score"
                    style={{ cursor: "pointer", width: "32px", height: "32px" }}
                    onClick={() => setShowScoreDesktop((prev) => !prev)}
                  />
                  <span style={{ fontSize: "14px", color: "#c13333" }}>
                    Score
                  </span>
                </div>
              )}
              {/* Desktop: Show score only if toggled */}
              {!isMobile && showScoreDesktop && (
                <div
                  className={`score-wrapper border-[5px] border-[#f9df10] bg-black 
                    w-full h-[150px] mt-${userInfo ? "0" : "4"}`}
                >
                  {scoreBoard && (
                    <div className="w-full h-full">
                      <ScoreBoard scoreBoard={scoreBoard} eventType={4} />
                    </div>
                  )}
                </div>
              )}

              {/* Mobile: Show only on LIVE tab */}
              {isMobile && activeTab === "LIVE" && (
                <div
                  className={`score-wrapper border-[5px] border-[#f9df10] bg-black 
                    w-full h-[150px] mt-${userInfo ? "0" : "4"}`}
                >
                  {scoreBoard && (
                    <div className="w-full h-full">
                      <ScoreBoard scoreBoard={scoreBoard} eventType={4} />
                    </div>
                  )}
                </div>
              )}

              {showOpenBets && (
                <div className="open-bets-section">
                  <h2>Open Bets</h2>
                  <p>No open bets available.</p>
                </div>
              )}

              {/* matchOdds */}

              {eventData.length > 0 && matchOdds && matchOdds.marketRunners && (
                <div className="w-full text-selection-none pb-3 lg:pb-0">
                  <div className="px-2 font-helvetica">
                    <div className="py-1.5">
                      {/* Header Row */}
                      <div className="grid grid-flow-col grid-cols-12 text-text_color_primary1 text-xs font-[500] mb-1.5">
                        <div className="pl-1 flex items-center justify-start gap-x-1 md:gap-x-1 col-span-7 md:col-span-5">
                          <div
                            className="capitalize font-bold text-xs sm:text-sm md:text-[15px] flex items-start justify-start flex-col"
                            title="Match Odds"
                          >
                            <span>Match Odds</span>
                            <span className="text-x font-normal text-text_color_info"></span>
                          </div>
                        </div>
                        <div className="col-span-5 md:col-span-7 grid grid-cols-2 md:grid-cols-6 pb-[2px]">
                          {isMobile ? (
                            <>
                              <span className="col-span-1 text-center text-[10px] sm:text-xs md:text-sm leading-3 font-bold h-full flex items-end justify-center">
                                BACK
                              </span>
                              <span className="col-span-1 text-center text-[10px] sm:text-xs md:text-sm leading-3 font-bold h-full flex items-end justify-center">
                                LAY
                              </span>
                            </>
                          ) : (
                            <>
                              <span className="hidden md:flex col-span-1 text-center font-semibold h-full items-end justify-center"></span>
                              <span className="col-span-1 text-center font-semibold h-full hidden md:flex items-end justify-center"></span>
                              <span className="col-span-1 text-center text-[10px] sm:text-xs md:text-sm leading-3 font-bold h-full flex items-end justify-center">
                                BACK
                              </span>
                              <span className="col-span-1 text-center text-[10px] sm:text-xs md:text-sm leading-3 font-bold h-full flex items-end justify-center">
                                LAY
                              </span>
                              <span className="col-span-1 text-center font-semibold h-full hidden md:flex items-end justify-center"></span>
                              <span className="col-span-1 text-center font-semibold h-full hidden md:flex items-end justify-center"></span>
                            </>
                          )}
                        </div>
                      </div>
                      {/* Runner Rows */}
                      <div className="bg-bg_color_primary rounded-[3px] shadow-[0_8px_30px_rgb(0,0,0,0.12)] py-[1px]">
                        {matchOdds.marketRunners.map((runner, idx) => (
                          <div
                            key={runner.selection_id || idx}
                            className="grid grid-cols-12 border-b border-border_color_primary1"
                          >
                            {/* Team Name */}
                            <div className="w-full md:col-span-5 col-span-7 h-12 grid grid-cols-12 grid-flow-col pl-2.5 md:pl-2 py-0.5 pr-[3px]">
                              <div className="truncate col-span-12 flex items-start justify-center h-full flex-col">
                                <div className="w-full flex flex-wrap">
                                  <div
                                    title={runner.runner_name}
                                    className="flex items-center flex-1 capitalize text-text_color_primary1 text-[13px] md:text-sm font-semibold truncate text-start h-full pr-0.5 md:pr-0"
                                  >
                                    <span className="truncate">
                                      {runner?.runner_name ||
                                        runner?.runnerName ||
                                        "Runner"}
                                    </span>
                                  </div>
                                </div>
                                {/* Exposure/Profit block as requested */}
                                <span
                                  style={{
                                    marginLeft: "5px",
                                    fontSize: "0.688rem",
                                    fontWeight: "bold",
                                    display: "flex",
                                    textAlign: "left",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}
                                >
                                  {/* Only show match odds exposure calculation for match odds bets */}
                                  <span
                                    id={
                                      runner.selection_id +
                                      "_maxprofit_list_loss_runner_prev_" +
                                      (matchOdds && matchOdds.market_id
                                        ? matchOdds.market_id.replace(".", "")
                                        : "")
                                    }
                                    className={`win market-exposure`}
                                    style={{
                                      fontSize: "0.688rem",
                                      fontWeight: "bold",
                                      textAlign: "left",
                                      marginLeft: "5px",
                                      marginRight: "3px",
                                      color:
                                        runner.exposure < 0
                                          ? "#d32f2f"
                                          : "#228b22",
                                    }}
                                    data-value={runner.exposure}
                                  >
                                    {showBetsSlip &&
                                      BetPlaceData &&
                                      BetPlaceData.price &&
                                      StakeValue > 0 &&
                                      BetPlaceData.market_id ===
                                      matchOdds.market_id &&
                                      BetPlaceData.market_type === "match_odds"
                                      ? (() => {
                                        const odds = parseFloat(
                                          BetPlaceData.price,
                                        );
                                        const stake = parseFloat(StakeValue);
                                        let newExposure =
                                          Number(runner.exposure) || 0;
                                        if (BetPlaceData.is_back) {
                                          if (
                                            runner.selection_id ===
                                            BetPlaceData.selection_id
                                          ) {
                                            newExposure += (odds - 1) * stake;
                                          } else {
                                            newExposure -= stake;
                                          }
                                        } else {
                                          if (
                                            runner.selection_id ===
                                            BetPlaceData.selection_id
                                          ) {
                                            newExposure -= (odds - 1) * stake;
                                          } else {
                                            newExposure += stake;
                                          }
                                        }
                                        return Math.round(newExposure);
                                      })()
                                      : Math.round(
                                        Number(runner?.exposure) || 0,
                                      )}
                                  </span>
                                  {/* Arrow */}
                                  {showBetsSlip &&
                                    is_fancy == false &&
                                    BetPlaceData.market_type ===
                                    "match_odds" && (
                                      <>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="10"
                                          height="10"
                                        >
                                          <path
                                            d="M0 3h4v4H0V3zm4 7V0l6 5-6 5z"
                                            fill="#508E0D"
                                            fillRule="evenodd"
                                          />
                                        </svg>
                                        <span
                                          id={
                                            runner.selection_id +
                                            "_maxprofit_Mlist_loss_runner_next_" +
                                            (matchOdds && matchOdds.market_id
                                              ? matchOdds.market_id.replace(
                                                ".",
                                                "",
                                              )
                                              : "")
                                          }
                                          className={`to-win market-exposure`}
                                          style={{
                                            fontSize: "0.688rem",
                                            fontWeight: "bold",
                                            textAlign: "left",
                                            color: (() => {
                                              let newExposure =
                                                Number(runner.exposure) || 0;
                                              if (
                                                showBetsSlip &&
                                                BetPlaceData &&
                                                BetPlaceData.price &&
                                                StakeValue > 0 &&
                                                BetPlaceData.market_type ===
                                                "match_odds"
                                              ) {
                                                const odds = parseFloat(
                                                  BetPlaceData.price,
                                                );
                                                const stake =
                                                  parseFloat(StakeValue);
                                                if (BetPlaceData.is_back) {
                                                  if (
                                                    runner.selection_id ===
                                                    BetPlaceData.selection_id
                                                  ) {
                                                    newExposure +=
                                                      (odds - 1) * stake;
                                                  } else {
                                                    newExposure -= stake;
                                                  }
                                                } else {
                                                  if (
                                                    runner.selection_id ===
                                                    BetPlaceData.selection_id
                                                  ) {
                                                    newExposure -=
                                                      (odds - 1) * stake;
                                                  } else {
                                                    newExposure += stake;
                                                  }
                                                }
                                              }
                                              return newExposure < 0
                                                ? "#d32f2f"
                                                : "#228b22";
                                            })(),
                                          }}
                                          data-value={
                                            showBetsSlip &&
                                              BetPlaceData &&
                                              BetPlaceData.price &&
                                              StakeValue > 0 &&
                                              BetPlaceData.market_type ===
                                              "match_odds"
                                              ? (() => {
                                                const odds = parseFloat(
                                                  BetPlaceData.price,
                                                );
                                                const stake =
                                                  parseFloat(StakeValue);
                                                let newExposure =
                                                  Number(runner.exposure) ||
                                                  0;
                                                if (BetPlaceData.is_back) {
                                                  if (
                                                    runner.selection_id ===
                                                    BetPlaceData.selection_id
                                                  ) {
                                                    newExposure +=
                                                      (odds - 1) * stake;
                                                  } else {
                                                    newExposure -= stake;
                                                  }
                                                } else {
                                                  if (
                                                    runner.selection_id ===
                                                    BetPlaceData.selection_id
                                                  ) {
                                                    newExposure -=
                                                      (odds - 1) * stake;
                                                  } else {
                                                    newExposure += stake;
                                                  }
                                                }
                                                return newExposure.toFixed(2);
                                              })()
                                              : Number(runner.exposure).toFixed(
                                                2,
                                              )
                                          }
                                        >
                                          {showBetsSlip &&
                                            BetPlaceData &&
                                            BetPlaceData.price &&
                                            BetPlaceData.market_type ===
                                            "match_odds"
                                            ? StakeValue > 0
                                              ? (() => {
                                                const odds = parseFloat(
                                                  BetPlaceData.price,
                                                );
                                                const stake =
                                                  parseFloat(StakeValue);
                                                let newExposure =
                                                  Number(runner.exposure) ||
                                                  0;
                                                if (BetPlaceData.is_back) {
                                                  if (
                                                    runner.selection_id ===
                                                    BetPlaceData.selection_id
                                                  ) {
                                                    newExposure +=
                                                      (odds - 1) * stake;
                                                  } else {
                                                    newExposure -= stake;
                                                  }
                                                } else {
                                                  if (
                                                    runner.selection_id ===
                                                    BetPlaceData.selection_id
                                                  ) {
                                                    newExposure -=
                                                      (odds - 1) * stake;
                                                  } else {
                                                    newExposure += stake;
                                                  }
                                                }
                                                return Math.round(
                                                  newExposure,
                                                );
                                              })()
                                              : "0"
                                            : Math.round(
                                              Number(runner?.exposure) || 0,
                                            )}
                                        </span>
                                      </>
                                    )}
                                </span>
                              </div>
                            </div>
                            {/* Odds */}
                            <div className="col-span-5 md:col-span-7 h-12 grid grid-cols-2 md:grid-cols-6 relative">
                              <div className="w-full h-full col-span-6">
                                {isMobile ? (
                                  // MOBILE: Only show BACK 1 and LAY 1
                                  <div className="w-full h-full grid grid-cols-2 gap-x-0.5 py-[1px] pr-[2px]">
                                    {/* BACK 1 */}
                                    <div className="w-full h-full">
                                      <div
                                        className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_backBtnBg text-text_color_oddValue"
                                        style={{
                                          cursor:
                                            runner.back_1_price > 0
                                              ? "pointer"
                                              : "not-allowed",
                                        }}
                                        onClick={() => {
                                          if (runner.back_1_price > 0) {
                                            handleOpenBetSlip(
                                              matchOdds.event_id,
                                              matchOdds.market_id,
                                              true, // is_back
                                              `availableToBack1_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false, // is_fancy
                                              runner.selection_id,
                                              runner.runner_name,
                                              `availableToBack1_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false,
                                              matchOdds.market_name,
                                            );
                                          } else {
                                            handleRateZeroClick();
                                          }
                                        }}
                                      >
                                        <span
                                          id={`availableToBack1_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full leading-5 text-sm md:text-[15px] font-semibold"
                                        >
                                          {runner.back_1_price}
                                        </span>
                                        <span
                                          id={`availableToBack1_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full text-[10px] leading-3 text-center whitespace-normal font-normal"
                                        >
                                          {runner.back_1_size}
                                        </span>
                                      </div>
                                    </div>
                                    {/* LAY 1 */}
                                    <div className="w-full h-full">
                                      <div
                                        className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_layBtnBg text-text_color_oddValue"
                                        style={{
                                          cursor:
                                            runner.lay_1_price > 0
                                              ? "pointer"
                                              : "not-allowed",
                                        }}
                                        onClick={() => {
                                          if (runner.lay_1_price > 0) {
                                            handleOpenBetSlip(
                                              matchOdds.event_id,
                                              matchOdds.market_id,
                                              false, // is_back
                                              `availableToLay1_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false, // is_fancy
                                              runner.selection_id,
                                              runner.runner_name,
                                              `availableToLay1_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false,
                                              matchOdds.market_name,
                                            );
                                          } else {
                                            handleRateZeroClick();
                                          }
                                        }}
                                      >
                                        <span
                                          id={`availableToLay1_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full leading-5 text-sm md:text-[15px] font-semibold"
                                        >
                                          {runner.lay_1_price}
                                        </span>
                                        <span
                                          id={`availableToLay1_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full text-[10px] leading-3 text-center whitespace-normal font-normal"
                                        >
                                          {runner.lay_1_size}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  // DESKTOP: Show all 3 BACK and 3 LAY
                                  <div className="w-full grid grid-cols-12 grid-flow-col overflow-auto h-full gap-x-0.5 py-[1px] pr-[2px]">
                                    {/* BACK 3 */}
                                    <div className="w-full col-span-2 h-full">
                                      <div
                                        className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_backBtnBg text-text_color_oddValue"
                                        style={{
                                          cursor:
                                            runner.back_3_price > 0
                                              ? "pointer"
                                              : "not-allowed",
                                        }}
                                        onClick={() => {
                                          if (runner.back_3_price > 0) {
                                            handleOpenBetSlip(
                                              matchOdds.event_id,
                                              matchOdds.market_id,
                                              true, // is_back
                                              `availableToBack3_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false, // is_fancy
                                              runner.selection_id,
                                              runner.runner_name,
                                              `availableToBack3_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false,
                                              matchOdds.market_name,
                                            );
                                          } else {
                                            handleRateZeroClick();
                                          }
                                        }}
                                      >
                                        <span
                                          id={`availableToBack3_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full leading-5 text-sm md:text-[15px] font-semibold"
                                        >
                                          {runner.back_3_price}
                                        </span>
                                        <span
                                          id={`availableToBack3_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full text-[10px] leading-3 text-center whitespace-normal font-normal"
                                        >
                                          {runner.back_3_size}
                                        </span>
                                      </div>
                                    </div>
                                    {/* BACK 2 */}
                                    <div className="w-full col-span-2 h-full">
                                      <div
                                        className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_backBtnBg text-text_color_oddValue"
                                        style={{
                                          cursor:
                                            runner.back_2_price > 0
                                              ? "pointer"
                                              : "not-allowed",
                                        }}
                                        onClick={() => {
                                          if (runner.back_2_price > 0) {
                                            handleOpenBetSlip(
                                              matchOdds.event_id,
                                              matchOdds.market_id,
                                              true, // is_back
                                              `availableToBack2_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false, // is_fancy
                                              runner.selection_id,
                                              runner.runner_name,
                                              `availableToBack2_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false,
                                              matchOdds.market_name,
                                            );
                                          } else {
                                            handleRateZeroClick();
                                          }
                                        }}
                                      >
                                        <span
                                          id={`availableToBack2_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full leading-5 text-sm md:text-[15px] font-semibold"
                                        >
                                          {runner.back_2_price}
                                        </span>
                                        <span
                                          id={`availableToBack2_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full text-[10px] leading-3 text-center whitespace-normal font-normal"
                                        >
                                          {runner.back_2_size}
                                        </span>
                                      </div>
                                    </div>
                                    {/* BACK 1 */}
                                    <div className="w-full col-span-2 h-full">
                                      <div
                                        className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_backBtnBg text-text_color_oddValue"
                                        style={{
                                          cursor:
                                            runner.back_1_price > 0
                                              ? "pointer"
                                              : "not-allowed",
                                        }}
                                        onClick={() => {
                                          if (runner.back_1_price > 0) {
                                            handleOpenBetSlip(
                                              matchOdds.event_id,
                                              matchOdds.market_id,
                                              true, // is_back
                                              `availableToBack1_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false, // is_fancy
                                              runner.selection_id,
                                              runner.runner_name,
                                              `availableToBack1_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false,
                                              matchOdds.market_name,
                                            );
                                          } else {
                                            handleRateZeroClick();
                                          }
                                        }}
                                      >
                                        <span
                                          id={`availableToBack1_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full leading-5 text-sm md:text-[15px] font-semibold"
                                        >
                                          {runner.back_1_price}
                                        </span>
                                        <span
                                          id={`availableToBack1_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full text-[10px] leading-3 text-center whitespace-normal font-normal"
                                        >
                                          {runner.back_1_size}
                                        </span>
                                      </div>
                                    </div>
                                    {/* LAY 1 */}
                                    <div className="w-full col-span-2 h-full">
                                      <div
                                        className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_layBtnBg text-text_color_oddValue"
                                        style={{
                                          cursor:
                                            runner.lay_1_price > 0
                                              ? "pointer"
                                              : "not-allowed",
                                        }}
                                        onClick={() => {
                                          if (runner.lay_1_price > 0) {
                                            handleOpenBetSlip(
                                              matchOdds.event_id,
                                              matchOdds.market_id,
                                              false, // is_back
                                              `availableToLay1_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false, // is_fancy
                                              runner.selection_id,
                                              runner.runner_name,
                                              `availableToLay1_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false,
                                              matchOdds.market_name,
                                            );
                                          } else {
                                            handleRateZeroClick();
                                          }
                                        }}
                                      >
                                        <span
                                          id={`availableToLay1_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full leading-5 text-sm md:text-[15px] font-semibold"
                                        >
                                          {runner.lay_1_price}
                                        </span>
                                        <span
                                          id={`availableToLay1_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full text-[10px] leading-3 text-center whitespace-normal font-normal"
                                        >
                                          {runner.lay_1_size}
                                        </span>
                                      </div>
                                    </div>
                                    {/* LAY 2 */}
                                    <div className="w-full col-span-2 h-full">
                                      <div
                                        className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_layBtnBg text-text_color_oddValue"
                                        style={{
                                          cursor:
                                            runner.lay_2_price > 0
                                              ? "pointer"
                                              : "not-allowed",
                                        }}
                                        onClick={() => {
                                          if (runner.lay_2_price > 0) {
                                            handleOpenBetSlip(
                                              matchOdds.event_id,
                                              matchOdds.market_id,
                                              false, // is_back
                                              `availableToLay2_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false, // is_fancy
                                              runner.selection_id,
                                              runner.runner_name,
                                              `availableToLay2_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false,
                                              matchOdds.market_name,
                                            );
                                          } else {
                                            handleRateZeroClick();
                                          }
                                        }}
                                      >
                                        <span
                                          id={`availableToLay2_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full leading-5 text-sm md:text-[15px] font-semibold"
                                        >
                                          {runner.lay_2_price}
                                        </span>
                                        <span
                                          id={`availableToLay2_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full text-[10px] leading-3 text-center whitespace-normal font-normal"
                                        >
                                          {runner.lay_2_size}
                                        </span>
                                      </div>
                                    </div>
                                    {/* LAY 3 */}
                                    <div className="w-full col-span-2 h-full">
                                      <div
                                        className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_layBtnBg text-text_color_oddValue"
                                        style={{
                                          cursor:
                                            runner.lay_3_price > 0
                                              ? "pointer"
                                              : "not-allowed",
                                        }}
                                        onClick={() => {
                                          if (runner.lay_3_price > 0) {
                                            handleOpenBetSlip(
                                              matchOdds.event_id,
                                              matchOdds.market_id,
                                              false, // is_back
                                              `availableToLay3_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false, // is_fancy
                                              runner.selection_id,
                                              runner.runner_name,
                                              `availableToLay3_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false,
                                              matchOdds.market_name,
                                            );
                                          } else {
                                            handleRateZeroClick();
                                          }
                                        }}
                                      >
                                        <span
                                          id={`availableToLay3_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full leading-5 text-sm md:text-[15px] font-semibold"
                                        >
                                          {runner.lay_3_price}
                                        </span>
                                        <span
                                          id={`availableToLay3_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full text-[10px] leading-3 text-center whitespace-normal font-normal"
                                        >
                                          {runner.lay_3_size}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Toss */}
              {eventData.length > 0 &&
                eventData.map(
                  (event, index) =>
                    event.marketTypes &&
                    event.marketTypes.length > 0 &&
                    event.marketTypes.map(
                      (market, indexm) =>
                        market.marketRunners &&
                        market.marketRunners.length > 0 &&
                        market.market_name == "Toss" && (
                          <div
                            className="w-full text-selection-none pb-3 lg:pb-0"
                            key={market.market_id}
                          >
                            <div className="px-2 font-helvetica">
                              <div className="py-1.5">
                                {/* Header Row */}
                                <div className="grid grid-flow-col grid-cols-12 text-text_color_primary1 text-xs font-[500] mb-1.5">
                                  <div className="pl-1 flex items-center justify-start gap-x-1 md:gap-x-1 col-span-7 md:col-span-5">
                                    <div
                                      className="capitalize font-bold text-xs sm:text-sm md:text-[15px] flex items-start justify-start flex-col"
                                      title="Toss"
                                    >
                                      <span>Toss Winner</span>
                                      <span className="text-x font-normal text-text_color_info"></span>
                                    </div>
                                  </div>
                                  <div className="col-span-5 md:col-span-7 grid grid-cols-2 md:grid-cols-6 pb-[2px]">
                                    {isMobile ? (
                                      <>
                                        <span className="col-span-1 text-center text-[10px] sm:text-xs md:text-sm leading-3 font-bold h-full flex items-end justify-center">
                                          BACK
                                        </span>
                                        <span className="col-span-1 text-center text-[10px] sm:text-xs md:text-sm leading-3 font-bold h-full flex items-end justify-center">
                                          LAY
                                        </span>
                                      </>
                                    ) : (
                                      <>
                                        <span className="hidden md:flex col-span-1 text-center font-semibold h-full items-end justify-center"></span>
                                        <span className="col-span-1 text-center font-semibold h-full hidden md:flex items-end justify-center"></span>
                                        <span className="col-span-1 text-center text-[10px] sm:text-xs md:text-sm leading-3 font-bold h-full flex items-end justify-center">
                                          BACK
                                        </span>
                                        <span className="col-span-1 text-center text-[10px] sm:text-xs md:text-sm leading-3 font-bold h-full flex items-end justify-center">
                                          LAY
                                        </span>
                                        <span className="col-span-1 text-center font-semibold h-full hidden md:flex items-end justify-center"></span>
                                        <span className="col-span-1 text-center font-semibold h-full hidden md:flex items-end justify-center"></span>
                                      </>
                                    )}
                                  </div>
                                </div>
                                {/* Runner Rows */}
                                <div className="bg-bg_color_primary rounded-[3px] shadow-[0_8px_30px_rgb(0,0,0,0.12)] py-[1px]">
                                  {market.marketRunners
                                    .slice(0, 2)
                                    .map((runner, idx) => (
                                      <div
                                        key={runner.selection_id || idx}
                                        className="grid grid-cols-12 border-b border-border_color_primary1"
                                      >
                                        {/* Team Name */}
                                        <div className="w-full md:col-span-5 col-span-7 h-12 grid grid-cols-12 grid-flow-col pl-2.5 md:pl-2 py-0.5 pr-[3px]">
                                          <div className="truncate col-span-12 flex items-start justify-center h-full flex-col">
                                            <div className="w-full flex flex-wrap">
                                              <div
                                                title={runner.runner_name}
                                                className="flex items-center flex-1 capitalize text-text_color_primary1 text-[13px] md:text-sm font-semibold truncate text-start h-full pr-0.5 md:pr-0"
                                              >
                                                <span className="truncate">
                                                  {String(
                                                    runner?.runner_name ||
                                                    runner?.runnerName ||
                                                    "Runner",
                                                  )
                                                    .split(" ")
                                                    .slice(0, 3)
                                                    .join(" ")}
                                                </span>
                                              </div>
                                            </div>
                                            <span
                                              style={{
                                                marginLeft: "5px",
                                                fontSize: "0.688rem",
                                                color: "#228b22",
                                                fontWeight: "bold",
                                                display: "flex",
                                                textAlign: "left",
                                                alignItems: "center",
                                                gap: "4px",
                                              }}
                                            >
                                              <span
                                                id={
                                                  runner.selection_id +
                                                  "_maxprofit_list_loss_runner_prev_toss_" +
                                                  (market && market.market_id
                                                    ? market.market_id.replace(
                                                      ".",
                                                      "",
                                                    )
                                                    : "")
                                                }
                                                className={`win market-exposure`}
                                                style={{
                                                  fontSize: "0.688rem",
                                                  fontWeight: "bold",
                                                  textAlign: "left",
                                                  marginLeft: "5px",
                                                  marginRight: "3px",
                                                }}
                                                data-value={runner.exposure}
                                              >
                                                {/* Before arrow: show exposure after bet placed (current exposure) */}
                                                {Math.round(
                                                  Number(runner?.exposure) || 0,
                                                )}
                                              </span>
                                              {showBetsSlip &&
                                                is_fancy == false &&
                                                BetPlaceData.market_type ===
                                                "toss" && (
                                                  <>
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="10"
                                                      height="10"
                                                    >
                                                      <path
                                                        d="M0 3h4v4H0V3zm4 7V0l6 5-6 5z"
                                                        fill="#508E0D"
                                                        fillRule="evenodd"
                                                      />
                                                    </svg>
                                                    <span
                                                      id={
                                                        runner.selection_id +
                                                        "_maxprofit_Mlist_loss_runner_next_toss_" +
                                                        (market &&
                                                          market.market_id
                                                          ? market.market_id.replace(
                                                            ".",
                                                            "",
                                                          )
                                                          : "")
                                                      }
                                                      className={`to-win market-exposure `}
                                                      style={{
                                                        fontSize: "0.688rem",
                                                        fontWeight: "bold",
                                                        textAlign: "left",
                                                      }}
                                                      data-value={(() => {
                                                        // After arrow: show zero until amount is selected, then show live calculation
                                                        if (
                                                          showBetsSlip &&
                                                          BetPlaceData &&
                                                          BetPlaceData.price &&
                                                          StakeValue > 0 &&
                                                          market.market_id ===
                                                          BetPlaceData.market_id &&
                                                          BetPlaceData.market_type ===
                                                          "toss"
                                                        ) {
                                                          const odds =
                                                            parseFloat(
                                                              BetPlaceData.price,
                                                            );
                                                          const stake =
                                                            parseFloat(
                                                              StakeValue,
                                                            );
                                                          let newExposure =
                                                            Number(
                                                              runner.exposure,
                                                            ) || 0;
                                                          if (
                                                            BetPlaceData.is_back
                                                          ) {
                                                            if (
                                                              runner.selection_id ===
                                                              BetPlaceData.selection_id
                                                            ) {
                                                              newExposure +=
                                                                (odds - 1) *
                                                                stake;
                                                            } else {
                                                              newExposure -=
                                                                stake;
                                                            }
                                                          } else {
                                                            if (
                                                              runner.selection_id ===
                                                              BetPlaceData.selection_id
                                                            ) {
                                                              newExposure -=
                                                                (odds - 1) *
                                                                stake;
                                                            } else {
                                                              newExposure +=
                                                                stake;
                                                            }
                                                          }
                                                          return newExposure.toFixed(
                                                            2,
                                                          );
                                                        }
                                                        // If no amount selected, show zero
                                                        return "0";
                                                      })()}
                                                    >
                                                      {/* After arrow: show zero until amount is selected, then show live calculation */}
                                                      {showBetsSlip &&
                                                        BetPlaceData &&
                                                        BetPlaceData.price &&
                                                        StakeValue > 0 &&
                                                        market.market_id ===
                                                        BetPlaceData.market_id &&
                                                        BetPlaceData.market_type ===
                                                        "toss"
                                                        ? (() => {
                                                          const odds =
                                                            parseFloat(
                                                              BetPlaceData.price,
                                                            );
                                                          const stake =
                                                            parseFloat(
                                                              StakeValue,
                                                            );
                                                          let newExposure =
                                                            Number(
                                                              runner.exposure,
                                                            ) || 0;
                                                          if (
                                                            BetPlaceData.is_back
                                                          ) {
                                                            if (
                                                              runner.selection_id ===
                                                              BetPlaceData.selection_id
                                                            ) {
                                                              newExposure +=
                                                                (odds - 1) *
                                                                stake;
                                                            } else {
                                                              newExposure -=
                                                                stake;
                                                            }
                                                          } else {
                                                            if (
                                                              runner.selection_id ===
                                                              BetPlaceData.selection_id
                                                            ) {
                                                              newExposure -=
                                                                (odds - 1) *
                                                                stake;
                                                            } else {
                                                              newExposure +=
                                                                stake;
                                                            }
                                                          }
                                                          return Math.round(
                                                            newExposure,
                                                          );
                                                        })()
                                                        : 0}
                                                    </span>
                                                  </>
                                                )}
                                            </span>
                                          </div>
                                        </div>
                                        {/* Odds */}
                                        <div className="col-span-5 md:col-span-7 h-12 grid grid-cols-2 md:grid-cols-6 relative">
                                          <div className="w-full h-full col-span-6">
                                            {isMobile ? (
                                              // MOBILE: Only show BACK 1 and LAY 1
                                              <div className="w-full h-full grid grid-cols-2 gap-x-0.5 py-[1px] pr-[2px]">
                                                {/* BACK 1 */}
                                                <div className="w-full h-full">
                                                  <div
                                                    className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_backBtnBg text-text_color_oddValue"
                                                    style={{
                                                      cursor:
                                                        runner.back_1_price > 0
                                                          ? "pointer"
                                                          : "not-allowed",
                                                    }}
                                                    onClick={() => {
                                                      if (
                                                        runner.back_1_price > 0
                                                      ) {
                                                        handleOpenBetSlip(
                                                          event.event_id,
                                                          market.market_id,
                                                          true,
                                                          `availableTossBackSize_${market.market_id.replace(".", "")}_${runner.selection_id}`,
                                                          false,
                                                          runner.selection_id,
                                                          runner.runner_name,
                                                          `availableTossBackPrice_${market.market_id.replace(".", "")}_${runner.selection_id}`,
                                                          false,
                                                          market.market_name,
                                                        );
                                                      } else {
                                                        handleRateZeroClick();
                                                      }
                                                    }}
                                                  >
                                                    <span
                                                      id={`availableTossBackPrice_${market.market_id.replace(".", "")}_${runner.selection_id}`}
                                                      style={{
                                                        fontWeight: 600,
                                                      }}
                                                    >
                                                      {runner?.back_1_price}
                                                    </span>
                                                    <span
                                                      id={`availableTossBackSize_${market.market_id.replace(".", "")}_${runner.selection_id}`}
                                                      style={{
                                                        fontSize: "10px",
                                                        marginLeft: 0,
                                                      }}
                                                    >
                                                      {runner?.back_1_size}
                                                    </span>
                                                  </div>
                                                </div>
                                                {/* LAY 1 */}
                                                <div className="w-full h-full">
                                                  <div
                                                    className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_layBtnBg text-text_color_oddValue"
                                                    style={{
                                                      cursor:
                                                        runner.lay_1_price > 0
                                                          ? "pointer"
                                                          : "not-allowed",
                                                    }}
                                                    onClick={() => {
                                                      if (
                                                        runner.lay_1_price > 0
                                                      ) {
                                                        handleOpenBetSlip(
                                                          event.event_id,
                                                          market.market_id,
                                                          false,
                                                          `availableTossLaySize_${market.market_id.replace(".", "")}_${runner.selection_id}`,
                                                          false,
                                                          runner.selection_id,
                                                          runner.runner_name,
                                                          `availableTossLayPrice_${market.market_id.replace(".", "")}_${runner.selection_id}`,
                                                          false,
                                                          market.market_name,
                                                        );
                                                      } else {
                                                        handleRateZeroClick();
                                                      }
                                                    }}
                                                  >
                                                    <span
                                                      id={`availableTossLayPrice_${market.market_id.replace(".", "")}_${runner.selection_id}`}
                                                      style={{
                                                        fontWeight: 600,
                                                      }}
                                                    >
                                                      {runner?.lay_1_price}
                                                    </span>
                                                    <span
                                                      id={`availableTossLaySize_${market.market_id.replace(".", "")}_${runner.selection_id}`}
                                                      style={{
                                                        fontSize: "10px",
                                                        marginLeft: 0,
                                                      }}
                                                    >
                                                      {runner?.lay_1_size}
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            ) : (
                                              // DESKTOP: Show all 3 BACK and 3 LAY (only 1 for toss, so repeat 3 times for layout)
                                              <div className="w-full grid grid-cols-12 grid-flow-col overflow-auto h-full gap-x-0.5 py-[1px] pr-[2px]">
                                                {/* BACK 3 */}
                                                <div className="w-full col-span-2 h-full">
                                                  <div
                                                    className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_backBtnBg text-text_color_oddValue"
                                                    style={{ opacity: 0.5 }}
                                                  >
                                                    <span>&nbsp;</span>
                                                    <span>&nbsp;</span>
                                                  </div>
                                                </div>
                                                {/* BACK 2 */}
                                                <div className="w-full col-span-2 h-full">
                                                  <div
                                                    className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_backBtnBg text-text_color_oddValue"
                                                    style={{ opacity: 0.5 }}
                                                  >
                                                    <span>&nbsp;</span>
                                                    <span>&nbsp;</span>
                                                  </div>
                                                </div>
                                                {/* BACK 1 */}
                                                <div className="w-full col-span-2 h-full">
                                                  <div
                                                    className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_backBtnBg text-text_color_oddValue"
                                                    style={{
                                                      cursor:
                                                        runner.back_1_price > 0
                                                          ? "pointer"
                                                          : "not-allowed",
                                                    }}
                                                    onClick={() => {
                                                      if (
                                                        runner.back_1_price > 0
                                                      ) {
                                                        handleOpenBetSlip(
                                                          event.event_id,
                                                          market.market_id,
                                                          true,
                                                          `availableTossBackSize_${market.market_id.replace(".", "")}_${runner.selection_id}`,
                                                          false,
                                                          runner.selection_id,
                                                          runner.runner_name,
                                                          `availableTossBackPrice_${market.market_id.replace(".", "")}_${runner.selection_id}`,
                                                          false,
                                                          market.market_name,
                                                        );
                                                      } else {
                                                        handleRateZeroClick();
                                                      }
                                                    }}
                                                  >
                                                    <span
                                                      id={`availableTossBackPrice_${market.market_id.replace(".", "")}_${runner.selection_id}`}
                                                      style={{
                                                        fontWeight: 600,
                                                      }}
                                                    >
                                                      {runner?.back_1_price}
                                                    </span>
                                                    <span
                                                      id={`availableTossBackSize_${market.market_id.replace(".", "")}_${runner.selection_id}`}
                                                      style={{
                                                        fontSize: "10px",
                                                        marginLeft: 0,
                                                      }}
                                                    >
                                                      {runner?.back_1_size}
                                                    </span>
                                                  </div>
                                                </div>
                                                {/* LAY 1 */}
                                                <div className="w-full col-span-2 h-full">
                                                  <div
                                                    className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_layBtnBg text-text_color_oddValue"
                                                    style={{
                                                      cursor:
                                                        runner.lay_1_price > 0
                                                          ? "pointer"
                                                          : "not-allowed",
                                                    }}
                                                    onClick={() => {
                                                      if (
                                                        runner.lay_1_price > 0
                                                      ) {
                                                        handleOpenBetSlip(
                                                          event.event_id,
                                                          market.market_id,
                                                          false,
                                                          `availableTossLaySize_${market.market_id.replace(".", "")}_${runner.selection_id}`,
                                                          false,
                                                          runner.selection_id,
                                                          runner.runner_name,
                                                          `availableTossLayPrice_${market.market_id.replace(".", "")}_${runner.selection_id}`,
                                                          false,
                                                          market.market_name,
                                                        );
                                                      } else {
                                                        handleRateZeroClick();
                                                      }
                                                    }}
                                                  >
                                                    <span
                                                      id={`availableTossLayPrice_${market.market_id.replace(".", "")}_${runner.selection_id}`}
                                                      style={{
                                                        fontWeight: 600,
                                                      }}
                                                    >
                                                      {runner?.lay_1_price}
                                                    </span>
                                                    <span
                                                      id={`availableTossLaySize_${market.market_id.replace(".", "")}_${runner.selection_id}`}
                                                      style={{
                                                        fontSize: "10px",
                                                        marginLeft: 0,
                                                      }}
                                                    >
                                                      {runner?.lay_1_size}
                                                    </span>
                                                  </div>
                                                </div>
                                                {/* LAY 2 */}
                                                <div className="w-full col-span-2 h-full">
                                                  <div
                                                    className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_layBtnBg text-text_color_oddValue"
                                                    style={{ opacity: 0.5 }}
                                                  >
                                                    <span>&nbsp;</span>
                                                    <span>&nbsp;</span>
                                                  </div>
                                                </div>
                                                {/* LAY 3 */}
                                                <div className="w-full col-span-2 h-full">
                                                  <div
                                                    className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_layBtnBg text-text_color_oddValue"
                                                    style={{ opacity: 0.5 }}
                                                  >
                                                    <span>&nbsp;</span>
                                                    <span>&nbsp;</span>
                                                  </div>
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        ),
                    ),
                )}

              {/* bookmaker */}
              {eventData.length > 0 && bookmaker && bookmaker.marketRunners && (
                <div className="w-full text-selection-none pb-3 lg:pb-0">
                  <div className="px-2 font-helvetica">
                    <div className="py-1.5">
                      {/* Header Row */}
                      <div className="grid grid-flow-col grid-cols-12 text-text_color_primary1 text-xs font-[500] mb-1.5">
                        <div className="pl-1 flex items-center justify-start gap-x-1 md:gap-x-1 col-span-7 md:col-span-5">
                          <div
                            className="capitalize font-bold text-xs sm:text-sm md:text-[15px] flex items-start justify-start flex-col"
                            title="Bookmaker"
                          >
                            <span>Bookmaker</span>
                            <span className="text-x font-normal text-text_color_info"></span>
                          </div>
                        </div>
                        <div className="col-span-5 md:col-span-7 grid grid-cols-2 md:grid-cols-6 pb-[2px]">
                          {isMobile ? (
                            <>
                              <span className="col-span-1 text-center text-[10px] sm:text-xs md:text-sm leading-3 font-bold h-full flex items-end justify-center">
                                BACK
                              </span>
                              <span className="col-span-1 text-center text-[10px] sm:text-xs md:text-sm leading-3 font-bold h-full flex items-end justify-center">
                                LAY
                              </span>
                            </>
                          ) : (
                            <>
                              <span className="hidden md:flex col-span-1 text-center font-semibold h-full items-end justify-center"></span>
                              <span className="col-span-1 text-center font-semibold h-full hidden md:flex items-end justify-center"></span>
                              <span className="col-span-1 text-center text-[10px] sm:text-xs md:text-sm leading-3 font-bold h-full flex items-end justify-center">
                                BACK
                              </span>
                              <span className="col-span-1 text-center text-[10px] sm:text-xs md:text-sm leading-3 font-bold h-full flex items-end justify-center">
                                LAY
                              </span>
                              <span className="col-span-1 text-center font-semibold h-full hidden md:flex items-end justify-center"></span>
                              <span className="col-span-1 text-center font-semibold h-full hidden md:flex items-end justify-center"></span>
                            </>
                          )}
                        </div>
                      </div>
                      {/* Runner Rows */}
                      <div className="bg-bg_color_primary rounded-[3px] shadow-[0_8px_30px_rgb(0,0,0,0.12)] py-[1px]">
                        {bookmaker.marketRunners.map((runner, idx) => (
                          <div
                            key={runner.selection_id || idx}
                            className="grid grid-cols-12 border-b border-border_color_primary1"
                          >
                            {/* Team Name */}
                            <div className="w-full md:col-span-5 col-span-7 h-12 grid grid-cols-12 grid-flow-col pl-2.5 md:pl-2 py-0.5 pr-[3px]">
                              <div className="truncate col-span-12 flex items-start justify-center h-full flex-col">
                                <div className="w-full flex flex-wrap">
                                  <div
                                    title={runner.runner_name}
                                    className="flex items-center flex-1 capitalize text-text_color_primary1 text-[13px] md:text-sm font-semibold truncate text-start h-full pr-0.5 md:pr-0"
                                  >
                                    <span className="truncate">
                                      {runner?.runner_name ||
                                        runner?.runnerName ||
                                        "Runner"}
                                    </span>
                                  </div>
                                </div>
                                {/* Exposure/Profit block for Bookmaker */}
                                <span
                                  style={{
                                    marginLeft: "5px",
                                    fontSize: "0.688rem",
                                    fontWeight: "bold",
                                    display: "flex",
                                    textAlign: "left",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}
                                >
                                  {/* Only show bookmaker exposure calculation for bookmaker bets */}
                                  <span
                                    id={
                                      runner.selection_id +
                                      "_maxprofit_list_loss_runner_prev_" +
                                      (bookmaker && bookmaker.market_id
                                        ? bookmaker.market_id.replace(".", "")
                                        : "")
                                    }
                                    className={`win market-exposure`}
                                    style={{
                                      fontSize: "0.688rem",
                                      fontWeight: "bold",
                                      textAlign: "left",
                                      marginLeft: "5px",
                                      marginRight: "3px",
                                      color:
                                        runner.exposure < 0
                                          ? "#d32f2f"
                                          : "#228b22",
                                    }}
                                    data-value={runner.exposure}
                                  >
                                    {showBetsSlip &&
                                      BetPlaceData &&
                                      BetPlaceData.price &&
                                      StakeValue > 0 &&
                                      BetPlaceData.market_id ===
                                      bookmaker.market_id &&
                                      BetPlaceData.market_type === "bookmaker"
                                      ? (() => {
                                        const odds = parseFloat(
                                          BetPlaceData.price,
                                        );
                                        const stake = parseFloat(StakeValue);
                                        let newExposure =
                                          Number(runner.exposure) || 0;
                                        if (BetPlaceData.is_back) {
                                          if (
                                            runner.selection_id ===
                                            BetPlaceData.selection_id
                                          ) {
                                            newExposure += (odds - 1) * stake;
                                          } else {
                                            newExposure -= stake;
                                          }
                                        } else {
                                          if (
                                            runner.selection_id ===
                                            BetPlaceData.selection_id
                                          ) {
                                            newExposure -= (odds - 1) * stake;
                                          } else {
                                            newExposure += stake;
                                          }
                                        }
                                        return Math.round(newExposure);
                                      })()
                                      : Math.round(
                                        Number(runner?.exposure) || 0,
                                      )}
                                  </span>
                                  {/* Arrow */}
                                  {showBetsSlip &&
                                    is_fancy == false &&
                                    BetPlaceData.market_type ===
                                    "bookmaker" && (
                                      <>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="10"
                                          height="10"
                                        >
                                          <path
                                            d="M0 3h4v4H0V3zm4 7V0l6 5-6 5z"
                                            fill="#508E0D"
                                            fillRule="evenodd"
                                          />
                                        </svg>
                                        <span
                                          id={
                                            runner.selection_id +
                                            "_maxprofit_Mlist_loss_runner_next_" +
                                            (bookmaker && bookmaker.market_id
                                              ? bookmaker.market_id.replace(
                                                ".",
                                                "",
                                              )
                                              : "")
                                          }
                                          className={`to-win market-exposure`}
                                          style={{
                                            fontSize: "0.688rem",
                                            fontWeight: "bold",
                                            textAlign: "left",
                                            color: (() => {
                                              let newExposure =
                                                Number(runner.exposure) || 0;
                                              if (
                                                showBetsSlip &&
                                                BetPlaceData &&
                                                BetPlaceData.price &&
                                                StakeValue > 0 &&
                                                BetPlaceData.market_type ===
                                                "bookmaker"
                                              ) {
                                                const odds = parseFloat(
                                                  BetPlaceData.price,
                                                );
                                                const stake =
                                                  parseFloat(StakeValue);
                                                if (BetPlaceData.is_back) {
                                                  if (
                                                    runner.selection_id ===
                                                    BetPlaceData.selection_id
                                                  ) {
                                                    newExposure +=
                                                      (odds - 1) * stake;
                                                  } else {
                                                    newExposure -= stake;
                                                  }
                                                } else {
                                                  if (
                                                    runner.selection_id ===
                                                    BetPlaceData.selection_id
                                                  ) {
                                                    newExposure -=
                                                      (odds - 1) * stake;
                                                  } else {
                                                    newExposure += stake;
                                                  }
                                                }
                                              }
                                              return newExposure < 0
                                                ? "#d32f2f"
                                                : "#228b22";
                                            })(),
                                          }}
                                          data-value={
                                            showBetsSlip &&
                                              BetPlaceData &&
                                              BetPlaceData.price &&
                                              StakeValue > 0 &&
                                              BetPlaceData.market_type ===
                                              "bookmaker"
                                              ? (() => {
                                                const odds = parseFloat(
                                                  BetPlaceData.price,
                                                );
                                                const stake =
                                                  parseFloat(StakeValue);
                                                let newExposure =
                                                  Number(runner.exposure) ||
                                                  0;
                                                if (BetPlaceData.is_back) {
                                                  if (
                                                    runner.selection_id ===
                                                    BetPlaceData.selection_id
                                                  ) {
                                                    newExposure +=
                                                      (odds - 1) * stake;
                                                  } else {
                                                    newExposure -= stake;
                                                  }
                                                } else {
                                                  if (
                                                    runner.selection_id ===
                                                    BetPlaceData.selection_id
                                                  ) {
                                                    newExposure -=
                                                      (odds - 1) * stake;
                                                  } else {
                                                    newExposure += stake;
                                                  }
                                                }
                                                return newExposure.toFixed(2);
                                              })()
                                              : Number(runner.exposure).toFixed(
                                                2,
                                              )
                                          }
                                        >
                                          {showBetsSlip &&
                                            BetPlaceData &&
                                            BetPlaceData.price &&
                                            BetPlaceData.market_type ===
                                            "bookmaker"
                                            ? StakeValue > 0
                                              ? (() => {
                                                const odds = parseFloat(
                                                  BetPlaceData.price,
                                                );
                                                const stake =
                                                  parseFloat(StakeValue);
                                                let newExposure =
                                                  Number(runner.exposure) ||
                                                  0;
                                                if (BetPlaceData.is_back) {
                                                  if (
                                                    runner.selection_id ===
                                                    BetPlaceData.selection_id
                                                  ) {
                                                    newExposure +=
                                                      (odds - 1) * stake;
                                                  } else {
                                                    newExposure -= stake;
                                                  }
                                                } else {
                                                  if (
                                                    runner.selection_id ===
                                                    BetPlaceData.selection_id
                                                  ) {
                                                    newExposure -=
                                                      (odds - 1) * stake;
                                                  } else {
                                                    newExposure += stake;
                                                  }
                                                }
                                                return Math.round(
                                                  newExposure,
                                                );
                                              })()
                                              : "0"
                                            : Math.round(
                                              Number(runner?.exposure) || 0,
                                            )}
                                        </span>
                                      </>
                                    )}
                                </span>
                              </div>
                            </div>
                            {/* Odds */}
                            {allSuspended ? (
                              <div className="col-span-5 md:col-span-7 h-12 grid grid-cols-2 md:grid-cols-6 relative">
                                <div className="w-full h-full col-span-6">
                                  <div className="w-full h-full flex items-center justify-center">
                                    <div
                                      className="w-full h-full rounded-sm flex items-center justify-center bg-bg_color_suspended text-color-suspendedFontColor text-xs font-bold"
                                      style={{
                                        cursor: "not-allowed",
                                        minHeight: "48px",
                                        minWidth: "100%",
                                      }}
                                    >
                                      Suspended
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              // ...existing odds rendering code...
                              <div className="col-span-5 md:col-span-7 h-12 grid grid-cols-2 md:grid-cols-6 relative">
                                <div className="w-full h-full col-span-6">
                                  {isMobile ? (
                                    // MOBILE: Only show BACK 1 and LAY 1
                                    <div className="w-full h-full grid grid-cols-2 gap-x-0.5 py-[1px] pr-[2px]">
                                      {/* BACK 1 */}
                                      <div className="w-full h-full">
                                        <div
                                          className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_backBtnBg text-text_color_oddValue"
                                          style={{
                                            cursor:
                                              runner.back_1_price > 0
                                                ? "pointer"
                                                : "not-allowed",
                                          }}
                                          onClick={() => {
                                            if (runner.back_1_price > 0) {
                                              handleOpenBetSlip(
                                                bookmaker.event_id,
                                                bookmaker.market_id,
                                                true, // is_back
                                                `availableToBack1_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false, // is_fancy
                                                runner.selection_id,
                                                runner.runner_name,
                                                `availableToBack1_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                bookmaker.market_name,
                                              );
                                            } else {
                                              handleRateZeroClick();
                                            }
                                          }}
                                        >
                                          <span
                                            id={`availableToBack1_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                            className="relative z-1 flex items-center justify-center w-full leading-5 text-sm md:text-[15px] font-semibold"
                                          >
                                            {runner.back_1_price}
                                          </span>
                                          <span
                                            id={`availableToBack1_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                            className="relative z-1 flex items-center justify-center w-full text-[10px] leading-3 text-center whitespace-normal font-normal"
                                          >
                                            {runner.back_1_size}
                                          </span>
                                        </div>
                                      </div>
                                      {/* LAY 1 */}
                                      <div className="w-full h-full">
                                        <div
                                          className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_layBtnBg text-text_color_oddValue"
                                          style={{
                                            cursor:
                                              runner.lay_1_price > 0
                                                ? "pointer"
                                                : "not-allowed",
                                          }}
                                          onClick={() => {
                                            if (runner.lay_1_price > 0) {
                                              handleOpenBetSlip(
                                                bookmaker.event_id,
                                                bookmaker.market_id,
                                                false, // is_back
                                                `availableToLay1_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false, // is_fancy
                                                runner.selection_id,
                                                runner.runner_name,
                                                `availableToLay1_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                bookmaker.market_name,
                                              );
                                            } else {
                                              handleRateZeroClick();
                                            }
                                          }}
                                        >
                                          <span
                                            id={`availableToLay1_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                            className="relative z-1 flex items-center justify-center w-full leading-5 text-sm md:text-[15px] font-semibold"
                                          >
                                            {runner.lay_1_price}
                                          </span>
                                          <span
                                            id={`availableToLay1_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                            className="relative z-1 flex items-center justify-center w-full text-[10px] leading-3 text-center whitespace-normal font-normal"
                                          >
                                            {runner.lay_1_size}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    // DESKTOP: Show all 3 BACK and 3 LAY
                                    <div className="w-full grid grid-cols-12 grid-flow-col overflow-auto h-full gap-x-0.5 py-[1px] pr-[2px]">
                                      {/* BACK 3 */}
                                      <div className="w-full col-span-2 h-full">
                                        <div
                                          className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_backBtnBg text-text_color_oddValue"
                                          style={{
                                            cursor:
                                              runner.back_3_price > 0
                                                ? "pointer"
                                                : "not-allowed",
                                          }}
                                          onClick={() => {
                                            if (runner.back_3_price > 0) {
                                              handleOpenBetSlip(
                                                bookmaker.event_id,
                                                bookmaker.market_id,
                                                true,
                                                `availableToBack3_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                runner.selection_id,
                                                runner.runner_name,
                                                `availableToBack3_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                bookmaker.market_name,
                                              );
                                            } else {
                                              handleRateZeroClick();
                                            }
                                          }}
                                        >
                                          <span
                                            id={`availableToBack3_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                          >
                                            {runner.back_3_price}
                                          </span>
                                          <span
                                            id={`availableToBack3_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                          >
                                            {runner.back_3_size}
                                          </span>
                                        </div>
                                      </div>
                                      {/* BACK 2 */}
                                      <div className="w-full col-span-2 h-full">
                                        <div
                                          className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_backBtnBg text-text_color_oddValue"
                                          style={{
                                            cursor:
                                              runner.back_2_price > 0
                                                ? "pointer"
                                                : "not-allowed",
                                          }}
                                          onClick={() => {
                                            if (runner.back_2_price > 0) {
                                              handleOpenBetSlip(
                                                bookmaker.event_id,
                                                bookmaker.market_id,
                                                true,
                                                `availableToBack2_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                runner.selection_id,
                                                runner.runner_name,
                                                `availableToBack2_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                bookmaker.market_name,
                                              );
                                            } else {
                                              handleRateZeroClick();
                                            }
                                          }}
                                        >
                                          <span
                                            id={`availableToBack2_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                          >
                                            {runner.back_2_price}
                                          </span>
                                          <span
                                            id={`availableToBack2_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                          >
                                            {runner.back_2_size}
                                          </span>
                                        </div>
                                      </div>
                                      {/* BACK 1 */}
                                      <div className="w-full col-span-2 h-full">
                                        <div
                                          className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_backBtnBg text-text_color_oddValue"
                                          style={{
                                            cursor:
                                              runner.back_1_price > 0
                                                ? "pointer"
                                                : "not-allowed",
                                          }}
                                          onClick={() => {
                                            if (runner.back_1_price > 0) {
                                              handleOpenBetSlip(
                                                bookmaker.event_id,
                                                bookmaker.market_id,
                                                true,
                                                `availableToBack1_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                runner.selection_id,
                                                runner.runner_name,
                                                `availableToBack1_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                bookmaker.market_name,
                                              );
                                            } else {
                                              handleRateZeroClick();
                                            }
                                          }}
                                        >
                                          <span
                                            id={`availableToBack1_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                          >
                                            {runner.back_1_price}
                                          </span>
                                          <span
                                            id={`availableToBack1_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                          >
                                            {runner.back_1_size}
                                          </span>
                                        </div>
                                      </div>
                                      {/* LAY 1 */}
                                      <div className="w-full col-span-2 h-full">
                                        <div
                                          className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_layBtnBg text-text_color_oddValue"
                                          style={{
                                            cursor:
                                              runner.lay_1_price > 0
                                                ? "pointer"
                                                : "not-allowed",
                                          }}
                                          onClick={() => {
                                            if (runner.lay_1_price > 0) {
                                              handleOpenBetSlip(
                                                bookmaker.event_id,
                                                bookmaker.market_id,
                                                false,
                                                `availableToLay1_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                runner.selection_id,
                                                runner.runner_name,
                                                `availableToLay1_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                bookmaker.market_name,
                                              );
                                            } else {
                                              handleRateZeroClick();
                                            }
                                          }}
                                        >
                                          <span
                                            id={`availableToLay1_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                          >
                                            {runner.lay_1_price}
                                          </span>
                                          <span
                                            id={`availableToLay1_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                          >
                                            {runner.lay_1_size}
                                          </span>
                                        </div>
                                      </div>
                                      {/* LAY 2 */}
                                      <div className="w-full col-span-2 h-full">
                                        <div
                                          className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_layBtnBg text-text_color_oddValue"
                                          style={{
                                            cursor:
                                              runner.lay_2_price > 0
                                                ? "pointer"
                                                : "not-allowed",
                                          }}
                                          onClick={() => {
                                            if (runner.lay_2_price > 0) {
                                              handleOpenBetSlip(
                                                bookmaker.event_id,
                                                bookmaker.market_id,
                                                false,
                                                `availableToLay2_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                runner.selection_id,
                                                runner.runner_name,
                                                `availableToLay2_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                bookmaker.market_name,
                                              );
                                            } else {
                                              handleRateZeroClick();
                                            }
                                          }}
                                        >
                                          <span
                                            id={`availableToLay2_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                          >
                                            {runner.lay_2_price}
                                          </span>
                                          <span
                                            id={`availableToLay2_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                          >
                                            {runner.lay_2_size}
                                          </span>
                                        </div>
                                      </div>
                                      {/* LAY 3 */}
                                      <div className="w-full col-span-2 h-full">
                                        <div
                                          className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_layBtnBg text-text_color_oddValue"
                                          style={{
                                            cursor:
                                              runner.lay_3_price > 0
                                                ? "pointer"
                                                : "not-allowed",
                                          }}
                                          onClick={() => {
                                            if (runner.lay_3_price > 0) {
                                              handleOpenBetSlip(
                                                bookmaker.event_id,
                                                bookmaker.market_id,
                                                false,
                                                `availableToLay3_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                runner.selection_id,
                                                runner.runner_name,
                                                `availableToLay3_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                bookmaker.market_name,
                                              );
                                            } else {
                                              handleRateZeroClick();
                                            }
                                          }}
                                        >
                                          <span
                                            id={`availableToLay3_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                          >
                                            {runner.lay_3_price}
                                          </span>
                                          <span
                                            id={`availableToLay3_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                          >
                                            {runner.lay_3_size}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* fancy */}
              {/* Fancy/Premium Market Heading */}
              {fancyOddsData && fancyOddsData.length > 0 && (
                <div className="text-base font-medium text-center py-1.5">
                  <ul className="flex flex-wrap items-center justify-start gap-x-3">
                    <li className="px-[15px] py-2 rounded-[100px] flex items-center justify-center cursor-pointer active:scale-95 transition-all ease-in-out duration-100 bg-bg_text_brand_primary text-text_color_primary2 border-border_color_brand_primary">
                      <span className="inline-block font-bold text-xs sm:text-sm md:text-base leading-4">
                        Fancy Market
                      </span>
                    </li>
                    <li className="px-[15px] py-2 border rounded-[100px] flex items-center justify-center cursor-pointer active:scale-95 transition-all ease-in-out duration-100 bg-bg_color_primary text-text_color_tertiary2 border-border_color_primary">
                      <span className="inline-block font-bold text-xs sm:text-sm md:text-base leading-4">
                        Premium Market
                      </span>
                    </li>
                  </ul>
                </div>
              )}
              {fancyOddsData.map((fancy, idx) => (
                <div
                  key={fancy.selection_id || idx}
                  className="grid grid-cols-12 border-b border-border_color_primary1"
                >
                  {/* Team Name, Watch, Stairs */}
                  <div className="w-full md:col-span-6 col-span-7 h-12 grid grid-cols-12 grid-flow-col pl-2.5 md:pl-2 py-0.5 pr-[3px]">
                    <div className="col-span-8 md:col-span-10 flex flex-col h-full">
                      <div className="w-full flex flex-nowrap flex-1">
                        <div
                          title={fancy.runner_name}
                          className="flex items-center flex-1 capitalize text-text_color_primary1 text-[13px] md:text-sm font-semibold truncate text-start pr-0.5 md:pr-0"
                        >
                          <span className="truncate">{fancy.runner_name}</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-span-2 md:col-span-1 flex flex-row items-center justify-center gap-x-[2px]">
                      {/* Watch Icon */}
                      <svg
                        version="1.0"
                        height="15"
                        width="15"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 840.000000 936.000000"
                        preserveAspectRatio="xMidYMid meet"
                      >
                        <g
                          transform="translate(0.000000,936.000000) scale(0.100000,-0.100000)"
                          fill="var(--icon-color-brand-tertiary1)"
                          stroke="none"
                        >
                          <path d="M3472 8818 l3 -243 243 -3 242 -2 0 -244 0 -243 -122 -12 c-1359 -130 -2543 -950 -3143 -2176 -155 -318 -271 -677 -334 -1035 -75 -424 -73 -934 5 -1360 226 -1229 1014 -2267 2136 -2810 694 -335 1447 -455 2228 -354 567 74 1147 294 1640 624 792 530 1374 1353 1605 2270 133 529 156 1092 65 1627 -175 1029 -775 1959 -1645 2552 -539 367 -1135 586 -1792 657 l-163 18 0 243 0 243 243 2 242 3 3 243 2 242 -730 0 -730 0 2 -242z m1138 -1242 c478 -59 937 -216 1346 -463 765 -461 1323 -1208 1543 -2067 190 -738 131 -1502 -171 -2206 -175 -408 -460 -814 -789 -1122 -519 -487 -1138 -787 -1845 -895 -164 -25 -204 -27 -484 -27 -325 -1 -422 7 -685 60 -1170 231 -2155 1089 -2543 2214 -222 647 -250 1318 -82 1975 283 1104 1112 1999 2195 2372 215 74 531 144 735 162 63 6 133 13 155 15 85 9 506 -4 625 -18z"></path>
                          <path d="M3960 5620 c0 -654 -3 -1010 -10 -1010 -5 0 -41 -30 -80 -66 -51 -49 -80 -86 -105 -138 -133 -272 18 -605 310 -681 132 -34 277 -11 391 63 202 131 276 400 169 618 -25 52 -54 89 -105 138 -39 36 -75 66 -80 66 -7 0 -10 356 -10 1010 l0 1010 -240 0 -240 0 0 -1010z"></path>
                        </g>
                      </svg>
                      <span className="font-[480] text-sm text-text_color_primary1">
                        4s
                      </span>
                    </div>
                    <div className="col-span-2 md:col-span-1 flex flex-row items-center justify-center">
                      <div className="opacity-50 cursor-not-allowed">
                        {/* Stairs Icon */}
                        <svg
                          height="18"
                          width="18"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g>
                            <path
                              d="M5.21875 3.13672V13.1367"
                              stroke="var(--icon-color-brand-tertiary1)"
                            ></path>
                            <path
                              d="M5.21875 5.48047H10.5312"
                              stroke="var(--icon-color-brand-tertiary1)"
                            ></path>
                            <path
                              d="M5.21875 8.13672H10.5312"
                              stroke="var(--icon-color-brand-tertiary1)"
                            ></path>
                            <path
                              d="M5.21875 11.1055H10.5312"
                              stroke="var(--icon-color-brand-tertiary1)"
                            ></path>
                            <path
                              d="M10.5312 3.13672V13.1367"
                              stroke="var(--icon-color-brand-tertiary1)"
                            ></path>
                          </g>
                        </svg>
                      </div>
                    </div>
                  </div>

                  {/* Odds or Status */}
                  <div className="col-span-5 md:col-span-6 h-12 relative flex">
                    {fancy.game_status === "Ball Running" ||
                      fancy.game_status === "SUSPENDED" ? (
                      <span className="flex-1 text-center min-h-12 py-[1px] px-[1px] flex items-center justify-center w-full h-full">
                        <span
                          className={`text-center w-full h-full rounded-sm flex text-xs flex-col items-center justify-center ${fancy.game_status === "Ball Running"
                            ? "bg-bg_color_ballRunning text-text_color_primary1"
                            : "bg-bg_color_suspended text-color-suspendedFontColor"
                            }`}
                          style={{ cursor: "not-allowed" }}
                        >
                          {fancy.game_status === "Ball Running"
                            ? "Ball Running"
                            : "Suspended"}
                        </span>
                      </span>
                    ) : (
                      <>
                        <div className="flex flex-1 grid grid-cols-2 gap-x-0.5 py-[1px] pr-[2px]">
                          {/* BACK */}
                          <div className="w-full h-full">
                            <div
                              className="overflow-hidden relative w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_backBtnBg text-text_color_oddValue"
                              style={{
                                cursor:
                                  fancy.back_price1 > 0
                                    ? "pointer"
                                    : "not-allowed",
                              }}
                              onClick={() => {
                                if (fancy.back_price1 > 0) {
                                  handleOpenBetSlip(
                                    fancy.match_id,
                                    "",
                                    true,
                                    `fancy_back_size_${fancy.selection_id}`,
                                    true,
                                    fancy.selection_id,
                                    fancy.runner_name,
                                    `fancy_back_price_${fancy.selection_id}`,
                                    false,
                                    "",
                                  );
                                } else {
                                  handleRateZeroClick();
                                }
                              }}
                            >
                              <span
                                id={`fancy_back_price_${fancy.selection_id}`}
                                style={{ fontWeight: 600 }}
                              >
                                {fancy.back_price1}
                              </span>
                              <span
                                id={`fancy_back_size_${fancy.selection_id}`}
                                style={{ fontSize: "10px", marginLeft: 0 }}
                              >
                                {fancy.back_size1}
                              </span>
                            </div>
                          </div>
                          {/* LAY */}
                          <div className="w-full h-full">
                            <div
                              className="overflow-hidden relative w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_layBtnBg text-text_color_oddValue"
                              style={{
                                cursor:
                                  fancy.lay_price1 > 0
                                    ? "pointer"
                                    : "not-allowed",
                              }}
                              onClick={() => {
                                if (fancy.lay_price1 > 0) {
                                  handleOpenBetSlip(
                                    fancy.match_id,
                                    "",
                                    false,
                                    `fancy_lay_size_${fancy.selection_id}`,
                                    true,
                                    fancy.selection_id,
                                    fancy.runner_name,
                                    `fancy_lay_price_${fancy.selection_id}`,
                                    false,
                                    "",
                                  );
                                } else {
                                  handleRateZeroClick();
                                }
                              }}
                            >
                              <span
                                id={`fancy_lay_price_${fancy.selection_id}`}
                                style={{ fontWeight: 600 }}
                              >
                                {fancy.lay_price1}
                              </span>
                              <span
                                id={`fancy_lay_size_${fancy.selection_id}`}
                                style={{ fontSize: "10px", marginLeft: 0 }}
                              >
                                {fancy.lay_size1}
                              </span>
                            </div>
                          </div>
                        </div>

                        <span className="hidden md:flex md:flex-col md:justify-center md:items-center md:ml-1 text-center min-h-12 px-1 text-text_color_tertiary2 text-[10px]">
                          <div className="flex items-center justify-center">
                            <span>Max Bet :</span>&nbsp;
                            <span>{fancy.max_bet || "2,25,000"}</span>
                          </div>
                          <div className="flex items-center justify-center">
                            <span>Max Mkt :</span>&nbsp;
                            <span>{fancy.max_market || "20,00,000"}</span>
                          </div>
                        </span>
                      </>
                    )}
                  </div>
                </div>
              ))}

              {showPlaceBetPopup && (
                <div className="modal-overlay" onClick={handleClosePlaceBet}>
                  <div
                    className="modal-content"
                    onClick={(e) => e.stopPropagation()} // Prevents closing when clicking inside the modal content
                  >
                    <PlaceBet
                      type={type}
                      BetPlaceData={BetPlaceData}
                      placeStakeValue={placeStakeValue}
                      StakeValue={StakeValue}
                      chips={chips}
                      placing={placing}
                      betPlace={betPlace}
                      handleClosePlaceBet={handleClosePlaceBet}
                      setShowBetsSlip={setShowBetsSlip}
                      setSelection_id={setSelection_id}
                      setHtmlId={setHtmlId}
                    />
                  </div>
                </div>
              )}

              {showSuccessPopup && (
                <PlaceBetSuccessfull
                  message="Bet placed successfully!"
                  onClose={() => setShowSuccessPopup(false)} // Close the success popup
                />
              )}

              <Empty />

              {/* <Footer /> */}
            </div>
          </>
        ) : (
          <div className="mainscreen-container">
            <div>
              <SideMenu
                handleToggleMenu={handleToggleMenu}
                isMobile={isMobile}
                props={{ setEventType }}
              />{" "}
              {/* FIXED */}
            </div>

            <Modal
              title={"Book"}
              className="book-model"
              onCancel={() => setBookModalOpen(false)}
              footer={null}
              open={bookModalOpen}
            >
              <div style={{ padding: "5px", color: "#23282c" }}>
                <div
                  style={{
                    display: "grid",
                    border: "2px solid #333",
                    borderTop: "1px solid #333",
                    width: "100%",
                  }}
                >
                  <div style={{ backgroundColor: "#e0e6e6", width: "100%" }}>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        width: "100%",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "5px",
                          borderRight: "1px solid #000",
                        }}
                      >
                        <span style={{ color: "black", fontWeight: "bold" }}>
                          {" "}
                          Run
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "5px",
                          borderRight: "1px solid #000",
                        }}
                      >
                        <span style={{ color: "black", fontWeight: "bold" }}>
                          {" "}
                          Amount
                        </span>
                      </div>
                    </div>
                  </div>

                  {postionFancyList.length > 0 ? (
                    postionFancyList.map((item, index) => {
                      if (item < 0)
                        return (
                          <>
                            <div
                              style={{
                                backgroundColor: "#e0e6e6",
                                width: "100%",
                              }}
                            >
                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: "1fr 1fr",
                                  width: "100%",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "5px",
                                    borderRight: "1px solid #000",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "black",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {" "}
                                    {index}
                                  </span>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "5px",
                                    borderRight: "1px solid #000",
                                  }}
                                >
                                  <span
                                    style={{ color: "red", fontWeight: "bold" }}
                                    data-value={item}
                                  >
                                    {" "}
                                    {item}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      if (item >= 0 && item != null)
                        return (
                          <>
                            <div
                              style={{
                                backgroundColor: "#e0e6e6",
                                width: "100%",
                              }}
                            >
                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: "1fr 1fr",
                                  width: "100%",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "5px",
                                    borderRight: "1px solid #000",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "black",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    {" "}
                                    {index}
                                  </span>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    padding: "5px",
                                    borderRight: "1px solid #000",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "green",
                                      fontWeight: "bold",
                                    }}
                                    data-value={item}
                                  >
                                    {" "}
                                    {item}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                    })
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        fontWeight: "bold",
                        textAlign: "center",
                        borderTop: "1px solid",
                        borderColor: "black",
                      }}
                    >
                      No data!
                    </div>
                  )}
                </div>
              </div>
            </Modal>

            <div className="matchupdates-container">
              {/* <div className="match-update-header">
              <div className="inside-content">
                <FaPlayCircle size={15} color="white" style={{ marginRight: 5, marginLeft: 5, marginTop: 3 }} />
                <span>{eventName ? eventName : ''}</span>
                <p>{openDate ? openDate : ''}</p>
              </div>
              <IoInformationCircleOutline size={15} color="white" style={{ marginRight: 5, marginLeft: 0, marginTop: 10 }} />
            </div>

            <div className="header-part-2">
              <a href="#" onClick={handleMarketClick}>MARKET</a>
              <a href="#" onClick={handleLiveClick}>
                LIVE <MdLiveTv size={15} color="white" style={{ marginBottom: 2, marginLeft: 2 }} />
              </a>
              <a href="#" onClick={handleOpenBets}>OPEN BETS</a>
            </div> */}

              <div className="match-header-container">
                {/* Top Ribbon */}
                {/* <div className="ribbon-wrapper">
                  <div className="ribbon">
                    <span className="event-name">{eventName ? eventName : ""}</span>
                    <span className="event-time">{openDate ? openDate : ""}</span>

                    <svg
                      className="ribbon-wave"
                      xmlns="http://www.w3.org/2000/svg"
                      width="100"
                      height="26"
                      viewBox="0 0 190 26"
                    >
                      <path
                        d="M0.208334 0.899998C3.00833 1.4 9.20833 2.6 14.2083 3.4C28.1083 5.9 33.9083 7.6 51.1083 13.9C73.9083 22.5 79.5833 24.7999 93 25.5C107.692 25.4999 116.508 23.5 132.708 17.2C156.308 8 166.008 4.8 177.408 2.4L189.208 0H92.2083C30.8083 0 -2.99167 0.4 0.208334 0.899998Z"
                        fill="#c1092f"
                      />
                    </svg>

                    <div className="ribbon-deco left" />
                    <div className="ribbon-deco right" />
                  </div>
                </div> */}

                {/* Top Icons */}
                {/* <div className="header-icons">
                  <div
                    className="live-icon"
                    onClick={() => {
                      setShowLtv((prev) => !prev);
                    }}
                  >
                    {isInplay && (
                      <>
                        <span className="ping" />
                        <span className="dot" />
                      </>
                    )}
                    <img
                      src="https://bx-s3-dev-001.s3.ap-southeast-1.amazonaws.com/icons/tv.svg"
                      alt="TV Icon"
                    />
                  </div>
                  <div className="info-icon" onClick={() => handleOpenRules()}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="#6D081D"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="16" x2="12" y2="12" />
                      <line x1="12" y1="8" x2="12.01" y2="8" />
                    </svg>
                  </div>
                </div> */}

                {/* Teams Row */}
                {/* <div className="teams-row">
                  {team1 && team2 ? (
                    <>
                      <div className="team-name left">{team1.trim()}</div>
                      <div className="vs">vs</div>
                      <div className="team-name right">{team2.trim()}</div>
                    </>
                  ) : (
                    <div className="team-name single">{eventName}</div>
                  )}
                </div> */}
                <div className="flex flex-col w-full">
                  <div className="flex flex-row w-full justify-between items-center px-2 mt-2 bg-bg_appBg rounded-sm py-2">
                    <div
                      id="playIcon"
                      className="flex items-center justify-start gap-x-3 w-[92%]"
                    >
                      <span className="min-w-[4%]">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 21 20"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_1717_31137)">
                            <path
                              d="M10.5 19.8571C8.55041 19.8571 6.64463 19.279 5.02363 18.1959C3.40264 17.1128 2.13922 15.5733 1.39316 13.7721C0.647093 11.971 0.451889 9.98903 0.832229 8.07694C1.21257 6.16484 2.15137 4.40846 3.52992 3.02992C4.90846 1.65137 6.66484 0.712569 8.57694 0.332229C10.489 -0.0481111 12.471 0.147093 14.2721 0.893157C16.0733 1.63922 17.6128 2.90264 18.6959 4.52363C19.779 6.14463 20.3571 8.05041 20.3571 9.99997C20.3541 12.6133 19.3146 15.1188 17.4667 16.9667C15.6188 18.8146 13.1133 19.8541 10.5 19.8571ZM10.5 1.5714C8.83296 1.5714 7.20338 2.06572 5.81731 2.99187C4.43123 3.91801 3.35092 5.23437 2.71298 6.77449C2.07505 8.31461 1.90813 10.0093 2.23335 11.6443C2.55857 13.2793 3.36131 14.7811 4.54007 15.9599C5.71883 17.1386 7.22065 17.9414 8.85564 18.2666C10.4906 18.5918 12.1853 18.4249 13.7254 17.787C15.2656 17.149 16.5819 16.0687 17.5081 14.6826C18.4342 13.2966 18.9285 11.667 18.9285 9.99997C18.926 7.76536 18.0371 5.62302 16.457 4.04291C14.8769 2.4628 12.7346 1.57397 10.5 1.5714Z"
                              fill="url(#paint0_linear_1717_31137)"
                            ></path>
                            <path
                              d="M15.6915 11.5172H10.5629C10.3735 11.5172 10.1918 11.4419 10.0578 11.308C9.92389 11.174 9.84863 10.9923 9.84863 10.8029V5.67376C9.84863 5.48432 9.92389 5.30264 10.0578 5.16868C10.1918 5.03473 10.3735 4.95947 10.5629 4.95947C10.7524 4.95947 10.934 5.03473 11.068 5.16868C11.2019 5.30264 11.2772 5.48432 11.2772 5.67376V10.0886H15.6915C15.8809 10.0886 16.0626 10.1639 16.1966 10.2978C16.3305 10.4318 16.4058 10.6135 16.4058 10.8029C16.4058 10.9923 16.3305 11.174 16.1966 11.308C16.0626 11.4419 15.8809 11.5172 15.6915 11.5172Z"
                              fill="url(#paint1_linear_1717_31137)"
                            ></path>
                          </g>
                          <defs>
                            <linearGradient
                              id="paint0_linear_1717_31137"
                              x1="0.642822"
                              y1="21.0893"
                              x2="22.3721"
                              y2="18.475"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="var(--icon-color-brand-secondary)"></stop>
                              <stop
                                offset="1"
                                stopColor="var(--icon-color-brand-secondary)"
                              ></stop>
                            </linearGradient>
                            <linearGradient
                              id="paint1_linear_1717_31137"
                              x1="9.84863"
                              y1="11.927"
                              x2="17.076"
                              y2="11.0576"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="var(--icon-color-brand-secondary)"></stop>
                              <stop
                                offset="1"
                                stopColor="var(--icon-color-brand-secondary)"
                              ></stop>
                            </linearGradient>
                            <clipPath id="clip0_1717_31137">
                              <rect
                                width="20"
                                height="20"
                                fill="white"
                                transform="translate(0.5)"
                              ></rect>
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                      <span className="bg-bg_text_brand_primary text-transparent bg-clip-text font-lato text-base font-bold">
                        <span className="capitalize w-max break-words">
                          {headingEventName || "Match details"}
                        </span>
                        {/* {team2 && (
                          <>
                            <span className="ml-[2px]">vs</span>
                            <span className="capitalize w-max ml-[2px] break-words">{team2}</span>
                          </>
                        )} */}
                      </span>
                      {/* Desktop: Show score icon and toggle score iframe */}
                      {!isMobile && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            margin: "10px 0",
                          }}
                        >
                          <img
                            src="/images/icons8-score-96.png"
                            alt="Show Score"
                            style={{
                              cursor: "pointer",
                              width: "32px",
                              height: "32px",
                            }}
                            onClick={() => setShowScoreDesktop((prev) => !prev)}
                          />
                          {headingOpenDate}
                        </div>
                      )}
                    </div>
                    <div className="flex items-center justify-center gap-x-2">
                      <span className="w-max break-words bg-bg_text_brand_primary text-transparent bg-clip-text font-lato text-xs font-bold"></span>
                      <span onClick={() => handleOpenRules()}>
                        <svg
                          width="17"
                          height="17"
                          viewBox="0 0 17 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clipPath="url(#clip0_1717_31141)">
                            <path
                              d="M8.5 0.5C4.07841 0.5 0.5 4.078 0.5 8.5C0.5 12.9215 4.078 16.5 8.5 16.5C12.9216 16.5 16.5 12.922 16.5 8.5C16.5 4.07847 12.922 0.5 8.5 0.5ZM8.5 15.3837C4.70431 15.3837 1.61628 12.2957 1.61628 8.5C1.61628 4.70428 4.70431 1.61628 8.5 1.61628C12.2957 1.61628 15.3837 4.70428 15.3837 8.5C15.3837 12.2957 12.2957 15.3837 8.5 15.3837Z"
                              fill="var(--icon-color-brand-secondary)"
                            ></path>
                            <path
                              d="M8.5003 7.1687C8.02642 7.1687 7.68945 7.36883 7.68945 7.66367V11.6757C7.68945 11.9285 8.02642 12.1812 8.5003 12.1812C8.95311 12.1812 9.32164 11.9285 9.32164 11.6757V7.66361C9.32164 7.36879 8.95311 7.1687 8.5003 7.1687Z"
                              fill="var(--icon-color-brand-secondary)"
                            ></path>
                            <path
                              d="M8.50019 4.69409C8.01578 4.69409 7.63672 5.04159 7.63672 5.44175C7.63672 5.84194 8.01581 6.19997 8.50019 6.19997C8.97406 6.19997 9.35319 5.84194 9.35319 5.44175C9.35319 5.04159 8.97403 4.69409 8.50019 4.69409Z"
                              fill="var(--icon-color-brand-secondary)"
                            ></path>
                          </g>
                          <defs>
                            <clipPath id="clip0_1717_31141">
                              <rect
                                width="16"
                                height="16"
                                fill="white"
                                transform="translate(0.5 0.5)"
                              ></rect>
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-span-1">
                <div className="w-full px-2">
                  <button
                    className="inline-block leading-normal relative overflow-hidden transition duration-150 ease-in-out w-full py-2 text-sm my-2 font-semibold text-center text-text_color_primary2 bg-bg_color_watch_enjoy_live_action_btn rounded-md cursor-pointer"
                    type="button"
                    onClick={() => {
                      setTvVisible((prev) => !prev);
                      setShowIframe((prev) => !prev);
                      setShowLtv((prev) => !prev);
                    }}
                  >
                    {tvVisible ? "Hide TV" : "Watch TV Enjoy Live Action..."}
                  </button>
                  <div></div>
                </div>
              </div>

              {tvVisible && (
                <div
                  className="tv-div"
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    margin: "0 auto",
                    padding: "8px",
                  }}
                >
                  <div
                    id="streamingBox"
                    className="tv-fix"
                    style={{
                      width: "100%",
                      maxWidth: "700px",
                      border: "3px solid #0c9971",
                      borderRadius: "8px",
                      overflow: "hidden",
                      background: "#000",
                    }}
                  >
                    <iframe
                      allowFullScreen={true}
                      webkitallowfullscreen="true"
                      mozallowfullscreen="true"
                      contentEditable="false"
                      frameBorder="0"
                      scrolling="yes"
                      id="tvframe"
                      src={tvUrl}
                      style={{
                        width: "100%",
                        height: "300px",
                        minHeight: "180px",
                        maxWidth: "100%",
                        border: "none",
                        background: "#000",
                        display: "",
                      }}
                    ></iframe>
                  </div>
                </div>
              )}

              {/* Desktop: Show score iframe only if toggled */}
              {/* {!isMobile && showScoreDesktop && (
                <div
                  className="score-wrapper border-[5px] border-[#f9df10]"
                  style={{
                    marginTop: userInfo ? "0px" : "18px",
                    backgroundColor: "#000",
                    height: "153px",
                    width: "100%",
                  }}
                >
                  <iframe
                    frameBorder="0"
                    className="score-board"
                    src={scoreUrl || "about:blank"}
                    title="match-score"
                    style={{ height: "142px", width: "100%" }}
                  />
                  {
                    scoreBoard && (
                      <ScoreBoard scoreBoard={scoreBoard} eventType={4} />
                    )
                  }
                </div>
              )} */}
              {!isMobile && showScoreDesktop && (
                <div
                  className={`score-wrapper border-[5px] border-[#f9df10] bg-black 
                    w-full h-[150px] mt-${userInfo ? "0" : "4"}`}
                >
                  {scoreBoard && (
                    <div className="w-full h-full">
                      <ScoreBoard scoreBoard={scoreBoard} eventType={4} />
                    </div>
                  )}
                </div>
              )}

              {/* <div className="col-span-1">
                <div className="w-full px-2">
                  <button
                    className="inline-block leading-normal relative overflow-hidden transition duration-150 ease-in-out w-full py-2 text-sm my-2 font-semibold text-center text-text_color_primary2 bg-bg_color_watch_enjoy_live_action_btn rounded-md cursor-pointer"
                    type="button"
                    onClick={() => setShowIframe((prev) => !prev)}
                    onClick={() => {
                      setShowIframe(true);
                      setShowLtv(true);
                    }}
                  >
                    Watch TV Enjoy Live Action...
                  </button>
                  <div></div>
                </div>
              </div>

                    

              {showIframe && showLtv && (
                <div className="tv-div">
                  {showLtv && (
                    <div id="streamingBox" className="tv-fix">
                      <iframe
                        allowFullScreen={true}
                        webkitallowfullscreen="true"
                        mozallowfullscreen="true"
                        contentEditable="false"
                        frameBorder="0"
                        scrolling="yes"
                        id="tvframe"
                        src={tvUrl}
                        style={{
                          width: "100vw",
                          height: "14rem",
                          display: showLtv ? "" : "none",
                        }}
                      ></iframe>
                    </div>
                  )}
                  <div
                    className="score-wrapper border-t-[5px]  border-t-[#c13333]"
                    style={{
                      display: showScoreIfram ? "block" : "none",
                      marginTop: userInfo ? "0px" : "18px",
                      backgroundColor: "#000",
                      height: "210px",
                      width: "100%",
                    }}
                  >
                    <iframe
                      onLoad={() => setShowScoreIfram(true)}
                      frameBorder="0"
                      className="score-board"
                      src={scoreUrl}
                      title="match-score"
                      style={{ height: "200px", width: "100%" }}
                    />
                  </div>
                </div>
              )} */}

              {showOpenBets && (
                <div className="open-bets-section">
                  <h2>Open Bets</h2>
                  <p>No open bets available.</p>
                </div>
              )}

              {/* matchOdds */}

              {eventData.length > 0 && matchOdds && matchOdds.marketRunners && (
                <div className="w-full text-selection-none pb-3 lg:pb-0">
                  <div className="px-2 font-helvetica">
                    <div className="py-1.5">
                      {/* Header Row */}
                      <div className="grid grid-flow-col grid-cols-12 text-text_color_primary1 text-xs font-[500] mb-1.5">
                        <div className="pl-1 flex items-center justify-start gap-x-1 md:gap-x-1 col-span-7 md:col-span-5">
                          <div
                            className="capitalize font-bold text-xs sm:text-sm md:text-[15px] flex items-start justify-start flex-col"
                            title="Match Odds"
                          >
                            <span>Match Odds</span>
                            <span className="text-x font-normal text-text_color_info"></span>
                          </div>
                        </div>
                        <div className="col-span-5 md:col-span-7 grid grid-cols-2 md:grid-cols-6 pb-[2px]">
                          {isMobile ? (
                            <>
                              <span className="col-span-1 text-center text-[10px] sm:text-xs md:text-sm leading-3 font-bold h-full flex items-end justify-center">
                                BACK
                              </span>
                              <span className="col-span-1 text-center text-[10px] sm:text-xs md:text-sm leading-3 font-bold h-full flex items-end justify-center">
                                LAY
                              </span>
                            </>
                          ) : (
                            <>
                              <span className="hidden md:flex col-span-1 text-center font-semibold h-full items-end justify-center"></span>
                              <span className="col-span-1 text-center font-semibold h-full hidden md:flex items-end justify-center"></span>
                              <span className="col-span-1 text-center text-[10px] sm:text-xs md:text-sm leading-3 font-bold h-full flex items-end justify-center">
                                BACK
                              </span>
                              <span className="col-span-1 text-center text-[10px] sm:text-xs md:text-sm leading-3 font-bold h-full flex items-end justify-center">
                                LAY
                              </span>
                              <span className="col-span-1 text-center font-semibold h-full hidden md:flex items-end justify-center"></span>
                              <span className="col-span-1 text-center font-semibold h-full hidden md:flex items-end justify-center"></span>
                            </>
                          )}
                        </div>
                      </div>
                      {/* Runner Rows */}
                      <div className="bg-bg_color_primary rounded-[3px] shadow-[0_8px_30px_rgb(0,0,0,0.12)] py-[1px]">
                        {matchOdds.marketRunners.map((runner, idx) => (
                          <div
                            key={runner.selection_id || idx}
                            className="grid grid-cols-12 border-b border-border_color_primary1"
                          >
                            {/* Team Name */}
                            <div className="w-full md:col-span-5 col-span-7 h-12 grid grid-cols-12 grid-flow-col pl-2.5 md:pl-2 py-0.5 pr-[3px]">
                              <div className="truncate col-span-12 flex items-start justify-center h-full flex-col">
                                <div className="w-full flex flex-wrap">
                                  <div
                                    title={runner.runner_name}
                                    className="flex items-center flex-1 capitalize text-text_color_primary1 text-[13px] md:text-sm font-semibold truncate text-start h-full pr-0.5 md:pr-0"
                                  >
                                    <span className="truncate">
                                      {runner?.runner_name ||
                                        runner?.runnerName ||
                                        "Runner"}
                                    </span>
                                  </div>
                                </div>
                                {/* Exposure/Profit block as requested */}
                                <span
                                  style={{
                                    marginLeft: "5px",
                                    fontSize: "0.688rem",
                                    fontWeight: "bold",
                                    display: "flex",
                                    textAlign: "left",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}
                                >
                                  {/* Only show match odds exposure calculation for match odds bets */}
                                  <span
                                    id={
                                      runner.selection_id +
                                      "_maxprofit_list_loss_runner_prev_" +
                                      (matchOdds && matchOdds.market_id
                                        ? matchOdds.market_id.replace(".", "")
                                        : "")
                                    }
                                    className={`win market-exposure`}
                                    style={{
                                      fontSize: "0.688rem",
                                      fontWeight: "bold",
                                      textAlign: "left",
                                      marginLeft: "5px",
                                      marginRight: "3px",
                                      color:
                                        runner.exposure < 0
                                          ? "#d32f2f"
                                          : "#228b22",
                                    }}
                                    data-value={runner.exposure}
                                  >
                                    {showBetsSlip &&
                                      BetPlaceData &&
                                      BetPlaceData.price &&
                                      StakeValue > 0 &&
                                      BetPlaceData.market_id ===
                                      matchOdds.market_id &&
                                      BetPlaceData.market_type === "match_odds"
                                      ? (() => {
                                        const odds = parseFloat(
                                          BetPlaceData.price,
                                        );
                                        const stake = parseFloat(StakeValue);
                                        let newExposure =
                                          Number(runner.exposure) || 0;
                                        if (BetPlaceData.is_back) {
                                          if (
                                            runner.selection_id ===
                                            BetPlaceData.selection_id
                                          ) {
                                            newExposure += (odds - 1) * stake;
                                          } else {
                                            newExposure -= stake;
                                          }
                                        } else {
                                          if (
                                            runner.selection_id ===
                                            BetPlaceData.selection_id
                                          ) {
                                            newExposure -= (odds - 1) * stake;
                                          } else {
                                            newExposure += stake;
                                          }
                                        }
                                        return Math.round(newExposure);
                                      })()
                                      : Math.round(
                                        Number(runner?.exposure) || 0,
                                      )}
                                  </span>
                                  {/* Arrow */}
                                  {showBetsSlip &&
                                    is_fancy == false &&
                                    BetPlaceData.market_type ===
                                    "match_odds" && (
                                      <>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="10"
                                          height="10"
                                        >
                                          <path
                                            d="M0 3h4v4H0V3zm4 7V0l6 5-6 5z"
                                            fill="#508E0D"
                                            fillRule="evenodd"
                                          />
                                        </svg>
                                        <span
                                          id={
                                            runner.selection_id +
                                            "_maxprofit_Mlist_loss_runner_next_" +
                                            (matchOdds && matchOdds.market_id
                                              ? matchOdds.market_id.replace(
                                                ".",
                                                "",
                                              )
                                              : "")
                                          }
                                          className={`to-win market-exposure`}
                                          style={{
                                            fontSize: "0.688rem",
                                            fontWeight: "bold",
                                            textAlign: "left",
                                            color: (() => {
                                              let newExposure =
                                                Number(runner.exposure) || 0;
                                              if (
                                                showBetsSlip &&
                                                BetPlaceData &&
                                                BetPlaceData.price &&
                                                StakeValue > 0 &&
                                                BetPlaceData.market_type ===
                                                "match_odds"
                                              ) {
                                                const odds = parseFloat(
                                                  BetPlaceData.price,
                                                );
                                                const stake =
                                                  parseFloat(StakeValue);
                                                if (BetPlaceData.is_back) {
                                                  if (
                                                    runner.selection_id ===
                                                    BetPlaceData.selection_id
                                                  ) {
                                                    newExposure +=
                                                      (odds - 1) * stake;
                                                  } else {
                                                    newExposure -= stake;
                                                  }
                                                } else {
                                                  if (
                                                    runner.selection_id ===
                                                    BetPlaceData.selection_id
                                                  ) {
                                                    newExposure -=
                                                      (odds - 1) * stake;
                                                  } else {
                                                    newExposure += stake;
                                                  }
                                                }
                                              }
                                              return newExposure < 0
                                                ? "#d32f2f"
                                                : "#228b22";
                                            })(),
                                          }}
                                          data-value={
                                            showBetsSlip &&
                                              BetPlaceData &&
                                              BetPlaceData.price &&
                                              StakeValue > 0 &&
                                              BetPlaceData.market_type ===
                                              "match_odds"
                                              ? (() => {
                                                const odds = parseFloat(
                                                  BetPlaceData.price,
                                                );
                                                const stake =
                                                  parseFloat(StakeValue);
                                                let newExposure =
                                                  Number(runner.exposure) ||
                                                  0;
                                                if (BetPlaceData.is_back) {
                                                  if (
                                                    runner.selection_id ===
                                                    BetPlaceData.selection_id
                                                  ) {
                                                    newExposure +=
                                                      (odds - 1) * stake;
                                                  } else {
                                                    newExposure -= stake;
                                                  }
                                                } else {
                                                  if (
                                                    runner.selection_id ===
                                                    BetPlaceData.selection_id
                                                  ) {
                                                    newExposure -=
                                                      (odds - 1) * stake;
                                                  } else {
                                                    newExposure += stake;
                                                  }
                                                }
                                                return newExposure.toFixed(2);
                                              })()
                                              : Number(runner.exposure).toFixed(
                                                2,
                                              )
                                          }
                                        >
                                          {showBetsSlip &&
                                            BetPlaceData &&
                                            BetPlaceData.price &&
                                            BetPlaceData.market_type ===
                                            "match_odds"
                                            ? StakeValue > 0
                                              ? (() => {
                                                const odds = parseFloat(
                                                  BetPlaceData.price,
                                                );
                                                const stake =
                                                  parseFloat(StakeValue);
                                                let newExposure =
                                                  Number(runner.exposure) ||
                                                  0;
                                                if (BetPlaceData.is_back) {
                                                  if (
                                                    runner.selection_id ===
                                                    BetPlaceData.selection_id
                                                  ) {
                                                    newExposure +=
                                                      (odds - 1) * stake;
                                                  } else {
                                                    newExposure -= stake;
                                                  }
                                                } else {
                                                  if (
                                                    runner.selection_id ===
                                                    BetPlaceData.selection_id
                                                  ) {
                                                    newExposure -=
                                                      (odds - 1) * stake;
                                                  } else {
                                                    newExposure += stake;
                                                  }
                                                }
                                                return Math.round(
                                                  newExposure,
                                                );
                                              })()
                                              : "0"
                                            : Math.round(
                                              Number(runner?.exposure) || 0,
                                            )}
                                        </span>
                                      </>
                                    )}
                                </span>
                              </div>
                            </div>
                            {/* Odds */}
                            <div className="col-span-5 md:col-span-7 h-12 grid grid-cols-2 md:grid-cols-6 relative">
                              <div className="w-full h-full col-span-6">
                                {isMobile ? (
                                  // MOBILE: Only show BACK 1 and LAY 1
                                  <div className="w-full h-full grid grid-cols-2 gap-x-0.5 py-[1px] pr-[2px]">
                                    {/* BACK 1 */}
                                    <div className="w-full h-full">
                                      <div className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_backBtnBg text-text_color_oddValue">
                                        <span className="relative z-1 flex items-center justify-center w-full leading-5 text-sm md:text-[15px] font-semibold">
                                          {runner.back_1_price}
                                        </span>
                                        <span className="relative z-1 flex items-center justify-center w-full text-[10px] leading-3 text-center whitespace-normal font-normal">
                                          {runner.back_1_size}
                                        </span>
                                      </div>
                                    </div>
                                    {/* LAY 1 */}
                                    <div className="w-full h-full">
                                      <div className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_layBtnBg text-text_color_oddValue">
                                        <span className="relative z-1 flex items-center justify-center w-full leading-5 text-sm md:text-[15px] font-semibold">
                                          {runner.lay_1_price}
                                        </span>
                                        <span className="relative z-1 flex items-center justify-center w-full text-[10px] leading-3 text-center whitespace-normal font-normal">
                                          {runner.lay_1_size}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  // DESKTOP: Show all 3 BACK and 3 LAY
                                  <div className="w-full grid grid-cols-12 grid-flow-col overflow-auto h-full gap-x-0.5 py-[1px] pr-[2px]">
                                    {/* BACK 3 */}
                                    <div className="w-full col-span-2 h-full">
                                      <div
                                        className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_backBtnBg text-text_color_oddValue"
                                        style={{
                                          cursor:
                                            runner.back_3_price > 0
                                              ? "pointer"
                                              : "not-allowed",
                                        }}
                                        onClick={() => {
                                          if (runner.back_3_price > 0) {
                                            handleOpenBetSlip(
                                              matchOdds.event_id,
                                              matchOdds.market_id,
                                              true,
                                              `availableToBack3_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false,
                                              runner.selection_id,
                                              runner.runner_name,
                                              `availableToBack3_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false,
                                              matchOdds.market_name,
                                            );
                                          } else {
                                            handleRateZeroClick();
                                          }
                                        }}
                                      >
                                        <span
                                          id={`availableToBack3_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full leading-5 text-sm md:text-[15px] font-semibold"
                                        >
                                          {runner.back_3_price}
                                        </span>
                                        <span
                                          id={`availableToBack3_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full text-[10px] leading-3 text-center whitespace-normal font-normal"
                                        >
                                          {runner.back_3_size}
                                        </span>
                                      </div>
                                    </div>
                                    {/* BACK 2 */}
                                    <div className="w-full col-span-2 h-full">
                                      <div
                                        className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_backBtnBg text-text_color_oddValue"
                                        style={{
                                          cursor:
                                            runner.back_2_price > 0
                                              ? "pointer"
                                              : "not-allowed",
                                        }}
                                        onClick={() => {
                                          if (runner.back_2_price > 0) {
                                            handleOpenBetSlip(
                                              matchOdds.event_id,
                                              matchOdds.market_id,
                                              true,
                                              `availableToBack2_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false,
                                              runner.selection_id,
                                              runner.runner_name,
                                              `availableToBack2_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false,
                                              matchOdds.market_name,
                                            );
                                          } else {
                                            handleRateZeroClick();
                                          }
                                        }}
                                      >
                                        <span
                                          id={`availableToBack2_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full leading-5 text-sm md:text-[15px] font-semibold"
                                        >
                                          {runner.back_2_price}
                                        </span>
                                        <span
                                          id={`availableToBack2_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full text-[10px] leading-3 text-center whitespace-normal font-normal"
                                        >
                                          {runner.back_2_size}
                                        </span>
                                      </div>
                                    </div>
                                    {/* BACK 1 */}
                                    <div className="w-full col-span-2 h-full">
                                      <div
                                        className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_backBtnBg text-text_color_oddValue"
                                        style={{
                                          cursor:
                                            runner.back_1_price > 0
                                              ? "pointer"
                                              : "not-allowed",
                                        }}
                                        onClick={() => {
                                          if (runner.back_1_price > 0) {
                                            handleOpenBetSlip(
                                              matchOdds.event_id,
                                              matchOdds.market_id,
                                              true,
                                              `availableToBack1_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false,
                                              runner.selection_id,
                                              runner.runner_name,
                                              `availableToBack1_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false,
                                              matchOdds.market_name,
                                            );
                                          } else {
                                            handleRateZeroClick();
                                          }
                                        }}
                                      >
                                        <span
                                          id={`availableToBack1_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full leading-5 text-sm md:text-[15px] font-semibold"
                                        >
                                          {runner.back_1_price}
                                        </span>
                                        <span
                                          id={`availableToBack1_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full text-[10px] leading-3 text-center whitespace-normal font-normal"
                                        >
                                          {runner.back_1_size}
                                        </span>
                                      </div>
                                    </div>
                                    {/* LAY 1 */}
                                    <div className="w-full col-span-2 h-full">
                                      <div
                                        className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_layBtnBg text-text_color_oddValue"
                                        style={{
                                          cursor:
                                            runner.lay_1_price > 0
                                              ? "pointer"
                                              : "not-allowed",
                                        }}
                                        onClick={() => {
                                          if (runner.lay_1_price > 0) {
                                            handleOpenBetSlip(
                                              matchOdds.event_id,
                                              matchOdds.market_id,
                                              false,
                                              `availableToLay1_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false,
                                              runner.selection_id,
                                              runner.runner_name,
                                              `availableToLay1_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false,
                                              matchOdds.market_name,
                                            );
                                          } else {
                                            handleRateZeroClick();
                                          }
                                        }}
                                      >
                                        <span
                                          id={`availableToLay1_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full leading-5 text-sm md:text-[15px] font-semibold"
                                        >
                                          {runner.lay_1_price}
                                        </span>
                                        <span
                                          id={`availableToLay1_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full text-[10px] leading-3 text-center whitespace-normal font-normal"
                                        >
                                          {runner.lay_1_size}
                                        </span>
                                      </div>
                                    </div>
                                    {/* LAY 2 */}
                                    <div className="w-full col-span-2 h-full">
                                      <div
                                        className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_layBtnBg text-text_color_oddValue"
                                        style={{
                                          cursor:
                                            runner.lay_2_price > 0
                                              ? "pointer"
                                              : "not-allowed",
                                        }}
                                        onClick={() => {
                                          if (runner.lay_2_price > 0) {
                                            handleOpenBetSlip(
                                              matchOdds.event_id,
                                              matchOdds.market_id,
                                              false,
                                              `availableToLay2_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false,
                                              runner.selection_id,
                                              runner.runner_name,
                                              `availableToLay2_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false,
                                              matchOdds.market_name,
                                            );
                                          } else {
                                            handleRateZeroClick();
                                          }
                                        }}
                                      >
                                        <span
                                          id={`availableToLay2_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full leading-5 text-sm md:text-[15px] font-semibold"
                                        >
                                          {runner.lay_2_price}
                                        </span>
                                        <span
                                          id={`availableToLay2_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full text-[10px] leading-3 text-center whitespace-normal font-normal"
                                        >
                                          {runner.lay_2_size}
                                        </span>
                                      </div>
                                    </div>
                                    {/* LAY 3 */}
                                    <div className="w-full col-span-2 h-full">
                                      <div
                                        className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_layBtnBg text-text_color_oddValue"
                                        style={{
                                          cursor:
                                            runner.lay_3_price > 0
                                              ? "pointer"
                                              : "not-allowed",
                                        }}
                                        onClick={() => {
                                          if (runner.lay_3_price > 0) {
                                            handleOpenBetSlip(
                                              matchOdds.event_id,
                                              matchOdds.market_id,
                                              false,
                                              `availableToLay3_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false,
                                              runner.selection_id,
                                              runner.runner_name,
                                              `availableToLay3_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`,
                                              false,
                                              matchOdds.market_name,
                                            );
                                          } else {
                                            handleRateZeroClick();
                                          }
                                        }}
                                      >
                                        <span
                                          id={`availableToLay3_price_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full leading-5 text-sm md:text-[15px] font-semibold"
                                        >
                                          {runner.lay_3_price}
                                        </span>
                                        <span
                                          id={`availableToLay3_size_${matchOdds.market_id.replace(".", "")}_${runner.selection_id}`}
                                          className="relative z-1 flex items-center justify-center w-full text-[10px] leading-3 text-center whitespace-normal font-normal"
                                        >
                                          {runner.lay_3_size}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Toss */}
              {eventData.length > 0 &&
                eventData.map(
                  (event, index) =>
                    event.marketTypes &&
                    event.marketTypes.length > 0 &&
                    event.marketTypes.map(
                      (market, indexm) =>
                        market.marketRunners &&
                        market.marketRunners.length > 0 &&
                        market.market_name == "Toss" && (
                          <div
                            className="w-full text-selection-none pb-3 lg:pb-0"
                            key={market.market_id}
                          >
                            <div className="px-2 font-helvetica">
                              <div className="py-1.5">
                                {/* Header Row */}
                                <div className="grid grid-flow-col grid-cols-12 text-text_color_primary1 text-xs font-[500] mb-1.5">
                                  <div className="pl-1 flex items-center justify-start gap-x-1 md:gap-x-1 col-span-7 md:col-span-5">
                                    <div
                                      className="capitalize font-bold text-xs sm:text-sm md:text-[15px] flex items-start justify-start flex-col"
                                      title="Toss"
                                    >
                                      <span>Toss Winner</span>
                                      <span className="text-x font-normal text-text_color_info"></span>
                                    </div>
                                  </div>
                                  <div className="col-span-5 md:col-span-7 flex items-end justify-end pb-[2px]">
                                    <div className="w-full md:w-1/3 grid grid-cols-2">
                                      <span className="text-center text-[10px] sm:text-xs md:text-sm leading-3 font-bold h-full flex items-end justify-center">
                                        BACK
                                      </span>

                                      <span className="text-center text-[10px] sm:text-xs md:text-sm leading-3 font-bold h-full flex items-end justify-center">
                                        LAY
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                {/* Runner Rows */}
                                <div className="bg-bg_color_primary rounded-[3px] shadow-[0_8px_30px_rgb(0,0,0,0.12)] py-[1px]">
                                  {market.marketRunners
                                    .slice(0, 2)
                                    .map((runner, idx) => (
                                      <div
                                        key={runner.selection_id || idx}
                                        className="grid grid-cols-12 border-b border-border_color_primary1"
                                      >
                                        {/* Team Name */}
                                        <div className="w-full md:col-span-5 col-span-7 h-12 grid grid-cols-12 grid-flow-col pl-2.5 md:pl-2 py-0.5 pr-[3px]">
                                          <div className="truncate col-span-12 flex items-start justify-center h-full flex-col">
                                            <div className="w-full flex flex-wrap">
                                              <div
                                                title={runner.runner_name}
                                                className="flex items-center flex-1 capitalize text-text_color_primary1 text-[13px] md:text-sm font-semibold truncate text-start h-full pr-0.5 md:pr-0"
                                              >
                                                <span className="truncate">
                                                  {String(
                                                    runner?.runner_name ||
                                                    runner?.runnerName ||
                                                    "Runner",
                                                  )
                                                    .split(" ")
                                                    .slice(0, 3)
                                                    .join(" ")}
                                                </span>
                                              </div>
                                            </div>
                                            <span
                                              style={{
                                                marginLeft: "5px",
                                                fontSize: "0.688rem",
                                                color: "#228b22",
                                                fontWeight: "bold",
                                                display: "flex",
                                                textAlign: "left",
                                                alignItems: "center",
                                                gap: "4px",
                                              }}
                                            >
                                              <span
                                                id={
                                                  runner.selection_id +
                                                  "_maxprofit_list_loss_runner_prev_toss_" +
                                                  (market && market.market_id
                                                    ? market.market_id.replace(
                                                      ".",
                                                      "",
                                                    )
                                                    : "")
                                                }
                                                className={`win market-exposure`}
                                                style={{
                                                  fontSize: "0.688rem",
                                                  fontWeight: "bold",
                                                  textAlign: "left",
                                                  marginLeft: "5px",
                                                  marginRight: "3px",
                                                }}
                                                data-value={runner.exposure}
                                              >
                                                {/* Before arrow: show exposure after bet placed (current exposure) */}
                                                {Math.round(
                                                  Number(runner?.exposure) || 0,
                                                )}
                                              </span>
                                              {showBetsSlip &&
                                                is_fancy == false &&
                                                BetPlaceData.market_type ===
                                                "toss" && (
                                                  <>
                                                    <svg
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      width="10"
                                                      height="10"
                                                    >
                                                      <path
                                                        d="M0 3h4v4H0V3zm4 7V0l6 5-6 5z"
                                                        fill="#508E0D"
                                                        fillRule="evenodd"
                                                      />
                                                    </svg>
                                                    <span
                                                      id={
                                                        runner.selection_id +
                                                        "_maxprofit_Mlist_loss_runner_next_toss_" +
                                                        (market &&
                                                          market.market_id
                                                          ? market.market_id.replace(
                                                            ".",
                                                            "",
                                                          )
                                                          : "")
                                                      }
                                                      className={`to-win market-exposure `}
                                                      style={{
                                                        fontSize: "0.688rem",
                                                        fontWeight: "bold",
                                                        textAlign: "left",
                                                      }}
                                                      data-value={(() => {
                                                        // After arrow: show zero until amount is selected, then show live calculation
                                                        if (
                                                          showBetsSlip &&
                                                          BetPlaceData &&
                                                          BetPlaceData.price &&
                                                          StakeValue > 0 &&
                                                          market.market_id ===
                                                          BetPlaceData.market_id &&
                                                          BetPlaceData.market_type ===
                                                          "toss"
                                                        ) {
                                                          const odds =
                                                            parseFloat(
                                                              BetPlaceData.price,
                                                            );
                                                          const stake =
                                                            parseFloat(
                                                              StakeValue,
                                                            );
                                                          let newExposure =
                                                            Number(
                                                              runner.exposure,
                                                            ) || 0;
                                                          if (
                                                            BetPlaceData.is_back
                                                          ) {
                                                            if (
                                                              runner.selection_id ===
                                                              BetPlaceData.selection_id
                                                            ) {
                                                              newExposure +=
                                                                (odds - 1) *
                                                                stake;
                                                            } else {
                                                              newExposure -=
                                                                stake;
                                                            }
                                                          } else {
                                                            if (
                                                              runner.selection_id ===
                                                              BetPlaceData.selection_id
                                                            ) {
                                                              newExposure -=
                                                                (odds - 1) *
                                                                stake;
                                                            } else {
                                                              newExposure +=
                                                                stake;
                                                            }
                                                          }
                                                          return newExposure.toFixed(
                                                            2,
                                                          );
                                                        }
                                                        // If no amount selected, show zero
                                                        return "0";
                                                      })()}
                                                    >
                                                      {/* After arrow: show zero until amount is selected, then show live calculation */}
                                                      {showBetsSlip &&
                                                        BetPlaceData &&
                                                        BetPlaceData.price &&
                                                        StakeValue > 0 &&
                                                        market.market_id ===
                                                        BetPlaceData.market_id &&
                                                        BetPlaceData.market_type ===
                                                        "toss"
                                                        ? (() => {
                                                          const odds =
                                                            parseFloat(
                                                              BetPlaceData.price,
                                                            );
                                                          const stake =
                                                            parseFloat(
                                                              StakeValue,
                                                            );
                                                          let newExposure =
                                                            Number(
                                                              runner.exposure,
                                                            ) || 0;
                                                          if (
                                                            BetPlaceData.is_back
                                                          ) {
                                                            if (
                                                              runner.selection_id ===
                                                              BetPlaceData.selection_id
                                                            ) {
                                                              newExposure +=
                                                                (odds - 1) *
                                                                stake;
                                                            } else {
                                                              newExposure -=
                                                                stake;
                                                            }
                                                          } else {
                                                            if (
                                                              runner.selection_id ===
                                                              BetPlaceData.selection_id
                                                            ) {
                                                              newExposure -=
                                                                (odds - 1) *
                                                                stake;
                                                            } else {
                                                              newExposure +=
                                                                stake;
                                                            }
                                                          }
                                                          return Math.round(
                                                            newExposure,
                                                          );
                                                        })()
                                                        : 0}
                                                    </span>
                                                  </>
                                                )}
                                            </span>
                                          </div>
                                        </div>
                                        {/* Odds */}
                                        {/* Toss Odds: only Back-1 and Lay-1 */}
                                        <div className="col-span-5 md:col-span-7 h-12 flex justify-end relative py-[1px]">
                                          <div className="w-full md:w-1/3 h-full grid grid-cols-2 gap-x-0.5">
                                            {/* BACK 1 */}
                                            <div className="w-full h-full min-w-0">
                                              <div
                                                className="overflow-hidden relative w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_backBtnBg text-text_color_oddValue"
                                                style={{
                                                  cursor:
                                                    Number(
                                                      runner?.back_1_price,
                                                    ) > 0
                                                      ? "pointer"
                                                      : "not-allowed",
                                                }}
                                                onClick={() => {
                                                  if (
                                                    Number(
                                                      runner?.back_1_price,
                                                    ) > 0
                                                  ) {
                                                    handleOpenBetSlip(
                                                      event.event_id,
                                                      market.market_id,
                                                      true,
                                                      `availableTossBackSize_${market.market_id.replace(".", "")}_${runner.selection_id}`,
                                                      false,
                                                      runner.selection_id,
                                                      runner.runner_name,
                                                      `availableTossBackPrice_${market.market_id.replace(".", "")}_${runner.selection_id}`,
                                                      false,
                                                      market.market_name,
                                                    );
                                                  } else {
                                                    handleRateZeroClick();
                                                  }
                                                }}
                                              >
                                                <span
                                                  id={`availableTossBackPrice_${market.market_id.replace(".", "")}_${runner.selection_id}`}
                                                  className="font-semibold leading-5 text-sm md:text-[15px]"
                                                >
                                                  {runner?.back_1_price || 0}
                                                </span>

                                                <span
                                                  id={`availableTossBackSize_${market.market_id.replace(".", "")}_${runner.selection_id}`}
                                                  className="text-[10px] leading-3"
                                                >
                                                  {runner?.back_1_size || 0}
                                                </span>
                                              </div>
                                            </div>

                                            {/* LAY 1 */}
                                            <div className="w-full h-full min-w-0">
                                              <div
                                                className="overflow-hidden relative w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_layBtnBg text-text_color_oddValue"
                                                style={{
                                                  cursor:
                                                    Number(
                                                      runner?.lay_1_price,
                                                    ) > 0
                                                      ? "pointer"
                                                      : "not-allowed",
                                                }}
                                                onClick={() => {
                                                  if (
                                                    Number(
                                                      runner?.lay_1_price,
                                                    ) > 0
                                                  ) {
                                                    handleOpenBetSlip(
                                                      event.event_id,
                                                      market.market_id,
                                                      false,
                                                      `availableTossLaySize_${market.market_id.replace(".", "")}_${runner.selection_id}`,
                                                      false,
                                                      runner.selection_id,
                                                      runner.runner_name,
                                                      `availableTossLayPrice_${market.market_id.replace(".", "")}_${runner.selection_id}`,
                                                      false,
                                                      market.market_name,
                                                    );
                                                  } else {
                                                    handleRateZeroClick();
                                                  }
                                                }}
                                              >
                                                <span
                                                  id={`availableTossLayPrice_${market.market_id.replace(".", "")}_${runner.selection_id}`}
                                                  className="font-semibold leading-5 text-sm md:text-[15px]"
                                                >
                                                  {runner?.lay_1_price || 0}
                                                </span>

                                                <span
                                                  id={`availableTossLaySize_${market.market_id.replace(".", "")}_${runner.selection_id}`}
                                                  className="text-[10px] leading-3"
                                                >
                                                  {runner?.lay_1_size || 0}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        ),
                    ),
                )}

              {/* bookmaker */}

              {eventData.length > 0 && bookmaker && bookmaker.marketRunners && (
                <div className="w-full text-selection-none pb-3 lg:pb-0">
                  <div className="px-2 font-helvetica">
                    <div className="py-1.5">
                      {/* Header Row */}
                      <div className="grid grid-flow-col grid-cols-12 text-text_color_primary1 text-xs font-[500] mb-1.5">
                        <div className="pl-1 flex items-center justify-start gap-x-1 md:gap-x-1 col-span-7 md:col-span-5">
                          <div
                            className="capitalize font-bold text-xs sm:text-sm md:text-[15px] flex items-start justify-start flex-col"
                            title="Bookmaker"
                          >
                            <span>Bookmaker</span>
                            <span className="text-x font-normal text-text_color_info"></span>
                          </div>
                        </div>
                        <div className="col-span-5 md:col-span-7 grid grid-cols-2 md:grid-cols-6 pb-[2px]">
                          {isMobile ? (
                            <>
                              <span className="col-span-1 text-center text-[10px] sm:text-xs md:text-sm leading-3 font-bold h-full flex items-end justify-center">
                                BACK
                              </span>
                              <span className="col-span-1 text-center text-[10px] sm:text-xs md:text-sm leading-3 font-bold h-full flex items-end justify-center">
                                LAY
                              </span>
                            </>
                          ) : (
                            <>
                              <span className="hidden md:flex col-span-1 text-center font-semibold h-full items-end justify-center"></span>
                              <span className="col-span-1 text-center font-semibold h-full hidden md:flex items-end justify-center"></span>
                              <span className="col-span-1 text-center text-[10px] sm:text-xs md:text-sm leading-3 font-bold h-full flex items-end justify-center">
                                BACK
                              </span>
                              <span className="col-span-1 text-center text-[10px] sm:text-xs md:text-sm leading-3 font-bold h-full flex items-end justify-center">
                                LAY
                              </span>
                              <span className="col-span-1 text-center font-semibold h-full hidden md:flex items-end justify-center"></span>
                              <span className="col-span-1 text-center font-semibold h-full hidden md:flex items-end justify-center"></span>
                            </>
                          )}
                        </div>
                      </div>
                      {/* Runner Rows */}
                      <div className="bg-bg_color_primary rounded-[3px] shadow-[0_8px_30px_rgb(0,0,0,0.12)] py-[1px]">
                        {bookmaker.marketRunners.map((runner, idx) => (
                          <div
                            key={runner.selection_id || idx}
                            className="grid grid-cols-12 border-b border-border_color_primary1"
                          >
                            {/* Team Name */}
                            <div className="w-full md:col-span-5 col-span-7 h-12 grid grid-cols-12 grid-flow-col pl-2.5 md:pl-2 py-0.5 pr-[3px]">
                              <div className="truncate col-span-12 flex items-start justify-center h-full flex-col">
                                <div className="w-full flex flex-wrap">
                                  <div
                                    title={runner.runner_name}
                                    className="flex items-center flex-1 capitalize text-text_color_primary1 text-[13px] md:text-sm font-semibold truncate text-start h-full pr-0.5 md:pr-0"
                                  >
                                    <span className="truncate">
                                      {runner?.runner_name ||
                                        runner?.runnerName ||
                                        "Runner"}
                                    </span>
                                  </div>
                                </div>
                                {/* Exposure/Profit block for Bookmaker */}
                                <span
                                  style={{
                                    marginLeft: "5px",
                                    fontSize: "0.688rem",
                                    fontWeight: "bold",
                                    display: "flex",
                                    textAlign: "left",
                                    alignItems: "center",
                                    gap: "4px",
                                  }}
                                >
                                  {/* Only show bookmaker exposure calculation for bookmaker bets */}
                                  <span
                                    id={
                                      runner.selection_id +
                                      "_maxprofit_list_loss_runner_prev_" +
                                      (bookmaker && bookmaker.market_id
                                        ? bookmaker.market_id.replace(".", "")
                                        : "")
                                    }
                                    className={`win market-exposure`}
                                    style={{
                                      fontSize: "0.688rem",
                                      fontWeight: "bold",
                                      textAlign: "left",
                                      marginLeft: "5px",
                                      marginRight: "3px",
                                      color:
                                        runner.exposure < 0
                                          ? "#d32f2f"
                                          : "#228b22",
                                    }}
                                    data-value={runner.exposure}
                                  >
                                    {showBetsSlip &&
                                      BetPlaceData &&
                                      BetPlaceData.price &&
                                      StakeValue > 0 &&
                                      BetPlaceData.market_id ===
                                      bookmaker.market_id &&
                                      BetPlaceData.market_type === "bookmaker"
                                      ? (() => {
                                        const odds = parseFloat(
                                          BetPlaceData.price,
                                        );
                                        const stake = parseFloat(StakeValue);
                                        let newExposure =
                                          Number(runner.exposure) || 0;
                                        if (BetPlaceData.is_back) {
                                          if (
                                            runner.selection_id ===
                                            BetPlaceData.selection_id
                                          ) {
                                            newExposure += (odds - 1) * stake;
                                          } else {
                                            newExposure -= stake;
                                          }
                                        } else {
                                          if (
                                            runner.selection_id ===
                                            BetPlaceData.selection_id
                                          ) {
                                            newExposure -= (odds - 1) * stake;
                                          } else {
                                            newExposure += stake;
                                          }
                                        }
                                        return Math.round(newExposure);
                                      })()
                                      : Math.round(
                                        Number(runner?.exposure) || 0,
                                      )}
                                  </span>
                                  {/* Arrow */}
                                  {showBetsSlip &&
                                    is_fancy == false &&
                                    BetPlaceData.market_type ===
                                    "bookmaker" && (
                                      <>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="10"
                                          height="10"
                                        >
                                          <path
                                            d="M0 3h4v4H0V3zm4 7V0l6 5-6 5z"
                                            fill="#508E0D"
                                            fillRule="evenodd"
                                          />
                                        </svg>
                                        <span
                                          id={
                                            runner.selection_id +
                                            "_maxprofit_Mlist_loss_runner_next_" +
                                            (bookmaker && bookmaker.market_id
                                              ? bookmaker.market_id.replace(
                                                ".",
                                                "",
                                              )
                                              : "")
                                          }
                                          className={`to-win market-exposure`}
                                          style={{
                                            fontSize: "0.688rem",
                                            fontWeight: "bold",
                                            textAlign: "left",
                                            color: (() => {
                                              let newExposure =
                                                Number(runner.exposure) || 0;
                                              if (
                                                showBetsSlip &&
                                                BetPlaceData &&
                                                BetPlaceData.price &&
                                                StakeValue > 0 &&
                                                BetPlaceData.market_type ===
                                                "bookmaker"
                                              ) {
                                                const odds = parseFloat(
                                                  BetPlaceData.price,
                                                );
                                                const stake =
                                                  parseFloat(StakeValue);
                                                if (BetPlaceData.is_back) {
                                                  if (
                                                    runner.selection_id ===
                                                    BetPlaceData.selection_id
                                                  ) {
                                                    newExposure +=
                                                      (odds - 1) * stake;
                                                  } else {
                                                    newExposure -= stake;
                                                  }
                                                } else {
                                                  if (
                                                    runner.selection_id ===
                                                    BetPlaceData.selection_id
                                                  ) {
                                                    newExposure -=
                                                      (odds - 1) * stake;
                                                  } else {
                                                    newExposure += stake;
                                                  }
                                                }
                                              }
                                              return newExposure < 0
                                                ? "#d32f2f"
                                                : "#228b22";
                                            })(),
                                          }}
                                          data-value={
                                            showBetsSlip &&
                                              BetPlaceData &&
                                              BetPlaceData.price &&
                                              StakeValue > 0 &&
                                              BetPlaceData.market_type ===
                                              "bookmaker"
                                              ? (() => {
                                                const odds = parseFloat(
                                                  BetPlaceData.price,
                                                );
                                                const stake =
                                                  parseFloat(StakeValue);
                                                let newExposure =
                                                  Number(runner.exposure) ||
                                                  0;
                                                if (BetPlaceData.is_back) {
                                                  if (
                                                    runner.selection_id ===
                                                    BetPlaceData.selection_id
                                                  ) {
                                                    newExposure +=
                                                      (odds - 1) * stake;
                                                  } else {
                                                    newExposure -= stake;
                                                  }
                                                } else {
                                                  if (
                                                    runner.selection_id ===
                                                    BetPlaceData.selection_id
                                                  ) {
                                                    newExposure -=
                                                      (odds - 1) * stake;
                                                  } else {
                                                    newExposure += stake;
                                                  }
                                                }
                                                return newExposure.toFixed(2);
                                              })()
                                              : Number(runner.exposure).toFixed(
                                                2,
                                              )
                                          }
                                        >
                                          {showBetsSlip &&
                                            BetPlaceData &&
                                            BetPlaceData.price &&
                                            BetPlaceData.market_type ===
                                            "bookmaker"
                                            ? StakeValue > 0
                                              ? (() => {
                                                const odds = parseFloat(
                                                  BetPlaceData.price,
                                                );
                                                const stake =
                                                  parseFloat(StakeValue);
                                                let newExposure =
                                                  Number(runner.exposure) ||
                                                  0;
                                                if (BetPlaceData.is_back) {
                                                  if (
                                                    runner.selection_id ===
                                                    BetPlaceData.selection_id
                                                  ) {
                                                    newExposure +=
                                                      (odds - 1) * stake;
                                                  } else {
                                                    newExposure -= stake;
                                                  }
                                                } else {
                                                  if (
                                                    runner.selection_id ===
                                                    BetPlaceData.selection_id
                                                  ) {
                                                    newExposure -=
                                                      (odds - 1) * stake;
                                                  } else {
                                                    newExposure += stake;
                                                  }
                                                }
                                                return Math.round(
                                                  newExposure,
                                                );
                                              })()
                                              : "0"
                                            : Math.round(
                                              Number(runner?.exposure) || 0,
                                            )}
                                        </span>
                                      </>
                                    )}
                                </span>
                              </div>
                            </div>
                            {/* Odds */}
                            {allSuspended ? (
                              <div className="col-span-5 md:col-span-7 h-12 grid grid-cols-2 md:grid-cols-6 relative">
                                <div className="w-full h-full col-span-6">
                                  <div className="w-full h-full flex items-center justify-center">
                                    <div
                                      className="w-full h-full rounded-sm flex items-center justify-center bg-bg_color_suspended text-color-suspendedFontColor text-xs font-bold"
                                      style={{
                                        cursor: "not-allowed",
                                        minHeight: "48px",
                                        minWidth: "100%",
                                      }}
                                    >
                                      Suspended
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div className="col-span-5 md:col-span-7 h-12 grid grid-cols-2 md:grid-cols-6 relative">
                                <div className="w-full h-full col-span-6">
                                  {isMobile ? (
                                    // MOBILE: Only show BACK 1 and LAY 1
                                    <div className="w-full h-full grid grid-cols-2 gap-x-0.5 py-[1px] pr-[2px]">
                                      {/* BACK 1 */}
                                      <div className="w-full h-full">
                                        <div
                                          className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_backBtnBg text-text_color_oddValue"
                                          style={{
                                            cursor:
                                              runner.back_1_price > 0
                                                ? "pointer"
                                                : "not-allowed",
                                          }}
                                          onClick={() => {
                                            if (runner.back_1_price > 0) {
                                              handleOpenBetSlip(
                                                bookmaker.event_id,
                                                bookmaker.market_id,
                                                true,
                                                `availableToBack1_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                runner.selection_id,
                                                runner.runner_name,
                                                `availableToBack1_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                bookmaker.market_name,
                                              );
                                            } else {
                                              handleRateZeroClick();
                                            }
                                          }}
                                        >
                                          <span
                                            id={`availableToBack1_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                            className="relative z-1 flex items-center justify-center w-full leading-5 text-sm md:text-[15px] font-semibold"
                                          >
                                            {runner.back_1_price}
                                          </span>
                                          <span
                                            id={`availableToBack1_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                            className="relative z-1 flex items-center justify-center w-full text-[10px] leading-3 text-center whitespace-normal font-normal"
                                          >
                                            {runner.back_1_size}
                                          </span>
                                        </div>
                                      </div>
                                      {/* LAY 1 */}
                                      <div className="w-full h-full">
                                        <div
                                          className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_layBtnBg text-text_color_oddValue"
                                          style={{
                                            cursor:
                                              runner.lay_1_price > 0
                                                ? "pointer"
                                                : "not-allowed",
                                          }}
                                          onClick={() => {
                                            if (runner.lay_1_price > 0) {
                                              handleOpenBetSlip(
                                                bookmaker.event_id,
                                                bookmaker.market_id,
                                                false,
                                                `availableToLay1_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                runner.selection_id,
                                                runner.runner_name,
                                                `availableToLay1_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                bookmaker.market_name,
                                              );
                                            } else {
                                              handleRateZeroClick();
                                            }
                                          }}
                                        >
                                          <span
                                            id={`availableToLay1_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                            className="relative z-1 flex items-center justify-center w-full leading-5 text-sm md:text-[15px] font-semibold"
                                          >
                                            {runner.lay_1_price}
                                          </span>
                                          <span
                                            id={`availableToLay1_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                            className="relative z-1 flex items-center justify-center w-full text-[10px] leading-3 text-center whitespace-normal font-normal"
                                          >
                                            {runner.lay_1_size}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    // DESKTOP: Show all 3 BACK and 3 LAY
                                    <div className="w-full grid grid-cols-12 grid-flow-col overflow-auto h-full gap-x-0.5 py-[1px] pr-[2px]">
                                      {/* BACK 3 */}
                                      <div className="w-full col-span-2 h-full">
                                        <div
                                          className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_backBtnBg text-text_color_oddValue"
                                          style={{
                                            cursor:
                                              runner.back_3_price > 0
                                                ? "pointer"
                                                : "not-allowed",
                                          }}
                                          onClick={() => {
                                            if (runner.back_3_price > 0) {
                                              handleOpenBetSlip(
                                                bookmaker.event_id,
                                                bookmaker.market_id,
                                                true,
                                                `availableToBack3_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                runner.selection_id,
                                                runner.runner_name,
                                                `availableToBack3_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                bookmaker.market_name,
                                              );
                                            } else {
                                              handleRateZeroClick();
                                            }
                                          }}
                                        >
                                          <span
                                            id={`availableToBack3_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                            className="relative z-1 flex items-center justify-center w-full leading-5 text-sm md:text-[15px] font-semibold"
                                          >
                                            {runner.back_3_price}
                                          </span>
                                          <span
                                            id={`availableToBack3_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                            className="relative z-1 flex items-center justify-center w-full text-[10px] leading-3 text-center whitespace-normal font-normal"
                                          >
                                            {runner.back_3_size}
                                          </span>
                                        </div>
                                      </div>
                                      {/* BACK 2 */}
                                      <div className="w-full col-span-2 h-full">
                                        <div
                                          className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_backBtnBg text-text_color_oddValue"
                                          style={{
                                            cursor:
                                              runner.back_2_price > 0
                                                ? "pointer"
                                                : "not-allowed",
                                          }}
                                          onClick={() => {
                                            if (runner.back_2_price > 0) {
                                              handleOpenBetSlip(
                                                bookmaker.event_id,
                                                bookmaker.market_id,
                                                true,
                                                `availableToBack2_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                runner.selection_id,
                                                runner.runner_name,
                                                `availableToBack2_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                bookmaker.market_name,
                                              );
                                            } else {
                                              handleRateZeroClick();
                                            }
                                          }}
                                        >
                                          <span
                                            id={`availableToBack2_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                            className="relative z-1 flex items-center justify-center w-full leading-5 text-sm md:text-[15px] font-semibold"
                                          >
                                            {runner.back_2_price}
                                          </span>
                                          <span
                                            id={`availableToBack2_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                            className="relative z-1 flex items-center justify-center w-full text-[10px] leading-3 text-center whitespace-normal font-normal"
                                          >
                                            {runner.back_2_size}
                                          </span>
                                        </div>
                                      </div>
                                      {/* BACK 1 */}
                                      <div className="w-full col-span-2 h-full">
                                        <div
                                          className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_backBtnBg text-text_color_oddValue"
                                          style={{
                                            cursor:
                                              runner.back_1_price > 0
                                                ? "pointer"
                                                : "not-allowed",
                                          }}
                                          onClick={() => {
                                            if (runner.back_1_price > 0) {
                                              handleOpenBetSlip(
                                                bookmaker.event_id,
                                                bookmaker.market_id,
                                                true,
                                                `availableToBack1_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                runner.selection_id,
                                                runner.runner_name,
                                                `availableToBack1_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                bookmaker.market_name,
                                              );
                                            } else {
                                              handleRateZeroClick();
                                            }
                                          }}
                                        >
                                          <span
                                            id={`availableToBack1_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                            className="relative z-1 flex items-center justify-center w-full leading-5 text-sm md:text-[15px] font-semibold"
                                          >
                                            {runner.back_1_price}
                                          </span>
                                          <span
                                            id={`availableToBack1_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                            className="relative z-1 flex items-center justify-center w-full text-[10px] leading-3 text-center whitespace-normal font-normal"
                                          >
                                            {runner.back_1_size}
                                          </span>
                                        </div>
                                      </div>
                                      {/* LAY 1 */}
                                      <div className="w-full col-span-2 h-full">
                                        <div
                                          className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_layBtnBg text-text_color_oddValue"
                                          style={{
                                            cursor:
                                              runner.lay_1_price > 0
                                                ? "pointer"
                                                : "not-allowed",
                                          }}
                                          onClick={() => {
                                            if (runner.lay_1_price > 0) {
                                              handleOpenBetSlip(
                                                bookmaker.event_id,
                                                bookmaker.market_id,
                                                false,
                                                `availableToLay1_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                runner.selection_id,
                                                runner.runner_name,
                                                `availableToLay1_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                bookmaker.market_name,
                                              );
                                            } else {
                                              handleRateZeroClick();
                                            }
                                          }}
                                        >
                                          <span
                                            id={`availableToLay1_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                            className="relative z-1 flex items-center justify-center w-full leading-5 text-sm md:text-[15px] font-semibold"
                                          >
                                            {runner.lay_1_price}
                                          </span>
                                          <span
                                            id={`availableToLay1_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                            className="relative z-1 flex items-center justify-center w-full text-[10px] leading-3 text-center whitespace-normal font-normal"
                                          >
                                            {runner.lay_1_size}
                                          </span>
                                        </div>
                                      </div>
                                      {/* LAY 2 */}
                                      <div className="w-full col-span-2 h-full">
                                        <div
                                          className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_layBtnBg text-text_color_oddValue"
                                          style={{
                                            cursor:
                                              runner.lay_2_price > 0
                                                ? "pointer"
                                                : "not-allowed",
                                          }}
                                          onClick={() => {
                                            if (runner.lay_2_price > 0) {
                                              handleOpenBetSlip(
                                                bookmaker.event_id,
                                                bookmaker.market_id,
                                                false,
                                                `availableToLay2_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                runner.selection_id,
                                                runner.runner_name,
                                                `availableToLay2_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                bookmaker.market_name,
                                              );
                                            } else {
                                              handleRateZeroClick();
                                            }
                                          }}
                                        >
                                          <span
                                            id={`availableToLay2_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                            className="relative z-1 flex items-center justify-center w-full leading-5 text-sm md:text-[15px] font-semibold"
                                          >
                                            {runner.lay_2_price}
                                          </span>
                                          <span
                                            id={`availableToLay2_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                            className="relative z-1 flex items-center justify-center w-full text-[10px] leading-3 text-center whitespace-normal font-normal"
                                          >
                                            {runner.lay_2_size}
                                          </span>
                                        </div>
                                      </div>
                                      {/* LAY 3 */}
                                      <div className="w-full col-span-2 h-full">
                                        <div
                                          className="overflow-hidden relative opacity-100 w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_layBtnBg text-text_color_oddValue"
                                          style={{
                                            cursor:
                                              runner.lay_3_price > 0
                                                ? "pointer"
                                                : "not-allowed",
                                          }}
                                          onClick={() => {
                                            if (runner.lay_3_price > 0) {
                                              handleOpenBetSlip(
                                                bookmaker.event_id,
                                                bookmaker.market_id,
                                                false,
                                                `availableToLay3_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                runner.selection_id,
                                                runner.runner_name,
                                                `availableToLay3_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`,
                                                false,
                                                bookmaker.market_name,
                                              );
                                            } else {
                                              handleRateZeroClick();
                                            }
                                          }}
                                        >
                                          <span
                                            id={`availableToLay3_price_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                            className="relative z-1 flex items-center justify-center w-full leading-5 text-sm md:text-[15px] font-semibold"
                                          >
                                            {runner.lay_3_price}
                                          </span>
                                          <span
                                            id={`availableToLay3_size_${bookmaker.market_id.replace(".", "")}_${runner.selection_id}`}
                                            className="relative z-1 flex items-center justify-center w-full text-[10px] leading-3 text-center whitespace-normal font-normal"
                                          >
                                            {runner.lay_3_size}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* fancy */}
              {/* Fancy/Premium Market Heading */}
              {fancyOddsData && fancyOddsData.length > 0 && (
                <div className="text-base font-medium text-center py-1.5">
                  <ul className="flex flex-wrap items-center justify-start gap-x-3">
                    <li className="px-[15px] py-2 rounded-[100px] flex items-center justify-center cursor-pointer active:scale-95 transition-all ease-in-out duration-100 bg-bg_text_brand_primary text-text_color_primary2 border-border_color_brand_primary">
                      <span className="inline-block font-bold text-xs sm:text-sm md:text-base leading-4">
                        Fancy Market
                      </span>
                    </li>
                    <li className="px-[15px] py-2 border rounded-[100px] flex items-center justify-center cursor-pointer active:scale-95 transition-all ease-in-out duration-100 bg-bg_color_primary text-text_color_tertiary2 border-border_color_primary">
                      <span className="inline-block font-bold text-xs sm:text-sm md:text-base leading-4">
                        Premium Market
                      </span>
                    </li>
                  </ul>
                </div>
              )}
              {fancyOddsData.map((fancy, idx) => (
                <div
                  key={fancy.selection_id || idx}
                  className="grid grid-cols-12 border-b border-border_color_primary1"
                >
                  {/* Team Name, Watch, Stairs */}
                  <div className="w-full md:col-span-6 col-span-7 h-12 grid grid-cols-12 grid-flow-col pl-2.5 md:pl-2 py-0.5 pr-[3px]">
                    <div className="col-span-8 md:col-span-10 flex flex-col h-full">
                      <div className="w-full flex flex-nowrap flex-1">
                        <div
                          title={fancy.runner_name}
                          className="flex items-center flex-1 capitalize text-text_color_primary1 text-[13px] md:text-sm font-semibold truncate text-start pr-0.5 md:pr-0"
                        >
                          <span className="truncate">{fancy.runner_name}</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-span-2 md:col-span-1 flex flex-row items-center justify-center gap-x-[2px]">
                      {/* Watch Icon */}
                      <svg
                        version="1.0"
                        height="15"
                        width="15"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 840.000000 936.000000"
                        preserveAspectRatio="xMidYMid meet"
                      >
                        <g
                          transform="translate(0.000000,936.000000) scale(0.100000,-0.100000)"
                          fill="var(--icon-color-brand-tertiary1)"
                          stroke="none"
                        >
                          <path d="M3472 8818 l3 -243 243 -3 242 -2 0 -244 0 -243 -122 -12 c-1359 -130 -2543 -950 -3143 -2176 -155 -318 -271 -677 -334 -1035 -75 -424 -73 -934 5 -1360 226 -1229 1014 -2267 2136 -2810 694 -335 1447 -455 2228 -354 567 74 1147 294 1640 624 792 530 1374 1353 1605 2270 133 529 156 1092 65 1627 -175 1029 -775 1959 -1645 2552 -539 367 -1135 586 -1792 657 l-163 18 0 243 0 243 243 2 242 3 3 243 2 242 -730 0 -730 0 2 -242z m1138 -1242 c478 -59 937 -216 1346 -463 765 -461 1323 -1208 1543 -2067 190 -738 131 -1502 -171 -2206 -175 -408 -460 -814 -789 -1122 -519 -487 -1138 -787 -1845 -895 -164 -25 -204 -27 -484 -27 -325 -1 -422 7 -685 60 -1170 231 -2155 1089 -2543 2214 -222 647 -250 1318 -82 1975 283 1104 1112 1999 2195 2372 215 74 531 144 735 162 63 6 133 13 155 15 85 9 506 -4 625 -18z"></path>
                          <path d="M3960 5620 c0 -654 -3 -1010 -10 -1010 -5 0 -41 -30 -80 -66 -51 -49 -80 -86 -105 -138 -133 -272 18 -605 310 -681 132 -34 277 -11 391 63 202 131 276 400 169 618 -25 52 -54 89 -105 138 -39 36 -75 66 -80 66 -7 0 -10 356 -10 1010 l0 1010 -240 0 -240 0 0 -1010z"></path>
                        </g>
                      </svg>
                      <span className="font-[480] text-sm text-text_color_primary1">
                        4s
                      </span>
                    </div>
                    <div className="col-span-2 md:col-span-1 flex flex-row items-center justify-center">
                      <div className="opacity-50 cursor-not-allowed">
                        {/* Stairs Icon */}
                        <svg
                          height="18"
                          width="18"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g>
                            <path
                              d="M5.21875 3.13672V13.1367"
                              stroke="var(--icon-color-brand-tertiary1)"
                            ></path>
                            <path
                              d="M5.21875 5.48047H10.5312"
                              stroke="var(--icon-color-brand-tertiary1)"
                            ></path>
                            <path
                              d="M5.21875 8.13672H10.5312"
                              stroke="var(--icon-color-brand-tertiary1)"
                            ></path>
                            <path
                              d="M5.21875 11.1055H10.5312"
                              stroke="var(--icon-color-brand-tertiary1)"
                            ></path>
                            <path
                              d="M10.5312 3.13672V13.1367"
                              stroke="var(--icon-color-brand-tertiary1)"
                            ></path>
                          </g>
                        </svg>
                      </div>
                    </div>
                  </div>

                  {/* Odds or Status */}
                  <div className="col-span-5 md:col-span-6 h-12 relative flex">
                    {fancy.game_status === "Ball Running" ||
                      fancy.game_status === "SUSPENDED" ? (
                      <span className="flex-1 text-center min-h-12 py-[1px] px-[1px] flex items-center justify-center w-full h-full">
                        <span
                          className={`text-center w-full h-full rounded-sm flex text-xs flex-col items-center justify-center ${fancy.game_status === "Ball Running"
                            ? "bg-bg_color_ballRunning text-text_color_primary1"
                            : "bg-bg_color_suspended text-color-suspendedFontColor"
                            }`}
                          style={{ cursor: "not-allowed" }}
                        >
                          {fancy.game_status === "Ball Running"
                            ? "Ball Running"
                            : "Suspended"}
                        </span>
                      </span>
                    ) : (
                      <>
                        <div className="flex flex-1 grid grid-cols-2 gap-x-0.5 py-[1px] pr-[2px]">
                          {/* BACK */}
                          <div className="w-full h-full">
                            <div
                              className="overflow-hidden relative w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_backBtnBg text-text_color_oddValue"
                              style={{
                                cursor:
                                  fancy.back_price1 > 0
                                    ? "pointer"
                                    : "not-allowed",
                              }}
                              onClick={() => {
                                if (fancy.back_price1 > 0) {
                                  handleOpenBetSlip(
                                    fancy.match_id,
                                    "",
                                    true,
                                    `fancy_back_size_${fancy.selection_id}`,
                                    true,
                                    fancy.selection_id,
                                    fancy.runner_name,
                                    `fancy_back_price_${fancy.selection_id}`,
                                    false,
                                    "",
                                  );
                                }
                              }}
                            >
                              <span
                                id={`fancy_back_price_${fancy.selection_id}`}
                                style={{ fontWeight: 600 }}
                              >
                                {fancy.back_price1}
                              </span>
                              <span
                                id={`fancy_back_size_${fancy.selection_id}`}
                                style={{ fontSize: "10px", marginLeft: 0 }}
                              >
                                {fancy.back_size1}
                              </span>
                            </div>
                          </div>
                          {/* LAY */}
                          <div className="w-full h-full">
                            <div
                              className="overflow-hidden relative w-full h-full px-1 py-[1px] rounded-sm flex flex-col items-center justify-center bg-bg_color_layBtnBg text-text_color_oddValue"
                              style={{
                                cursor:
                                  fancy.lay_price1 > 0
                                    ? "pointer"
                                    : "not-allowed",
                              }}
                              onClick={() => {
                                if (fancy.lay_price1 > 0) {
                                  handleOpenBetSlip(
                                    fancy.match_id,
                                    "",
                                    false,
                                    `fancy_lay_size_${fancy.selection_id}`,
                                    true,
                                    fancy.selection_id,
                                    fancy.runner_name,
                                    `fancy_lay_price_${fancy.selection_id}`,
                                    false,
                                    "",
                                  );
                                }
                              }}
                            >
                              <span
                                id={`fancy_lay_price_${fancy.selection_id}`}
                                style={{ fontWeight: 600 }}
                              >
                                {fancy.lay_price1}
                              </span>
                              <span
                                id={`fancy_lay_size_${fancy.selection_id}`}
                                style={{ fontSize: "10px", marginLeft: 0 }}
                              >
                                {fancy.lay_size1}
                              </span>
                            </div>
                          </div>
                        </div>

                        <span className="hidden md:flex md:flex-col md:justify-center md:items-center md:ml-1 text-center min-h-12 px-1 text-text_color_tertiary2 text-[10px]">
                          <div className="flex items-center justify-center">
                            <span>Max Bet :</span>&nbsp;
                            <span>{fancy.max_bet || "2,25,000"}</span>
                          </div>
                          <div className="flex items-center justify-center">
                            <span>Max Mkt :</span>&nbsp;
                            <span>{fancy.max_market || "20,00,000"}</span>
                          </div>
                        </span>
                      </>
                    )}
                  </div>
                </div>
              ))}

              {showPlaceBetPopup && (
                <div className="modal-overlay" onClick={handleClosePlaceBet}>
                  <div
                    className="modal-content"
                    onClick={(e) => e.stopPropagation()} // Prevents closing when clicking inside the modal content
                  >
                    <PlaceBet
                      type={type}
                      BetPlaceData={BetPlaceData}
                      placeStakeValue={placeStakeValue}
                      StakeValue={StakeValue}
                      chips={chips}
                      placing={placing}
                      betPlace={betPlace}
                      handleClosePlaceBet={handleClosePlaceBet}
                      setShowBetsSlip={setShowBetsSlip}
                      setSelection_id={setSelection_id}
                      setHtmlId={setHtmlId}
                    />
                  </div>
                </div>
              )}

              {showSuccessPopup && (
                <PlaceBetSuccessfull
                  message="Bet placed successfully!"
                  onClose={() => setShowSuccessPopup(false)} // Close the success popup
                />
              )}

              <Empty />

              {/* <Footer /> */}
            </div>

            <div style={{ width: "30%" }}>
              <OpenBets isMobile={isMobile} />
            </div>
          </div>
        )}
      </div>

      {showRateZeroPopup && (
        <div
          className="modal-overlay"
          onClick={() => setShowRateZeroPopup(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            padding: "1rem",
          }}
        >
          <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "#fff",
              borderRadius: "8px",
              maxWidth: "90%",
              width: "400px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            }}
          >
            <div style={{ padding: "24px", textAlign: "center" }}>
              <h3 style={{ marginBottom: "16px", color: "#c13333" }}>
                Bet Not Allowed
              </h3>
              <p>Bet is not allowed when rate is 0</p>
              <button
                style={{
                  marginTop: "20px",
                  padding: "8px 24px",
                  background: "#c13333",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
                onClick={() => setShowRateZeroPopup(false)}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MatchUpdates;
